export default {
  "brandSeo": {
    "pageTitle": "Miral AIで使える{title}",
    "toolDescription": "Miral AIで、{description}",
    "sectionTitle": "Miral AIで実現する{title}",
    "faqTitle": "Miral AIの{title}",
    "toolFreeTrialCta": "Miral AIでこのツールを無料体験",
    "toolProcessCta": "{action}を無料で試す",
    "imageFaqs": [
      { "q": "MiralでAI画像生成を無料体験できますか？", "a": "はい。Miral AIに登録すると無料クレジットを受け取り、画像生成を試せます。生成ごとに選択したモデル所定のクレジットを使用します。" },
      { "q": "Miral AIで画像を生成するメリットは？", "a": "Miral AIは主要な画像モデルを一つの場所に集約し、複数サービスを切り替えずに機能を比較して制作を続けられます。" }
    ],
    "toolFaqs": [
      { "q": "このMiral AIツールは無料体験できますか？", "a": "はい。Miral AIにログインすると無料体験を始められます。利用可能回数はアカウント条件により異なり、無制限の永久無料ではありません。" },
      { "q": "Miral AIの制作ツールを使う理由は？", "a": "画像生成と実用的な編集ツールを一つのプラットフォームにまとめ、制作、処理、ダウンロードまで一つの流れで行えます。" }
    ]
  },
  "common": {
    "loading": "読み込み中...",
    "error": "エラーが発生しました",
    "success": "成功",
    "confirm": "確定",
    "prev": "前へ",
    "next": "次へ",
    "optional": "オプション",
    "remove": "削除",
    "generate": "生成",
    "generating": "生成中...",
    "required": "必須",
    "generateFailedContactSupport": "生成に失敗しました。再試行するか、サポートにお問い合わせください。",
    "localMediaTransferFailed": "ネットワークの変動によりサービスの転送・連携に異常が発生し、生成が中断されました。再度生成するか、サポートにお問い合わせください。",
    "errorDetails": "エラー詳細",
    "tryAgainOrContactSupportTail": " もう一度お試しください。またはサポートにお問い合わせください！",
    "errorCategoryImageSizeInvalid": "画像サイズが要件を満たしていません。有効な画像を使用してください",
    "errorCategoryOutputEmptyOrSensitive": "出力が安全ルールによりブロックされたか、結果が生成されませんでした。プロンプト/参照画像を調整してください",
    "errorCategoryUpstreamBusy": "サービスがただいま混み合っています（上流の負荷が飽和）",
    "errorCategoryAiNetworkError": "ネットワーク接続が不安定です。接続を確認して再試行してください",
    "errorCategoryAiTimeout": "AIリクエストがタイムアウトしました。ネットワークが不安定な可能性があります。しばらくしてから再試行してください",
    "close": "閉じる",
    "leaveConfirmTitle": "お知らせ",
    "leaveConfirmMessage": "現在 AI 作品を生成中です。ページを切り替えても生成進行には影響しません。[マイ - マイ作品] で処理中または完了済みの作品を確認できます。\nこのままページを離れますか？",
    "leaveConfirmConfirm": "離れる",
    "leaveConfirmCancel": "このまま見る"
  },
  "api": {
    "errors": {
      "requestFailed": "リクエストに失敗しました",
      "badRequest": "不正なリクエスト",
      "unauthorized": "認証されていません。再度ログインしてください",
      "forbidden": "アクセスが拒否されました",
      "notFound": "リソースが見つかりません",
      "serverError": "サーバー内部エラー",
      "timeout": "リクエストがタイムアウトしました。再度お試しください",
      "networkError": "ネットワークエラー。接続を確認してください",
      "sessionExpired": "セッションが期限切れです。再度ログインしてください",
      "operationFailed": "操作に失敗しました！"
    }
  },
  "nav": {
    "home": "ホーム",
    "models": "AIモデル",
    "pricing": "料金",
    "faq": "よくある質問",
    "login": "ログイン",
    "signup": "アップグレード",
    "register": "新規登録",
    "email": "メールアドレス",
    "logout": "ログアウト",
    "help": "ヘルプ",
    "profile": "プロフィール",
    "myWorks": "マイ作品",
    "username": "ユーザー名",
    "password": "パスワード",
    "confirmPassword": "パスワード確認",
    "processing": "処理中...",
    "haveAccount": "アカウントをお持ちですか？",
    "noAccount": "アカウントをお持ちでないですか？",
    "orContinueWith": "または以下で続行",
    "loginFailed": "ログインに失敗しました。再度お試しください",
    "registerFailed": "登録に失敗しました。再度お試しください",
    "fillRequired": "すべての必須項目を入力してください",
    "passwordMismatch": "パスワードが一致しません",
    "passwordTooShort": "パスワードは6文字以上必要です",
    "googleNotLoaded": "Googleログインサービスが読み込まれていません。ページを更新してください",
    "googleInitFailed": "Googleログインの初期化に失敗しました",
    "googleUserInfoFailed": "ユーザー情報を取得できません",
    "googleCancelled": "Googleログインがキャンセルされました",
    "codeLoginHint": "メールアドレスを入力すると、確認コードをお送りします",
    "verificationCode": "確認コード",
    "sendCode": "コードを送信",
    "resendCode": "再送信",
    "verifyAndLogin": "確認してログイン",
    "enterEmail": "メールアドレスを入力してください",
    "invalidEmail": "有効なメールアドレスを入力してください",
    "sendCodeFailed": "確認コードの送信に失敗しました。再度お試しください",
    "checkSpamFolder": "メールが見つかりませんか？迷惑メールフォルダをご確認ください",
    "enterValidCode": "6桁の確認コードを入力してください",
    "verifyCodeFailed": "確認コードが無効または期限切れです",
    "googleLoginFailed": "Googleログインに失敗しました。再度お試しください",
    "registerHint": "登録することで、",
    "and": "と",
    "freeCreditsLabel": "無料クレジット：",
    "freeCreditsDesc": "ログインするだけで無料クレジットを取得 — 支払い不要！",
    "sidebar": {
      "navigation": "ナビゲーション",
      "home": "ホーム",
      "inspiration": "インスピレーション",
      "history": "履歴",
      "allModels": "すべてのAIモデル",
      "videoAI": "動画AI",
      "videoGenerator": "動画ジェネレーター",
      "newModels": "新着モデル",
      "otherModels": "その他のモデル",
      "videoEnhance": "動画強化",
      "musicAI": "AI音楽",
      "musicGenerator": "AI音楽",
      "imageAI": "画像AI",
      "imageGenerator": "画像ジェネレーター",
      "hotModels": "人気モデル",
      "hotTools": "人気ツール",
      "upgrade": "アップグレード"
    }
  },
  "footer": {
    "brand": "Miral",
    "siteTitle": "Miral - AI画像・動画・音楽作成プラットフォーム",
    "desc": "画像、動画、音楽制作を一体化したオールインワンAIプラットフォーム。",
    "fluxModels": "FLUXモデル",
    "aiImages": "AI画像",
    "aiVideos": "AI動画",
    "aiMusic": "AI音楽",
    "product": "製品",
    "videoModels": "AI動画モデル",
    "imageModels": "AI画像モデル",
    "musicModels": "AI音楽モデル",
    "apps": "アプリ",
    "company": "会社",
    "about": "会社概要",
    "contact": "お問い合わせ",
    "blog": "ブログ",
    "tools": "ツール",
    "resources": "リソース",
    "allModels": "すべてのAIモデル",
    "pricing": "料金",
    "trustSafety": "信頼と安全",
    "terms": "利用規約",
    "privacy": "プライバシーポリシー",
    "faq": "よくある質問",
    "musicGenerator": "AI音楽ジェネレーター",
    "copyright": "© 2025 Miral. All rights reserved.",
    "langZh": "简体中文",
    "langEn": "English"
  },
  "about": {
    "tag": "Miralについて",
    "title": "会社概要",
    "subtitle": "画像・動画・音楽をひとつのAIプラットフォームで。",
    "paragraphs": [
      "Miralは、クリエイター・デザイナー・企業向けのAI創作プラットフォームです。画像生成、動画生成、AI音楽、透かし除去や文書処理ツールを提供します。",
      "ブラウザ上でアイデアから完成まで進められるよう、主要モデルと安定した経路を継続的に拡充しています。",
      "データ取り扱いについては信頼と安全ページをご覧ください。ご質問はサポートまでご連絡ください。"
    ]
  },
  "contact": {
    "tag": "サポート",
    "title": "お問い合わせ",
    "subtitle": "ご質問やフィードバックにお答えします。",
    "emailLabel": "サポートメール",
    "hint": "請求、クレジット、生成に関するご質問をメールでお送りください。通常、営業日にお返事します。",
    "cta": "メールを送る"
  },
  "models": {
    "image": {
      "nano-banana": {
        "name": "Nano Banana Pro",
        "desc": "シネマ級の写実表現。肌質・質感・光のディテールまで自然に再現"
      },
      "nano-banana-31": {
        "name": "Nano Banana 3.1",
        "desc": "マルチ解像度画像生成、v2.5とv3.1モード対応"
      },
      "seedream-4": {
        "name": "Seedream 4",
        "desc": "アートスタイル"
      },
      "seedream-5": {
        "name": "Seedream 5",
        "desc": "アートスタイル"
      },
      "midjourney": {
        "name": "Midjourney",
        "desc": "アートスタイル"
      },
      "gpt-image-1": {
        "name": "GPT-Image-1",
        "desc": "マルチパーパス"
      },
      "gpt-image-1-5": {
        "name": "GPT-Image-1-5",
        "desc": "マルチパーパス"
      },
      "flux-pro-1-1-ultra": {
        "name": "Flux Pro 1.1 Ultra",
        "desc": "高品質テキストから画像"
      },
      "flux-schnell": {
        "name": "Flux Schnell",
        "desc": "高速テキストから画像"
      },
      "flux-2": {
        "name": "FLUX.2",
        "desc": "次世代テキストから画像"
      },
      "flux-kontext": {
        "name": "Flux Kontext",
        "desc": "高品質テキストから画像・編集"
      },
      "qwen-image-2-0-pro": {
        "name": "Qwen Image 2.0 Pro",
        "desc": "高解像度の画像生成と精細化"
      },
      "z-image-turbo": {
        "name": "Z Image Turbo",
        "desc": "高解像度テキストから画像"
      },
      "sd-3-5": {
        "name": "Stable Diffusion 3.5",
        "desc": "Stable Diffusion 3.5のテキスト画像生成"
      }
    },
    "video": {
      "pollodance": {
        "name": "Pollo Dance",
        "desc": "モーション制御・参照・シネマティック"
      },
      "seegen": {
        "name": "SeeGen",
        "desc": "テキスト・画像から動画、マルチ解像度"
      },
      "seedance": {
        "name": "Seedance AI",
        "desc": "ネイティブ音声同期"
      },
      "wan-2-5": {
        "name": "Wan 2.5",
        "desc": "アニメーションスタイル"
      },
      "wan-2-6": {
        "name": "Wan 2.6",
        "desc": "高画質強化"
      },
      "veo-3-1": {
        "name": "Veo 3.1",
        "desc": "複数画像参照"
      },
      "veo-3-1-fast": {
        "name": "Veo 3.1 Fast",
        "desc": "高速、テールフレーム対応"
      },
      "kling-2-6": {
        "name": "Kling 2.6",
        "desc": "リップシンク"
      },
      "kling-3": {
        "name": "Kling 3",
        "desc": "リップシンク"
      },
      "sora-2": {
        "name": "Sora 2",
        "desc": "4秒 / 8秒 / 12秒"
      },
      "kling-2-5": {
        "name": "Kling 2.5",
        "desc": "スタンダード"
      },
      "wan-2-2": {
        "name": "Wan 2.2",
        "desc": "クラシック"
      },
      "vidu-q3-pro": {
        "name": "Vidu Q3 Pro",
        "desc": "テキスト/画像から動画、複数解像度"
      },
      "veo-3-0": {
        "name": "Veo 3.0",
        "desc": "テキスト/画像から動画"
      },
      "hailuo-2-3": {
        "name": "Hailuo 2.3",
        "desc": "クリエイティブ動画"
      },
      "runway": {
        "name": "Runway",
        "desc": "ワークベンチ"
      },
      "wan-animate": {
        "name": "Wan Animate",
        "desc": "AIモーション転送とアイデンティティ置換を融合した高品質キャラクターアニメモデル"
      }
    }
  },
  "tools": {
    "demoTitle": "デモ",
    "page": {
      "tag": "AIツールボックス",
      "title": "プロフェッショナルAIツールボックス",
      "subtitle": "透かし除去、写真復元、HDアップスケーリング、動画強化など、あらゆる後処理ニーズに対応するプロフェッショナルツール。",
      "allTools": "すべてのツール"
    },
    "detail": {
      "useNow": "今すぐ使用",
      "clickUpload": "クリックまたはドラッグしてアップロード",
      "support": "対応形式",
      "reupload": "再アップロード",
      "scale": "拡大倍率",
      "process": "処理開始",
      "processing": "処理中...",
      "before": "処理前",
      "after": "処理後",
      "download": "結果をダウンロード",
      "processNew": "新しいファイルを処理",
      "howToUse": "使い方",
      "moreTools": "その他のツール",
      "notFound": "ツールが見つかりません",
      "backToList": "ツール一覧に戻る",
      "loginRequired": "ログインが必要です",
      "loginRequiredDesc": "このツールを使用するにはログインしてください",
      "loginNow": "今すぐログイン",
      "demo": "デモ",
      "uploadOriginalFailed": "元の画像のアップロードに失敗しました。もう一度お試しください"
    },
    "steps": {
      "upload": {
        "title": "ファイルをアップロード",
        "desc": "処理したい画像または動画ファイルを選択またはドラッグ＆ドロップ。"
      },
      "adjust": {
        "title": "設定を調整",
        "desc": "拡大倍率や出力形式などの処理パラメータを設定。"
      },
      "process": {
        "title": "ワンクリック処理",
        "desc": "AIが自動的に処理。通常数秒から数分で完了。"
      },
      "download": {
        "title": "結果をダウンロード",
        "desc": "結果をプレビューし、高品質の出力をダウンロード。"
      }
    },
    "fileTypes": {
      "image": "画像",
      "video": "動画"
    },
    "watermarkRemover": {
      "name": "透かし除去",
      "desc": "AIで画像の透かしをワンクリック除去",
      "fullDesc": "AIによる透かし除去で画質を維持。バッチ処理、自動透かし検出、元画像を損なわない精密な除去に対応。"
    },
    "backgroundRemover": {
      "name": "背景除去",
      "desc": "AIで画像背景をワンクリック除去",
      "fullDesc": "AIワンクリックで背景を除去。被写体の輪郭を正確に検出し、髪の毛などの細部を保持、透明背景画像で出力。"
    },

    "photoRestore": {
      "name": "写真復元",
      "desc": "AI技術で古い、ぼやけた、または損傷した写真を復元",
      "fullDesc": "AI技術で古い、ぼやけた、または損傷した写真を復元。ノイズ除去、シャープ化、欠損部分の補完に対応し、大切な思い出を蘇らせます。"
    },
    "imageEnhancer": {
      "name": "画像強化",
      "desc": "AIで画像の鮮明度をワンクリック向上",
      "fullDesc": "画像を4K解像度にアップスケーリングし、詳細を強化。高度なAIアルゴリズムで詳細を強化し、ぼやけた画像をシャープに。"
    },
    "videoEnhancer": {
      "name": "動画強化",
      "desc": "動画を4K解像度にアップスケーリングし、鮮明さを強化",
      "fullDesc": "動画を4K解像度にアップスケーリングし、鮮明さを強化。複数の動画形式に対応し、AIによるフレーム補間で驚くべきHD品質を実現。"
    },
    "watermark-remover": {
      "name": "透かし除去",
      "desc": "AIによる透かし除去で画質を維持",
      "fullDesc": "AIによる透かし除去で画質を維持。バッチ処理、自動透かし検出、元画像を損なわない精密な除去に対応。",
      "fileTooLarge": "画像が大きすぎます。 15MB以下のファイル（JPG、PNG、WebP）をご利用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "noImageInResponse": "結果画像が返されませんでした。後でもう一度試してください。",
      "downloadName": "watermark-removed.png",
      "aiRepair": "ウォーターマークの除去",
      "uploadLabel": "画像をアップロードする",
      "uploadHint": "最大 15MB の JPG、PNG、または WebP 画像をサポートします。",
      "featuresKicker": "速くて正確",
      "featuresTitle": "オンラインの写真からさまざまな透かしを削除",
      "featuresIntro": "JPG、PNG、または WebP 画像をアップロードすると、AI が透かし領域を検出し、手動でブラッシングすることなく背景を再構築します。",
      "features": [
        {
          "title": "全画像透かしをクリア",
          "desc": "よりきれいな結果を得るには、画像全体を覆う繰り返しの半透明のテキストまたはパターンの透かしを削除します。",
          "cta": "AIウォーターマークリムーバーを無料でお試しください"
        },
        {
          "title": "タイムスタンプと日付マークを削除する",
          "desc": "写真の隅から日付、タイムスタンプ、カメラマークを削除し、その背後にある背景を再構築します。",
          "cta": "オンラインで画像の透かしを消去"
        },
        {
          "title": "ブランドロゴを消去",
          "desc": "編集権限のある画像からブランド ロゴ、コーナー バッジ、プロモーション マークを削除します。",
          "cta": "写真の透かしを今すぐ削除"
        },
        {
          "title": "クリーンテキストと下書きマーク",
          "desc": "プレビュー、デザインドラフト、写真からテキストオーバーレイを削除して、よりクリーンなビジュアルコンテンツを作成します。",
          "cta": "今すぐウォーターマーク除去ツールを試してください"
        }
      ],
      "useCasesKicker": "ユースケース",
      "useCasesTitle": "AI 画像透かし除去ツールは何を除去できますか?",
      "audienceLabels": [
        "eコマース販売者",
        "マーケティングチーム",
        "デザイナー＆クリエイター",
        "ファッション・アパレル店"
      ],
      "audienceCases": [
        {
          "title": "製品ビジュアルを 3 倍早く準備",
          "desc": "洗練された製品リスト画像を作成する前に、まず認定製品の写真、サプライヤーの画像、または下書きアセットをクリーンアップします。買い物客が商品に集中できるように、邪魔なマークを削除します。"
        },
        {
          "title": "手動クリーンアップを 60% 削減し、キャンペーン アセットをより迅速に作成",
          "desc": "所有またはライセンスされたビジュアルを広告、バナー、ブランド グラフィックに変換する前に、不要な透かしを削除してください。クリーンなアセットは、キャンペーン プロモーション、製品発売、製品ポスターに迅速に移行できます。"
        },
        {
          "title": "きれいな画像を新鮮な創造的なコンセプトに迅速に変換します",
          "desc": "よりクリーンなソース イメージから始めて、最初から再構築することなく新しいデザインの方向性を模索します。きれいになったドラフトを AI スケッチ、コンセプト アート、またはポスター スタイルのビジュアルの参照として使用します。"
        },
        {
          "title": "再撮影せずに製品カタログ画像を更新",
          "desc": "カタログの更新、季節限定の発売、または AI 仮想試着ビジュアルを準備する前に、買い物客がフィット感、生地、製品の詳細に集中できるように、認定されたアパレルの写真をクリーンアップします。"
        }
      ],
      "useCases": [
        {
          "title": "製品写真の透かし除去",
          "desc": "自分のアセットを再レイアウトする前に、製品写真からテキスト、ロゴ、宣伝マークを削除します。"
        },
        {
          "title": "ソーシャル写真の透かし除去",
          "desc": "自分の写真からプラットフォーム マークやタイムスタンプを削除して、よりクリーンな公開バージョンを実現します。"
        },
        {
          "title": "複数のウォーターマークを消去する",
          "desc": "1 つの画像に複数の透かしが含まれている場合、AI は複数の覆われた領域を検出してクリーニングできます。"
        }
      ],
      "howToKicker": "3 つの簡単なステップ",
      "howToTitle": "オンラインで画像から透かしを無料で削除する方法",
      "howToIntro": "ソフトウェアのインストールは必要ありません。画像をアップロードし、AI ウォーターマーク除去ツールを実行して、きれいになった結果をダウンロードします。",
      "howToCta": "今すぐオンラインで透かしを削除",
      "steps": {
        "upload": {
          "title": "透かし入りの画像をアップロードする",
          "desc": "15MB 未満の JPG、PNG、または WebP 画像を選択します。編集して使用する権利があることを確認してください。"
        },
        "remove": {
          "title": "AIで透かしを除去",
          "desc": "処理を開始すると、AI がロゴ、テキスト、タイムスタンプ、または画像全体の透かしを検出し、背景を再構築します。"
        },
        "download": {
          "title": "プレビューとダウンロード",
          "desc": "前後の結果を比較し、きれいになったイメージをダウンロードするか、別のイメージをアップロードします。"
        }
      },
      "faqTitle": "AI ウォーターマーク除去ツールに関するよくある質問",
      "faqs": [
        {
          "q": "AIウォーターマークリムーバーとは何ですか?",
          "a": "AI 透かし除去機能は透かし領域を検出し、近くの色、テクスチャ、画像コンテンツを使用して覆われた背景を再構築します。"
        },
        {
          "q": "オンラインで写真から透かしを無料で削除するにはどうすればよいですか?",
          "a": "サインアップして、Miral AI ウォーターマーク除去ツールに画像をアップロードし、処理を開始して、きれいになった結果をプレビューします。"
        },
        {
          "q": "どの画像形式がサポートされていますか?",
          "a": "このツールは現在、15 MB 未満の JPG、PNG、および WebP 画像をサポートしています。このページではビデオからウォーターマークは削除されません。"
        },
        {
          "q": "画像全体の透かし、ロゴ、タイムスタンプを削除できますか?",
          "a": "はい。 AI は、繰り返し表示される画像全体の透かし、ブランド ロゴ、日付スタンプ、テキスト、下書きマークを処理できます。結果は、不透明度、覆われた領域、背景の複雑さによって異なります。"
        },
        {
          "q": "1 枚の写真から複数のロゴやタイムスタンプを削除するにはどのツールを使用できますか?",
          "a": "Miral AI ウォーターマーク リムーバーは、ロゴやタイムスタンプを含む複数のウォーターマーク領域を処理できます。大きなマークが人物や複雑なテクスチャを覆っている場合は、プレビューを確認してください。"
        },
        {
          "q": "画像から透かしを削除することは合法ですか?",
          "a": "自分が所有している画像、編集を許可されている画像、または合法的に使用できる画像のみを処理してください。著作権ウォーターマークを許可なく削除すると、所有者の権利を侵害する可能性があります。"
        },
        {
          "q": "透かしを削除した後にぼやけた領域を修正するにはどうすればよいですか?",
          "a": "入手可能な最高品質のソース画像から始めて、ダウンロードする前にプレビューを確認してください。 AI は元の構成、解像度、詳細を維持しようとしますが、大きな透かしによって隠されたコンテンツは再構築する必要があるため、局所的な結果は元のものと異なる場合があります。"
        }
      ]
    },
    "full-watermark-remover": {
      "name": "AI透かし除去",
      "desc": "AIで画像内の透かしを除去します",
      "fullDesc": "AIで画像内の透かしを検出して除去し、元画像の内容、細部、品質を保ちます。",
      "audienceLabels": ["EC販売者", "マーケティングチーム", "デザイナー・クリエイター", "ファッション・アパレル店舗"],
      "audienceCases": [
        { "title": "商品ビジュアルの準備を3倍高速化", "desc": "洗練された商品一覧画像を作る前に、使用許可を得た商品写真、仕入先画像、下書き素材を整理します。不要なマークを除去し、購入者が商品そのものに集中できる画像に仕上げます。" },
        { "title": "手作業のクリーニングを60%削減し、販促素材をすばやく制作", "desc": "自社または使用許可済みの素材を広告、バナー、ブランド画像に展開する前に、不要な透かしを除去します。クリーンな素材をキャンペーン、新商品発表、商品ポスターへすばやく活用できます。" },
        { "title": "クリーンな画像から新しいアイデアをすばやく展開", "desc": "一から作り直すことなく、整理された元画像から新しいデザイン方向を検討できます。透かし除去後の下書きをAIスケッチ、コンセプトアート、ポスター風ビジュアルの参考にできます。" },
        { "title": "再撮影せずに商品カタログ画像を刷新", "desc": "カタログ更新、季節商品の投入、AIバーチャル試着用の画像を作る前に、使用許可済みのアパレル写真を整理し、購入者がシルエット、生地、商品ディテールに注目できるようにします。" }
      ],
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "全画面透かし除去結果.png"
    },
    "ai-text-remover": {
      "name": "AI文字除去",
      "desc": "AIで画像内の不要な文字を除去します",
      "fullDesc": "AIで画像内の不要な文字を除去し、背景、質感、自然な細部をできるだけ保ちます。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "文字除去結果.png"
    },
    "ai-logo-remover": {
      "name": "AIロゴ除去",
      "desc": "AIで画像内の不要なロゴを除去します",
      "fullDesc": "AIで画像内の不要なロゴを除去し、背景、質感、自然な細部をできるだけ保ちます。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "ロゴ除去結果.png"
    },
    "ai-passersby-remover": {
      "name": "AI通行人除去",
      "desc": "AIで画像内の通行人を除去します",
      "fullDesc": "AIで画像内の通行人を検出して除去し、被写体、背景の質感、自然な画像の細部を保ちます。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "通行人除去結果.png"
    },
    "background-remover": {
      "name": "背景除去",
      "desc": "AIワンクリックで背景を除去、被写体を保持",
      "heroTitle": "無料AI背景除去で透明PNGをワンクリック作成",
      "fullDesc": "JPG、PNG、WebP画像をアップロードするだけで、AIが人物や商品、被写体の輪郭を自動検出。髪の毛などの細部を保ちながら、Photoshop不要で透明PNGを作成できます。",
      "uploadLabel": "背景を削除する画像をアップロード",
      "uploadHint": "クリックまたはドラッグして画像をアップロード",
      "uploadSpec": "15MB以下のJPG、PNG、WebPに対応。結果は透明PNGでダウンロードできます。",
      "processButton": "画像の背景を削除",
      "previewAlt": "AI背景除去前の画像プレビュー",
      "demoBeforeAlt": "背景除去前の人物写真",
      "demoAfterAlt": "AIで背景を除去した人物写真",
      "processingAlt": "AIが画像の背景を削除中",
      "processingLabel": "切り抜き処理中",
      "resultLabel": "透明背景の準備完了",
      "resultBeforeAlt": "背景除去前の元画像",
      "resultAfterAlt": "AI背景除去後の透明PNG",
      "productBeforeAlt": "背景除去前の商品写真",
      "productAfterAlt": "透明背景にした商品PNG",
      "featuresKicker": "高精度な被写体検出",
      "featuresTitle": "人物・商品写真向けオンラインAI背景除去ツール",
      "featuresIntro": "複雑な人物の輪郭からEC商品画像まで、ブラシやパス、マスク操作なしでAIが被写体と背景を自動分離します。",
      "features": [
        { "title": "髪の毛を保ちながら人物背景を削除", "desc": "人物、服、細かな髪の毛の輪郭を検出し、プロフィール写真、証明写真素材、ポスター、SNS画像を自然に切り抜きます。", "cta": "人物背景を無料で削除" },
        { "title": "商品写真をワンクリックで切り抜き", "desc": "机や壁、撮影背景を削除し、白背景の商品画像、商品ページ、広告デザインに使える透明素材を作成します。", "cta": "商品背景をオンラインで削除" },
        { "title": "透明背景PNGをダウンロード", "desc": "透明チャンネルを維持したまま、新しい背景、バナー、資料、サムネイル、デザインにすぐ利用できます。", "cta": "背景を透明にする" }
      ],
      "featureAlts": { "portraitBefore": "人物写真の背景除去前", "portraitAfter": "髪の毛を保った人物切り抜き", "productBefore": "商品写真の背景除去前", "productAfter": "透明背景の商品切り抜き", "ecommerceBefore": "EC商品画像の背景除去前", "ecommerceAfter": "EC商品用の透明PNG" },
      "useCasesKicker": "主な使用例",
      "useCasesTitle": "AIワンクリック切り抜きに適した画像",
      "useCasesIntro": "独立した被写体や透明画像素材が必要な、日常の制作や商用デザインに利用できます。",
      "useCases": [
        { "title": "EC商品画像", "desc": "カタログ、ショップ、広告向けの透明な商品素材を作成。" },
        { "title": "人物・プロフィール写真", "desc": "髪や服の輪郭を保ちながら不要な背景を削除。" },
        { "title": "SNSデザイン", "desc": "人物や商品をカバー、投稿、サムネイルに配置。" },
        { "title": "証明写真・ビジネス写真", "desc": "人物を切り抜き、デザインツールで必要な単色背景を追加。" },
        { "title": "ロゴ・グラフィック素材", "desc": "不要な背景色を削除してWebやポスターで再利用。" },
        { "title": "広告・グラフィック制作", "desc": "自由に配置できる透明PNGをすばやく準備。" }
      ],
      "howToKicker": "簡単3ステップ",
      "howToTitle": "オンラインで画像背景を無料削除する方法",
      "howToIntro": "画像をアップロードし、AI自動切り抜きを実行して透明PNGをダウンロードします。",
      "steps": [
        { "title": "JPG・PNG・WebPをアップロード", "desc": "15MB以下の鮮明な人物、商品、デザイン画像を選択します。" },
        { "title": "AIが背景を自動削除", "desc": "AIが被写体を分離し、重要な輪郭を保ちながら背景を削除します。" },
        { "title": "透明PNGを確認して保存", "desc": "前後を比較し、透明画像をダウンロードします。" }
      ],
      "faqTitle": "AI背景除去のよくある質問",
      "faqs": [
        { "q": "画像の背景をオンラインで無料削除するには？", "a": "JPG、PNG、WebPをアップロードして背景除去を開始します。AIが被写体を検出し、透明PNGを作成します。" },
        { "q": "髪の毛や細かな輪郭も残せますか？", "a": "AIは髪、服、細かな輪郭の保持を試みます。被写体と背景の差が明確な画像ほど自然な結果になります。" },
        { "q": "商品写真の背景も削除できますか？", "a": "はい。被写体が明確な商品写真は、ECや広告用の透明素材作成に適しています。" },
        { "q": "処理後のファイル形式は？", "a": "透明チャンネルを持つPNG形式でダウンロードできます。" },
        { "q": "対応形式とファイルサイズは？", "a": "15MB以下のJPG、PNG、WebP画像に対応しています。" },
        { "q": "Photoshopのインストールは必要ですか？", "a": "不要です。ブラウザ上でAIが背景を自動削除します。" }
      ],
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "noImageInResponse": "結果画像を取得できませんでした。しばらくしてから再試行してください。",
      "downloadName": "背景除去結果.png"
    },
    "image-eraser": {
      "name": "画像消しゴム",
      "desc": "AIで画像内の不要な物体、人物、透かしを消去",
      "fullDesc": "AI搭載の画像消しゴム。写真内の不要な物体、人物、透かし、テキストをブラシでなぞるだけで、AIがシームレスに消去し自然な内容で塗りつぶします。写真の整理や邪魔な要素の除去に最適。",
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "noImageInResponse": "結果画像を取得できませんでした。しばらくしてから再試行してください。",
      "downloadName": "image-erased.png"
    },
    "object-remover": {
      "name": "オブジェクト削除",
      "desc": "AIで写真内の不要なオブジェクトを削除",
      "fullDesc": "AI搭載のオブジェクト削除ツール。写真内の不要なオブジェクトをブラシでなぞるだけで、AIがシームレスに消去し自然な内容で塗りつぶします。写真の整理や邪魔な要素の除去に最適。",
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "noImageInResponse": "結果画像を取得できませんでした。しばらくしてから再試行してください。",
      "downloadName": "object-removed.png",
      "uploadLabel": "画像をアップロードする",
      "uploadHint": "クリックまたはドラッグして画像をアップロードします",
      "uploadSpec": "JPG、PNG、または WebP 画像をサポートします。",
      "maskHint": "AI に削除させたいオブジェクトのすべての部分をブラシで塗りつぶします。",
      "processButton": "オブジェクトの削除",
      "demoBeforeAlt": "不要なオブジェクトを削除する前の写真",
      "demoAfterAlt": "不要な物体を除去した後の写真",
      "processingAlt": "マークされた写真をAIが処理",
      "resultBeforeAlt": "オブジェクトを削除する前の元の写真",
      "resultAfterAlt": "オブジェクトを除去した後のきれいな写真",
      "featureImageLabels": {
        "object": "不要なオブジェクトの削除の例",
        "person": "人物削除の例",
        "distraction": "気を散らす背景の除去の例"
      },
      "featuresKicker": "正確な写真のクリーンアップ",
      "featuresTitle": "オンラインの写真から不要なオブジェクトを削除する",
      "featuresIntro": "掃除したい正確な領域をマークし、背景を手動で再構築することなく、毎日の写真の気を紛らわすために AI オブジェクト除去を使用します。",
      "features": [
        {
          "title": "不要なオブジェクトを払いのける",
          "desc": "調整可能なブラシを使用して、散らかったもの、標識、小道具、その他のオブジェクトにマークを付けます。 AI は選択した領域を削除し、周囲の画像の詳細で塗りつぶします。",
          "cta": "オブジェクトを無料で削除"
        },
        {
          "title": "写真の背景から人物を削除する",
          "desc": "写真撮影者、観光客、通行人が主要な被写体から気をそらしたときに、旅行写真やポートレートから削除します。",
          "cta": "きれいな写真の背景を無料で"
        },
        {
          "title": "気を散らす小さな背景を消去する",
          "desc": "ワイヤー、ゴミ箱、街路の乱雑物、マーク、または孤立した視覚的な邪魔物を取り除き、よりクリーンな構成を作成します。",
          "cta": "写真の気を散らすものを無料で消去"
        }
      ],
      "useCasesKicker": "よくある使用例",
      "useCasesTitle": "AI Object Remover で何を削除できますか?",
      "useCasesIntro": "集中的に編集できるように設計されており、不要な領域を明確にブラシで消去し、写真の残りの部分は変更しないで済みます。",
      "useCases": [
        {
          "title": "旅行写真のクリーンアップ",
          "desc": "休暇中の写真から通行人、標識、ゴミ箱、街路の雑然としたものを取り除きます。"
        },
        {
          "title": "製品写真のクリーンアップ",
          "desc": "製品の周囲にある小道具、ラベル、ケーブル、邪魔になるものを消去します。"
        },
        {
          "title": "ポートレートの背景のクリーンアップ",
          "desc": "被写体から注意を引く背景の人物や小さなオブジェクトを削除します。"
        },
        {
          "title": "不動産の写真",
          "desc": "部屋や物件の画像から一時的な混乱や孤立したオブジェクトを削除します。"
        },
        {
          "title": "ソーシャルメディア画像",
          "desc": "投稿する前に、目に見える邪魔なものをフレームから取り除き、写真を磨きましょう。"
        },
        {
          "title": "クリエイティブな写真編集",
          "desc": "レイアウトまたはビジュアル プロジェクトで画像を再利用する前に、選択した領域をクリアします。"
        }
      ],
      "howToKicker": "3 つの簡単なステップ",
      "howToTitle": "オンラインで写真からオブジェクトを削除する方法",
      "howToIntro": "写真をアップロードし、不要なオブジェクトをブラシで上書きし、AI でクリーニングされた結果をダウンロードします。",
      "steps": [
        {
          "title": "写真をアップロードする",
          "desc": "消去したい人物、アイテム、または気を散らすものを含む画像を選択します。"
        },
        {
          "title": "オブジェクトをブラシで覆う",
          "desc": "ブラシを調整して、不要な領域を完全にカバーします。元に戻すまたは消しゴムを使用してマスクを調整します。"
        },
        {
          "title": "削除してダウンロード",
          "desc": "AI処理を開始し、前後の画像を比較し、きれいになった写真をダウンロードします。"
        }
      ],
      "faqTitle": "AI オブジェクト リムーバーに関するよくある質問",
      "faqs": [
        {
          "q": "オンラインの写真から不要なオブジェクトを削除するにはどうすればよいですか?",
          "a": "写真をアップロードし、不要なオブジェクト全体をブラシで覆い、処理を開始します。 AI は、近くの色、テクスチャ、シーンの詳細を使用して、選択した領域を再構成します。"
        },
        {
          "q": "写真の背景から人物を削除するにはどのツールを使用できますか?",
          "a": "ブラシを使用して人物を覆い、影や持ち物などの詳細を含めます。通常、周囲の背景が表示されている場合、結果はより良くなります。"
        },
        {
          "q": "AI は標識、電線、ゴミ箱、街路の散乱物を取り除くことができるでしょうか?",
          "a": "はい。不要な領域を明確にマークし、保持したい近くの被写体を覆わないようにしてください。一般に、小さくて孤立した気を散らすものは、再構成するのが簡単です。"
        },
        {
          "q": "より自然なオブジェクト除去結果を得るにはどうすればよいですか?",
          "a": "鮮明で高品質のソース イメージを使用し、オブジェクトの端をわずかに超えてブラシで塗ります。複数のオブジェクトが重なっている場合、難しい領域を個別に処理します。"
        },
        {
          "q": "オブジェクト除去ツールは写真全体を変更しますか?",
          "a": "削除リクエストはブラシ付きマスクに基づいています。このツールは選択した領域に焦点を当てますが、AI はそのエッジの周囲のピクセルを再構築する必要があります。"
        },
        {
          "q": "どの画像形式をアップロードできますか?",
          "a": "アップロード コントロールは、JPG、PNG、WebP などの一般的な画像形式を受け入れます。"
        }
      ]
    },
    "ai-person-remover": {
      "name": "AI人物削除",
      "desc": "AIで写真内の不要な人物を削除",
      "fullDesc": "AI搭載の人物削除ツール。写真内の不要な人物をブラシでなぞるだけで、AIがシームレスに消去し自然な内容で塗りつぶします。通行人や観光客など、写真に映り込んだ不要な人物の除去に最適。",
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "noImageInResponse": "結果画像を取得できませんでした。しばらくしてから再試行してください。",
      "downloadName": "person-removed.png"
    },
    "background-blur": {
      "name": "背景ぼかし",
      "desc": "AIワンクリックで背景をぼかし、被写体を際立たせる",
      "fullDesc": "AIが前景の主体（人/物）を自動認識し、主体は鮮明に保ったまま背景にガウスぼかしをかけ、ポートレートモードのようなボケ効果を作ります。ポートレートや商品のクローズアップに最適。",
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "noImageInResponse": "結果画像を取得できませんでした。しばらくしてから再試行してください。",
      "downloadName": "背景ぼかし結果.png"
    },
    "white-background": {
      "name": "白背景置換",
      "desc": "AIワンクリックで背景を白に置換",
      "fullDesc": "AIワンクリックで背景を白に置換。被写体の輪郭を正確に検出し、髪の毛などの細部を保持、白背景画像で出力。商品写真や証明写真に最適。",
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "noImageInResponse": "結果画像を取得できませんでした。しばらくしてから再試行してください。",
      "downloadName": "白背景結果.png"
    },
    "blue-background": {
      "name": "青背景置換",
      "desc": "AIワンクリックで背景を青に置換",
      "fullDesc": "AIワンクリックで背景を青に置換。被写体の輪郭を正確に検出し、髪の毛などの細部を保持、青背景画像で出力。証明写真やパスポート写真に最適。",
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "noImageInResponse": "結果画像を取得できませんでした。しばらくしてから再試行してください。",
      "downloadName": "青背景結果.png"
    },
    "face-swap": {
      "name": "写真顔交換",
      "desc": "AIで写真の顔をワンクリックで交換",
      "fullDesc": "AI搭載の顔交換機能。ターゲット写真とソース顔写真をアップロードするだけで、顔をターゲット画像にシームレスに合成。複数人のシーンにも対応し、リアルな結果を実現。",
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "targetImage": "ターゲット写真",
      "sourceImage": "ソース顔",
      "effectImageLabel": "結果",
      "downloadName": "顔交換結果.png",
      "step1Title": "写真をアップロード",
      "step1Desc": "ターゲット写真とソース顔写真をアップロード",
      "step2Title": "AI顔交換",
      "step2Desc": "処理をクリック、AIが自動で顔を交換",
      "step3Title": "ダウンロード",
      "step3Desc": "結果をプレビューしてダウンロード",
      "processButton": "顔を交換する",
      "targetPreviewAlt": "AI顔交換用のターゲット写真プレビュー",
      "sourcePreviewAlt": "AI 顔スワップのソース顔プレビュー",
      "processingAlt": "AI顔交換処理プレビュー",
      "resultBeforeAlt": "顔交換前の対象写真",
      "resultAfterAlt": "AI顔交換後の写真",
      "featuresKicker": "自然な顔の置換",
      "featuresTitle": "AI を使用して写真間で顔を交換する",
      "featuresIntro": "ポーズと構図にターゲット写真を使用してから、焦点を当てた写真の顔を交換するための明確なソース顔を提供します。",
      "features": [
        {
          "title": "自然な顔のスワップを作成する",
          "desc": "AI は、ポーズ、フレーミング、照明、全体的なビジュアル スタイルに従いながら、ソースのアイデンティティをターゲット写真にブレンドします。",
          "cta": "写真の顔スワップを無料で作成する"
        },
        {
          "title": "目的の写真の構図を維持する",
          "desc": "ポートレート、セルフィー、キャラクター画像、クリエイティブなシーンなどを、背景や構図を保ったままターゲットとして使用します。",
          "cta": "写真の顔の交換を無料で試す"
        },
        {
          "title": "クリアなソース面を使用する",
          "desc": "モデルがより一貫性のある置換を作成できるように、顔の詳細が見える正面向きの明るいソース画像をアップロードします。",
          "cta": "アップロードとスワップは無料"
        }
      ],
      "useCasesKicker": "クリエイティブな写真のアイデア",
      "useCasesTitle": "オンライン写真の顔交換の一般的な用途",
      "useCasesIntro": "1 つのターゲット画像と 1 つのソース顔画像を使用して、遊び心のあるクリエイティブな写真編集を作成します。",
      "useCases": [
        {
          "title": "セルフィーとプロフィール写真の顔の交換",
          "desc": "ターゲットのポーズ、背景、フレーミングを維持しながら、セルフィーまたはポートレートの顔を置き換えます。プロフィール写真のコンセプトと、明確なソースの顔を使用した個人的なポートレートのアイデアを検討します。",
          "cta": "ポートレートフェイススワップを無料で作成",
          "imageAlt": "自撮り写真とプロフィール写真の AI 顔交換の例"
        },
        {
          "title": "ミームと社会的反応の画像",
          "desc": "見慣れた写真をパーソナライズされたミーム、遊び心のあるリアクション画像、共有可能なソーシャル コンテンツに変えます。明確なターゲット表現は、最終的なイメージを認識しやすくするのに役立ちます。",
          "cta": "ミームの顔を無料で交換する",
          "imageAlt": "クリエイティブなミームと社会的反応の画像の使用例"
        },
        {
          "title": "コスプレ、キャラクター、創作ストーリー",
          "desc": "衣装を着た顔を試したり、ファンタジーのポートレート、イラストのキャラクター、またはテーマのシーンを試してみてください。顔の交換を使用してキャラクターのコンセプトを探求し、編集した画像からビジュアル ストーリーを作成します。",
          "cta": "キャラクターの顔の交換を無料で試してみる",
          "imageAlt": "コスプレとキャラクターの顔交換の使用例"
        }
      ],
      "howToKicker": "3 つの簡単なステップ",
      "howToTitle": "AI を使ってオンラインで写真内の顔を交換する方法",
      "howToIntro": "ターゲットの写真を選択し、明確なソースの顔を追加して、AI に顔交換の結果を生成させます。",
      "faqTitle": "写真の顔の交換に関するよくある質問",
      "faqs": [
        {
          "q": "オンラインで 2 枚の写真の顔を交換するにはどうすればよいですか?",
          "a": "ターゲットとしてポーズと構図を保持したい写真をアップロードし、ソース顔として使用するアイデンティティをアップロードして処理を開始します。"
        },
        {
          "q": "ターゲット写真とソース顔の違いは何ですか?",
          "a": "ターゲット写真は、ポーズ、背景、構図を提供します。ソース顔は、置換に使用される顔の ID を提供します。"
        },
        {
          "q": "顔の交換に適したソース画像を選択するにはどうすればよいですか?",
          "a": "遮るもののない、明るく明るい画像を使用してください。ソースの角度と表現をターゲットと同様にすると、より一貫した結果が得られます。"
        },
        {
          "q": "AI 顔交換を自撮り写真、ミーム写真、コスプレ写真に使用できますか?",
          "a": "はい。これらは、アップロードされた画像を所有しているか、編集する権限がある場合の一般的なクリエイティブな用途です。"
        },
        {
          "q": "顔の交換が時々現実的ではなくなるのはなぜですか?",
          "a": "顔の角度、照明、表現、解像度、または重度のオクルージョンに大きな違いがあると、ブレンディングがより困難になる可能性があります。より鮮明で互換性のあるソース写真を試してください。"
        },
        {
          "q": "どの画像形式とファイル サイズがサポートされていますか?",
          "a": "JPG、PNG、および WebP 画像がサポートされており、画像ごとの最大ファイル サイズは 15 MB です。"
        },
        {
          "q": "このページのビデオの顔を交換できますか?",
          "a": "いいえ。このページは静止画像を処理し、画像結果を返します。"
        }
      ]
    },
    "photo-restore": {
      "name": "写真復元",
      "desc": "AI技術で古い、ぼやけた、または損傷した写真を復元",
      "fullDesc": "AI技術で古い、ぼやけた、または損傷した写真を復元。ノイズ除去、シャープ化、欠損部分の補完に対応し、大切な思い出を蘇らせます。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "写真復元結果.png"
    },
    "blurry-photo-repair": {
      "name": "ぼやけた画像を修復",
      "desc": "AIでぼやけた画像を修復し、より鮮明な細部を復元します",
      "fullDesc": "AIでぼやけた画像を修復します。シャープさを高め、顔や質感の細部を復元し、ぼやけた写真をより鮮明にします。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "ぼやけ画像修復結果.png"
    },
    "cartoon-digital-human": {
      "name": "AIカートゥーンキャラクター生成",
      "desc": "人物写真をカートゥーン風に変換",
      "fullDesc": "人物写真からアニメ風カートゥーンのデジタルヒューマンを生成します。人物の認識しやすい特徴を保ちながら、きれいな線画と鮮やかな色の头像に仕上げます。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "カートゥーンデジタルヒューマン.png"
    },
    "manga-digital-human": {
      "name": "AI漫画風キャラクター生成",
      "desc": "人物写真を漫画風に変換",
      "fullDesc": "人物写真から漫画風のデジタルヒューマンを生成します。人物の認識しやすい特徴を保ちながら、表現力のある線画と整った陰影で漫画風に仕上げます。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "漫画デジタルヒューマン.png"
    },
    "oil-painting-digital-human": {
      "name": "AI油絵ポートレート生成",
      "desc": "人物写真を油絵風に変換",
      "fullDesc": "人物写真から油絵風のデジタルヒューマンを生成します。人物の認識しやすい特徴を保ちながら、豊かな色彩と筆触のある肖像に仕上げます。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "油絵デジタルヒューマン.png"
    },
    "id-photo-generator": {
      "name": "証明写真ジェネレーター",
      "desc": "人物写真から規格の証明写真を生成",
      "fullDesc": "人物写真から清潔でプロフェッショナルな証明写真風の画像を生成します。AIが被写体を整え、書類写真のような見た目に仕上げます。",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "downloadName": "証明写真結果.png"
    },
    "ai-change-clothes": {
      "name": "AI服装チェンジャー",
      "desc": "衣装画像と人物画像をアップロード、ワンクリック着せ替え",
      "fullDesc": "最初に衣装画像をアップロードし、次に人物画像をアップロードします。AIが選択した衣装を人物写真に反映し、人物、ポーズ、自然な画像の細部を保ちます。",
      "demoTitle": "デモ",
      "notImageFile": "有効な画像ファイルをアップロードしてください。",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください。",
      "firstImageLabel": "衣装画像",
      "uploadFirstImage": "衣装画像をアップロード",
      "changeFirstImage": "衣装画像を変更",
      "secondImageLabel": "人物画像",
      "uploadSecondImage": "人物画像をアップロード",
      "changeSecondImage": "人物画像を変更",
      "uploadingSecondImage": "人物画像をアップロード中...",
      "downloadName": "AI衣装チェンジ結果.png"
    },
    "image-enhancer": {
      "name": "画像強化",
      "desc": "画像を4K解像度にアップスケーリングし、詳細を強化",
      "fullDesc": "画像を4K解像度にアップスケーリングし、詳細を強化。高度なAIアルゴリズムで詳細を強化し、ぼやけた画像をシャープに。",
      "fileTooLarge": "画像が大きすぎます。15MB以下のJPG、PNG、WebPをご使用ください。",
      "notImageFile": "画像ファイルをアップロードしてください。",
      "downloadName": "画像強化結果.png",
      "targetResolution": "目標解像度",
      "outputFormat": "出力形式",
      "resolutions": {
        "2k": "2K",
        "4k": "4K",
        "8k": "8K"
      },
      "formats": {
        "JPEG": "JPEG",
        "PNG": "PNG",
        "WEBP": "WEBP"
      },
      "processFailed": "処理に失敗しました。別の画像または出力形式に変更してお試しください。"
    },
    "video-enhancer": {
      "name": "動画強化",
      "desc": "動画を4K解像度にアップスケーリングし、鮮明さを強化",
      "fullDesc": "動画を4K解像度にアップスケーリングし、鮮明さを強化。複数の動画形式に対応し、AIによるフレーム補間で驚くべきHD品質を実現。",
      "notVideoFile": "動画ファイルをアップロードしてください（例：MP4、MOV、AVI）。",
      "fileTooLarge": "動画が大きすぎます。100MB以下のファイルをご使用ください。"
    },
    "cartoon-video-style-converter": {
      "name": "カートゥーン風変換",
      "desc": "動画をカートゥーン風に変換",
      "fullDesc": "動画をアップロードすると、AIが主な動きや構図を保ちながらカートゥーン風の動画に変換します。",
      "notVideoFile": "有効な動画ファイルをアップロードしてください。",
      "fileTooLarge": "動画が大きすぎます。100MB以下の動画を選択してください。",
      "downloadName": "cartoon-style-video.mp4"
    },
    "anime-video-style-converter": {
      "name": "アニメ風変換",
      "desc": "動画をアニメ風に変換",
      "fullDesc": "動画をアップロードすると、AIが被写体の動きや映像のテンポを保ちながらアニメ風の動画に変換します。",
      "notVideoFile": "有効な動画ファイルをアップロードしてください。",
      "fileTooLarge": "動画が大きすぎます。100MB以下の動画を選択してください。",
      "downloadName": "anime-style-video.mp4"
    },
    "oil-painting-video-style-converter": {
      "name": "油絵風変換",
      "desc": "動画を油絵風に変換",
      "fullDesc": "動画をアップロードすると、AIが豊かな色彩と筆触感のある油絵風動画に変換します。",
      "notVideoFile": "有効な動画ファイルをアップロードしてください。",
      "fileTooLarge": "動画が大きすぎます。100MB以下の動画を選択してください。",
      "downloadName": "oil-painting-style-video.mp4"
    },
    "cyberpunk-video-style-converter": {
      "name": "サイバーパンク風変換",
      "desc": "動画をサイバーパンク風に変換",
      "fullDesc": "動画をアップロードすると、AIがネオン感と未来的な高コントラストのサイバーパンク風動画に変換します。",
      "notVideoFile": "有効な動画ファイルをアップロードしてください。",
      "fileTooLarge": "動画が大きすぎます。100MB以下の動画を選択してください。",
      "downloadName": "cyberpunk-style-video.mp4"
    },
    "doc-crop-enhance": {
      "name": "画像切り取り＆補正",
      "desc": "AIで文書の切り取りと歪み補正",
      "fullDesc": "ドキュメント画像の切り取り、歪み補正、強化。余白背景の削除、歪み補正、明るくする、シャープ化、白黒、グレースケール、影除去など多彩な強化モードをサポート。",
      "enhanceMode": "強化モード",
      "enhanceModes": {
        "disabled": "強化なし",
        "brighten": "明るくする",
        "sharpen": "強化＆シャープ化",
        "blackWhite": "白黒",
        "grayscale": "グレースケール",
        "deshadow": "影除去",
        "bitmap": "ビットマップ"
      },
      "cropImage": "切り取り",
      "dewarpImage": "歪み補正",
      "notImageFile": "有効な画像ファイルをアップロードしてください",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください",
      "noImageInResponse": "処理に失敗しました。再試行してください",
      "downloadName": "doc-crop-enhanced.png",
      "featuresKicker": "ドキュメントスキャンの強化",
      "featuresTitle": "ドキュメントの写真をきれいで適切に位置合わせされたスキャンに変換します",
      "featuresIntro": "一般的なモバイル キャプチャとスキャン強化のニーズに合わせて、ドキュメントの端、傾き、遠近感、湾曲したページ、影、テキストの明瞭さを処理します。",
      "features": [
        {
          "title": "ドキュメントの端を自動的に検出してトリミングする",
          "desc": "紙と背景の境界を見つけて、机、端の影、無関係な領域を削除してページをきれいにします。",
          "cta": "ドキュメントを無料でトリミングする"
        },
        {
          "title": "歪んだ文書をまっすぐにして遠近感を修正",
          "desc": "契約書、フォーム、試験用紙の傾いた携帯電話の写真によって引き起こされる台形の歪み、傾いたページ、縦横比を修正します。",
          "cta": "文書写真を修正する"
        },
        {
          "title": "湾曲したページとスキャンされた文書の歪みを補正する",
          "desc": "教科書や本の写真を読みやすくするために、本の装丁付近の歪み、カールした紙、折れたページを修正します。",
          "cta": "湾曲したドキュメントの歪みを補正する"
        },
        {
          "title": "ドキュメントスキャンから影を除去する",
          "desc": "電話、指、本の背、不均一な照明によって生じる影を軽減し、レシート、ワークシート、スキャンしたページをきれいにします。",
          "cta": "ドキュメントの影を削除する"
        },
        {
          "title": "文書を明るくし、テキストを鮮明にします",
          "desc": "低コントラストの文書の明るさと印刷されたテキストの端が改善され、読みやすく、印刷し、整理しやすくなります。",
          "cta": "スキャンしたテキストを鮮明にする"
        },
        {
          "title": "白黒、グレースケール、またはビットマップ スキャンの作成",
          "desc": "カラーのドキュメント写真を、印刷やアーカイブ用に白黒、グレースケール、またはビットマップで強化された画像に変換します。",
          "cta": "ドキュメント画像を強化する"
        }
      ],
      "useCasesKicker": "一般的な使用例",
      "useCasesTitle": "どのドキュメント画像をトリミングしたり、補正したりできるのですか?",
      "useCasesIntro": "携帯電話やスキャナーで取り込んだ、不均一なフレーミング、影、歪み、または不明瞭なテキストのある個々の文書画像用に設計されています。",
      "useCases": [
        {
          "title": "スキャンする携帯電話の写真",
          "desc": "デスクの背景を削除し、カメラの角度を修正して、携帯電話の写真をスキャンのように見せます。"
        },
        {
          "title": "契約書とフォーム",
          "desc": "契約書、申請書、フォームをトリミングして、きれいなエッジとページの比率を復元します。"
        },
        {
          "title": "領収書と請求書",
          "desc": "影を減らし、かすかな印刷テキストを鮮明にして、より鮮明な表示とアーカイブを実現します。"
        },
        {
          "title": "曲がった本のページ",
          "desc": "教科書、本、ワークブックの綴じ部分付近の湾曲を修正します。"
        },
        {
          "title": "テスト用紙とワークシート",
          "desc": "再利用または印刷するために、試験用紙をまっすぐにし、影を取り除き、印刷されたテキストを鮮明にします。"
        },
        {
          "title": "白黒アーカイブ",
          "desc": "文書の写真を一貫した白黒またはグレースケールのスキャン スタイルに変換します。"
        }
      ],
      "faqTitle": "AI ドキュメントの切り抜きと修正に関するよくある質問",
      "faqs": [
        {
          "q": "AI ドキュメントのトリミングと修正とは何ですか?",
          "a": "文書領域を検出し、周囲の背景を除去し、設定に基づいて傾き、遠近感、またはページの湾曲の歪みを修正します。"
        },
        {
          "q": "スキャンしたドキュメントの画像をオンラインで自動トリミングするにはどうすればよいですか?",
          "a": "エッジトリミングを有効にして、スキャンしたドキュメント画像をアップロードします。このツールは、用紙の境界を検出し、文書の外側の領域を削除しようとします。"
        },
        {
          "q": "スキャンしたドキュメントをオンラインでデスキューできますか?",
          "a": "はい。傾いたスキャンには傾き補正を使用し、傾いた携帯電話の写真には遠近補正を使用します。ページ自体が湾曲している場合にのみ、歪み補正を使用してください。"
        },
        {
          "q": "デシャドウ モードとシャープ モードの違いは何ですか?",
          "a": "デシャドウは不均一なページの照明を改善し、シャープはテキストと線のエッジを強化します。原因となる問題に一致するモードを選択してください。"
        },
        {
          "q": "スキャンした試験用紙、契約書、領収書を強化するにはどのツールを使用できますか?",
          "a": "このドキュメントのトリミングおよび強調ツールは、印刷用にドキュメントを準備するときに、不均一な照明のデシャドウ、かすかなテキストのシャープ化、および白黒またはグレースケールを備えたツールとして使用します。"
        },
        {
          "q": "携帯電話の写真をスキャンした文書に変換できますか?",
          "a": "トリミング、修正、および強調によりスキャンのような画像を生成できますが、このツールは PDF を生成したり、OCR テキストを抽出したりすることはありません。"
        },
        {
          "q": "どの画像形式とファイル サイズがサポートされていますか?",
          "a": "JPG、PNG、および WebP 画像がサポートされており、最大ファイル サイズは 15 MB です。"
        },
        {
          "q": "処理により元の文書の内容は変更されますか?",
          "a": "このツールは、フレーミング、ジオメトリ、明るさ、明瞭さを調整します。テキストの編集やドキュメントのコンテンツの抽出は行いません。"
        }
      ],
      "education": {
        "kicker": "教育文書",
        "title": "テスト用紙、宿題、教科書の写真を鮮明なスキャンに変換",
        "intro": "教育文書の端を自動的に検出し、傾き、遠近感、湾曲したページ、影を修正して、印刷、アーカイブ、教室での使用をよりきれいにします。",
        "items": [
          {
            "title": "作物試験紙の写真",
            "desc": "テスト用紙の端を検出し、机の背景を除去して、きれいで適切にフレーム化されたページを作成します。"
          },
          {
            "title": "正しい宿題の画像",
            "desc": "宿題の写真の傾きと遠近感を修正して、レビュー、提出、印刷しやすくします。"
          },
          {
            "title": "Dewarp 教科書のページ",
            "desc": "製本近くの湾曲したページを修正し、印刷内容を読みにくくする影を軽減します。"
          },
          {
            "title": "教室のワークシートを洗練する",
            "desc": "きれいな白黒またはグレースケールのスキャン効果を使用して、ワークシートや学習資料を明るく鮮明にします。"
          }
        ],
        "relatedTitle": "テスト用紙から手書きの回答を削除する必要がありますか?",
        "relatedDesc": "このツールは、トリミング、幾何学補正、画像補正を処理します。手書き消しゴムを使用して、生徒の解答、計算、または教師の注釈を削除します。",
        "relatedCta": "手書き消しゴムを開く"
      }
    },
    "handwritten-erase": {
      "name": "手書き文字消去",
      "desc": "AIで文書の手書き文字を自動消去",
      "fullDesc": "ドキュメントから手書き文字を自動検出して消去。印刷内容は保持します。試験用紙、ノート、契約書などに最適。切り取り、歪み補正、回転をサポート。",
      "docDirection": "回転",
      "docDirections": {
        "none": "回転なし",
        "rotate90": "時計回り90°",
        "rotate180": "時計回り180°",
        "rotate270": "時計回り270°",
        "auto": "自動検出"
      },
      "crop": "切り取り",
      "dewarp": "歪み補正",
      "notImageFile": "有効な画像ファイルをアップロードしてください",
      "fileTooLarge": "画像が大きすぎます。15MB以下の画像を選択してください",
      "noImageInResponse": "処理に失敗しました。再試行してください",
      "downloadName": "handwritten-erased.png",
      "featuresKicker": "文書の手書きの削除",
      "featuresTitle": "手書きを削除し、きれいな文書を復元する",
      "featuresIntro": "印刷されたテキストと元のレイアウトを維持しながら、手書きの回答、契約の改訂、レビューメモ、スキャンされた文書のマークをきれいにします。",
      "features": [
        {
          "title": "テスト用紙から生徒の回答を削除する",
          "desc": "記入済みの試験用紙上の手書きの解答、計算、注釈を自動的に検出します。",
          "cta": "きれいな試験紙の答えは無料です"
        },
        {
          "title": "契約書から手書きを消去する",
          "desc": "印刷された条項、表、レイアウトを維持しながら、手書きの追加、丸、変更金額、矢印、レビューメモをきれいにします。",
          "cta": "オンラインできれいな契約書の手書き"
        },
        {
          "title": "教育用のテストを準備して再印刷する",
          "desc": "レッスン、テスト準備、ドキュメントのアーカイブのために、生徒の回答と教師の注釈をクリーンにします。",
          "cta": "教師用テスト用紙クリーナーをお試しください"
        },
        {
          "title": "スキャンした文書から手書きマークを消去する",
          "desc": "スキャンしたフォーム、検査報告書、オフィス文書からチェックマーク、矢印、丸、余白メモ、レビューマークを削除します。",
          "cta": "スキャンした文書の跡をきれいにする"
        }
      ],
      "useCasesKicker": "学生と教師向け",
      "useCasesTitle": "AI 手書き削除の教育ユースケース",
      "useCases": [
        {
          "title": "テスト回答の削除",
          "desc": "生徒の答えや計算をテスト用紙から消去します。"
        },
        {
          "title": "間違いのレビュー",
          "desc": "完了した書類を次の練習のために復元します。"
        },
        {
          "title": "ワークブックのクリーニング",
          "desc": "宿題やワークシートから手書きの内容を削除します。"
        },
        {
          "title": "指導と試験の準備",
          "desc": "レッスン、再印刷、アーカイブ用にクリーンなペーパーを作成します。"
        },
        {
          "title": "スキャンした紙の修正",
          "desc": "歪んだり湾曲した文書画像を回転、トリミング、歪み補正します。"
        },
        {
          "title": "契約書とノートのクリーニング",
          "desc": "一般的な文書から手書きや注釈を削除します。"
        }
      ],
      "howToKicker": "3 つの簡単なステップ",
      "howToTitle": "オンラインの試験問題から手書きの解答を削除する方法",
      "howToIntro": "テスト用紙またはドキュメントをアップロードし、回転、トリミング、歪み補正のオプションを設定して、クリーンアップされた結果をダウンロードします。",
      "steps": {
        "upload": {
          "title": "テスト用紙またはドキュメントをアップロードする",
          "desc": "15 MB 未満の JPG、PNG、または WebP のテスト用紙、宿題シート、またはスキャンした文書をアップロードします。"
        },
        "process": {
          "title": "手書きの構成と削除",
          "desc": "ドキュメントの方向を選択し、必要に応じてトリミングまたは歪み補正を有効にして、処理を開始します。"
        },
        "download": {
          "title": "確認してダウンロード",
          "desc": "前後の画像を比較し、クリーンなドキュメントをダウンロードするか、別の画像を処理します。"
        }
      },
      "faqTitle": "AI テスト用紙解答リムーバー FAQ",
      "faqs": [
        {
          "q": "テスト用紙から手書きの回答を削除するにはどのようなツールを使用できますか?",
          "a": "Miral AI 手書きリムーバーは、印刷された質問と元のレイアウトを可能な限り保存しながら、手書きの回答、計算、注釈を検出します。"
        },
        {
          "q": "AI は印刷されたテキストを保持したまま手書きを削除できますか?",
          "a": "手書きが印刷内容に大きく重なっていない場合、印刷テキストを保持しながら、きれいな用紙を復元できます。"
        },
        {
          "q": "教師はテスト用紙をクリーニングして再印刷できますか?",
          "a": "はい。授業の準備や教室での説明、テストの作成、文書のアーカイブなどに適しています。"
        },
        {
          "q": "学生は解答済みのレポートを修正のためにリセットできますか?",
          "a": "はい。きれいにしたテスト用紙とワークシートは、間違いの復習やさらなる練習のために再利用できます。"
        },
        {
          "q": "手書きのメモ、ペン跡、赤インクの注釈を消去するにはどうすればよいですか?",
          "a": "文書画像をアップロードし、手書き削除ツールを実行します。さまざまな手書きの色や筆記ツールを処理できますが、結果は鮮明さや印刷されたテキストとの重なりによって異なります。"
        },
        {
          "q": "手書き文字を削除する前に、スキャンの傾きや湾曲を修正するにはどうすればよいですか?",
          "a": "まず、傾いたスキャンをデスキューまたは回転します。手書きを処理する前に、余分な背景にはトリミングを使用し、純粋に湾曲したページに対してのみ歪み補正を使用します。"
        },
        {
          "q": "どの画像形式がサポートされていますか?",
          "a": "15MB 未満の JPG、PNG、および WebP 画像がサポートされています。このページでは PDF ファイルはサポートされていません。"
        }
      ]
    },
    category: {
      image: '画像処理',
      video: '動画処理',
      document: 'ドキュメント処理'
    },
    categoryModal: {
      title: 'ツールカテゴリを選択'
    },
    convert: {
      success: '変換完了！',
      zipHint: '複数の画像を含むZIPファイルとしてパッケージされています',
      fileTooLarge: 'ファイルが大きすぎます。50MB以下のファイルを選択してください',
      demoTitle: '変換プレビュー',
      sourceLabel: '入力形式',
      targetLabel: '出力形式'
    },
    "pdf-to-word": {
      name: 'PDF→Word',
      desc: 'PDFファイルを編集可能なWord文書に変換',
      fullDesc: 'PDFファイルをインテリジェントに編集可能なWord文書に変換し、レイアウト、表、画像などを正確に保持します。'
    },
    "image-to-word": {
      name: '画像→Word',
      desc: '画像内のテキストをWord文書に変換',
      fullDesc: '画像内のテキスト、表などをインテリジェントに認識し、元のレイアウト形式を保持したWord文書に変換します。'
    },
    "pdf-to-excel": {
      name: 'PDF→Excel',
      desc: 'PDFの表を編集可能なExcelファイルに変換',
      fullDesc: 'PDFファイル内の表内容をインテリジェントに認識し、表構造とデータを正確に保持したExcelファイルに変換します。'
    },
    "pdf-to-ppt": {
      name: 'PDF→PPT',
      desc: 'PDFファイルを編集可能なPPTプレゼンテーションに変換',
      fullDesc: 'PDFファイルをインテリジェントに編集可能なPPTプレゼンテーションに変換し、元のレイアウト、画像、テキストを保持します。'
    },
    "pdf-to-image": {
      name: 'PDF→画像',
      desc: 'PDFの各ページを高品質な画像に変換',
      fullDesc: 'PDFファイルの各ページを高品質な画像に変換します。複数ページの一括変換に対応し、結果はZIPでダウンロードできます。'
    },
    "word-to-pdf": {
      name: 'Word→PDF',
      desc: 'Word文書をPDFファイルに変換',
      fullDesc: 'Word文書を素早くPDFファイルに変換し、元のレイアウト、フォント、画像を保持してフォーマットの一貫性を確保します。'
    },
    "excel-to-pdf": {
      name: 'Excel→PDF',
      desc: 'ExcelスプレッドシートをPDFファイルに変換',
      fullDesc: 'ExcelスプレッドシートをPDFファイルに変換し、表構造とデータレイアウトを保持します。'
    },
    "image-to-pdf": {
      name: '画像→PDF',
      desc: '複数の画像を1つのPDFファイルに結合',
      fullDesc: '複数の画像を1つのPDFファイルに結合します。JPG、PNG、BMPなどの一般的な画像形式に対応しています。'
    },
    "word-to-image": {
      name: 'Word→画像',
      desc: 'Word文書の各ページを画像に変換',
      fullDesc: 'Word文書の各ページを高品質な画像に変換します。複数ページの一括変換に対応し、結果はZIPでダウンロードできます。'
    }
  },
  "plans": {
    "basic": {
      "name": "ベーシック",
      "features": [
        "全クレジット一括付与",
        "最大2,600枚のAI画像を生成",
        "520本のAI動画を生成",
        "最大480曲のAI音楽を生成",
        "透かしなし",
        "商用ライセンス"
      ]
    },
    "pro": {
      "name": "プロ",
      "features": [
        "全クレジット一括付与",
        "最大10,600枚のAI画像を生成",
        "最大2,120本のAI動画を生成",
        "最大1,920曲のAI音楽を生成",
        "すべてのプレミアムモデル",
        "優先キュー",
        "優先サポート",
        "プライバシーモードとDPA準拠"
      ]
    },
    "ultimate": {
      "name": "アルティメット",
      "features": [
        "全クレジット一括付与",
        "最大36,600枚のAI画像を生成",
        "最大7,320本のAI動画を生成",
        "最大6,720曲のAI音楽を生成",
        "すべてのプレミアムモデル",
        "専用サポート",
        "プライバシーモードとDPA準拠"
      ]
    }
  },
  "faq": {
    "categories": {
      "all": "すべて",
      "general": "一般",
      "pricing": "料金",
      "models": "モデル",
      "features": "機能"
    },
    "items": [
      {
        "q": "Miralとは？",
        "a": "Miralは29以上のトップクラスAIモデルを統合したオールインワンAI創作プラットフォームで、画像生成、動画制作、音楽制作、プロフェッショナル編集ツールをサポートしています。FLUX、Midjourney、Sora、Veo、Klingなど、すべての主要モデルに1つのアカウントでアクセスできます。"
      },
      {
        "q": "どのAIモデルがサポートされていますか？",
        "a": "29以上のトップクラスAIモデルをサポートしています。画像モデル（FLUX 2 Max、Midjourney、Seedream、GPT-Image-1、Nano Bananaなど）、動画モデル（Veo 3.1、Sora 2、Kling 2.6、Seedance、Wan 2.5など）、AI音楽生成モデルを含みます。すべてのモデルは継続的に更新されます。"
      },
      {
        "q": "クレジットシステムはどのように機能しますか？",
        "a": "統一されたクレジットシステムを採用しています。画像生成は2クレジットから、動画生成は10クレジットから、音楽は1曲あたり10クレジットです。プレミアムモデルはより多くのクレジットを消費する場合があります。サブスクライバーはより低いクレジット単価を享受でき、クレジットパックを個別に購入することもできます。"
      },
      {
        "q": "画像、動画、音楽を生成できますか？",
        "a": "はい！Miralはテキストから画像、画像編集、スタイル転送、テキストから動画、画像から動画、AI音楽制作など、あらゆる創作ニーズに対応しています。"
      },
      {
        "q": "生成速度はどうですか？",
        "a": "ほとんどの画像生成は30秒以内に完了し、動画生成は約1〜6分かかります。インフラを継続的に最適化し、高速で安定した生成体験を確保しています。"
      },
      {
        "q": "Miralを商用目的で使用できますか？",
        "a": "はい。すべての有料プランに商用ライセンスが含まれており、生成されたコンテンツを商用プロジェクト、マーケティング資料、ソーシャルメディアなどに使用できます。"
      },
      {
        "q": "APIアクセスはありますか？",
        "a": "はい、アルティメットプランにはAPIアクセスが含まれています。包括的なAPIを通じて、AI画像、動画、音楽生成をアプリケーションに直接統合できます。"
      },
      {
        "q": "AIで音楽を生成できますか？",
        "a": "もちろんです！AI音楽ジェネレーターは様々な音楽スタイルをサポートしています。説明を入力するだけでオリジナル音楽を生成でき、動画のサウンドトラックやポッドキャストのBGMなどに最適です。"
      },
      {
        "q": "データプライバシーとセキュリティはどのように扱われますか？",
        "a": "GDPR準拠基準を厳守しています。すべてのデータは暗号化され、AIトレーニングには使用されません。ユーザーはいつでもアカウントとすべてのデータを削除できます。"
      },
      {
        "q": "他の人が私の作品を見ることができますか？",
        "a": "デフォルトでは、あなたの作品はあなただけに表示されます。プロおよびアルティメットユーザーはプライバシーモードを有効にして、完全なプライバシーを確保できます。"
      },
      {
        "q": "アカウントとデータを削除するにはどうすればいいですか？",
        "a": "アカウント設定からいつでもアカウント削除を申請できます。30日以内にすべてのデータと生成コンテンツを削除します。"
      },
      {
        "q": "問題が発生した場合、サポートを受けられますか？",
        "a": "もちろんです！miral_support@miralvis.comでサポートチームに連絡できます。プロユーザーは優先サポート、アルティメットユーザーは専用サポートを受けられます。"
      }
    ]
  },
  "testimonials": {
    "items": [
      {
        "name": "Alex Chen",
        "role": "デジタルマーケティングディレクター",
        "tag": "90%の時間節約",
        "content": "Miralは私たちのビジュアルコンテンツハブになりました。Midjourneyで製品画像を生成し、Veoでプロモーション動画を作成し、Miralですべてを編集 - プラットフォームを切り替える必要がありません。"
      },
      {
        "name": "Sarah Rodriguez",
        "role": "ECオーナー",
        "tag": "コンバージョン40%向上",
        "content": "29以上のモデルに1か所でアクセスできるのは素晴らしいです。Seedreamで製品写真、Seedanceで動画広告、アップスケーリングツールでカタログを作成。コンバージョンが40%向上しました！"
      },
      {
        "name": "David Kim",
        "role": "コンテンツクリエイター",
        "tag": "フォロワー500K以上",
        "content": "FLUXとNano Bananaで画像を作成し、KlingとSoraでバイラル動画に変換しています。クレジットシステムは公平で、必要な分だけ使えます。フォロワーは多様なコンテンツを気に入っています！"
      },
      {
        "name": "Emma Thompson",
        "role": "グラフィックデザイナー",
        "tag": "プロフェッショナル級",
        "content": "デザイナーとして、AIプラットフォームには懐疑的でした。しかしMiralの豊富なモデルライブラリと精密な編集ツールは本当に印象的です。コンセプトスケッチから最終製品まで、すべて簡単にできます。"
      },
      {
        "name": "James Wilson",
        "role": "動画プロデューサー",
        "tag": "ワークフロー10倍高速化",
        "content": "ここの動画モデルは素晴らしいです - Veoは映画級、Seedanceは高速、Wanのキャラクターアニメーションは自然です。すべてのモデルが1つのクレジットシステムを共有 - 時間とお金を節約できます。"
      },
      {
        "name": "Lisa Park",
        "role": "クリエイティブエージェンシーオーナー",
        "tag": "チームの選択",
        "content": "チーム全員がMiralに切り替えました。API統合はスムーズで、豊富なモデルの選択肢により、常に適切なツールが見つかります。これが現在最高のAIプラットフォームです。"
      }
    ]
  },
  "langModal": {
    "title": "言語を選択"
  },
  "home": {
    "generate": "生成",
    "chatDisabledGenerateHint": "プロンプトを入力してください",
    "compactChatPlaceholder": "プロンプトを入力して、美しいAI画像・動画・オリジナル音楽を生成",
    "hero": {
      "title": "Miral – 画像・動画・音楽のオールインワンAI制作プラットフォーム",
      "subtitle": "多彩なAIモデルを搭載したMiralは、画像編集、動画生成、AI音楽制作を一つに統合。写真を編集し、映画のようなポートレート動画や、個人・商用制作向けのオリジナルBGMを作成できます。",
      "createVideo": "動画を作成",
      "createImage": "画像を作成"
    },
    "stats": {
      "models": "トップAIモデル",
      "works": "生成された作品",
      "tools": "プロフェッショナルツール",
      "platforms": "パートナープラットフォーム"
    },
    "generatorNew": {
      "promptPlaceholder": "生成したい動画を説明してください...",
      "promptPlaceholderImage": "生成したい画像を説明してください...",
      "generating": "生成中...",
      "noHistory": "生成結果がここに表示されます",
      "generationFailed": "生成に失敗しました",
      "historyTitle": "履歴",
      "myAssets": "マイアセット"
    },
    "quickTools": {
      "title": "クイックAIツール"
    },
    "exploreMore": {
      "title": "もっとAI機能を探す"
    },
    "platform": {
      "tag": "プラットフォーム",
      "title": "創作をシンプルにするAIツールボックス",
      "subtitle": "画像生成、動画制作、音楽制作、プロフェッショナルツールを一体化。業界をリードするAIモデルで駆動。",
      "tabs": {
        "image": "AI画像",
        "video": "AI動画",
        "music": "AI音楽",
        "tools": "AIツールボックス"
      },
      "image": {
        "title": "世界トップクラスのAIモデルで驚くべき画像を生成・編集",
        "desc": "テキストから画像、精密編集、スタイル転送、HDアップスケーリング。FLUX、Midjourney、Seedream、GPT-Image-1、Nano Bananaで駆動。",
        "explore": "画像モデルを探索 →"
      },
      "video": {
        "title": "AIで映画級の動画を作成",
        "desc": "テキストから動画から画像アニメーションまで、Veo、Sora、Kling、Seedance、Wanモデルで駆動。同期音声とプロのカメラワークで動画を生成。",
        "explore": "動画モデルを探索 →"
      },
      "music": {
        "title": "AI駆動のオリジナル音楽制作",
        "desc": "説明からオリジナル音楽を生成。様々なスタイルと長さをサポート。動画のサウンドトラックやポッドキャストのBGMに最適。",
        "explore": "AI音楽を探索 →"
      },
      "tools": {
        "title": "プロフェッショナルAIツールボックス",
        "desc": "透かし除去、写真復元、HDアップスケーリング、動画強化など、あらゆる後処理ニーズに対応するプロフェッショナルツール。",
        "explore": "すべてのツールを表示 →"
      }
    },
    "models": {
      "tag": "モデル",
      "title": "世界トップクラスのAIモデルをワンストップで統合",
      "subtitle": "1つのプラットフォームですべての主要AIモデルを統合。複数のアカウントとサブスクリプションの切り替えはもう不要。",
      "imageModels": "画像モデル",
      "videoModels": "動画モデル",
      "musicModels": "AI音楽",
      "musicDesc": "説明からオリジナル音楽を生成",
      "filterAll": "すべて",
      "credits": "クレジット",
      "viewAll": "すべて表示 →"
    },
    "features": {
      "tag": "コア機能",
      "title": "驚くべき画像、動画、音楽を創作",
      "subtitle": "テキストから画像、テキストから動画、AI音楽制作から精密編集、HDアップスケーリングまで - オールインワンで創作。",
      "items": {
        "textToImage": {
          "tag": "テキストから画像",
          "title": "テキストから画像",
          "desc": "説明を入力して魔法を目撃。超リアルなポートレートでもファンタジー風景でも、Midjourney、Seedream、Nano Bananaなどのモデルで、シンプルなプロンプトでビジュアルマスターピースを生成。",
          "cta": "画像生成",
          "imageAlt": "Midjourney、Seedream、Nano Banana などのモデルで、シンプルなプロンプトでビジュアルマスターピースを生成"
        },
        "imageEdit": {
          "tag": "画像編集とスタイル転送",
          "title": "画像編集とスタイル転送",
          "desc": "AIを使って画像を精密に再形成。スタイルの変更、オブジェクトの修正、背景の置き換え、テキストの編集など、すべて高い一貫性で。",
          "cta": "画像編集",
          "beforeAlt": "画像編集とスタイル変換前",
          "afterAlt": "画像編集とスタイル変換後"
        },
        "textToVideo": {
          "tag": "テキストから動画",
          "title": "テキストから動画",
          "desc": "プロンプトを入力するだけで、同期音声、プロのカメラワーク、リアルな動きを持つ映画級の動画を生成。Veo、Sora、Kling、Seedance、Wanモデルから選択可能。",
          "cta": "動画生成"
        },
        "imageToVideo": {
          "tag": "画像から動画",
          "title": "画像から動画",
          "desc": "静止画を映画級の動画に変換。製品写真、イラスト、AI生成画像のいずれでも、自然な動きとナレーションで命を吹き込みます。",
          "cta": "画像アニメーション"
        },
        "upscale": {
          "tag": "HDアップスケーリング",
          "title": "HDアップスケーリング",
          "desc": "AIで画像と動画の品質を向上。ロスレスHDアップスケーリングと動画解像度の4Kプロフェッショナルレベルへの強化をサポート。",
          "cta": "今すぐアップスケール",
          "imageAlt": "AIで画像・動画の画質を向上"
        },
        "templates": {
          "tag": "40以上の画像テンプレート",
          "title": "40以上の画像テンプレート",
          "desc": "インスピレーションを刺激する豊富なテンプレート：3Dモデル、ジブリスタイル、デザイナートイ、ミームジェネレーター、雑誌カバーなど - 写真をアップロードするだけで即座に完成。",
          "cta": "テンプレートを閲覧",
          "imageAlt": "画像テンプレート例"
        }
      }
    },
    "gallery": {
      "tag": "ギャラリー",
      "title": "無限の可能性を探索",
      "subtitle": "クリエイターがMiralで何を作っているか見てみましょう - 超リアルな画像から映画級の動画まで、インスピレーションはすぐそこに。",
      "images": {
        "alt1": "Midjourney 生成画像例",
        "alt2": "Seedream 生成画像例",
        "alt3": "GPT-Image-1 生成画像例",
        "alt4": "Flux 生成画像例",
        "alt5": "Flux Pro 生成画像例",
        "alt6": "Midjourney 生成画像例",
        "alt7": "Seedream 生成画像例",
        "alt8": "GPT-Image-1 生成画像例"
      }
    },
    "whyChoose": {
      "tag": "Miralを選ぶ理由",
      "title": "オールインワン創作、必要なものすべて",
      "subtitle": "世界トップクラスのAI画像、動画、音楽制作モデルを集結させたワンストッププラットフォーム。",
      "items": {
        "allModels": {
          "title": "全モデル統合、1つで十分",
          "desc": "OpenAI、Google、Alibaba、ByteDanceなど29以上のトップAIモデルにワンストップでアクセス。ツール間の切り替えや複数のサブスクリプション管理は不要。"
        },
        "fast": {
          "title": "稲妻のような速さ",
          "desc": "ほとんどの画像生成は30秒以内に完了、動画生成は約1〜6分。最適化されたインフラで長い待ち時間はありません。"
        },
        "credits": {
          "title": "シンプルなクレジットシステム",
          "desc": "使った分だけ支払い、透明な価格設定。無料クレジットから始めて - サブスクリプションなしで創作を開始。"
        },
        "api": {
          "title": "開発者API",
          "desc": "包括的なAPIを通じて、AI画像、動画、音楽生成をアプリケーションに直接統合。トップAIモデルの上に製品を構築。"
        }
      }
    },
    "testimonials": {
      "tag": "ユーザーストーリー",
      "title": "世界中のクリエイターに信頼されています",
      "subtitle": "何千人ものプロフェッショナルとクリエイターがMiralを使用して画像を生成、動画を作成し、クリエイティブワークフローを強化しています。"
    },
    "faq": {
      "tag": "サポート",
      "title": "よくある質問",
      "subtitle": "プラットフォーム、サポートモデル、料金プラン、機能に関する包括的なガイド。"
    },
    "cta": {
      "title": "今すぐAI創作の旅を始めよう",
      "subtitle": "何千人ものクリエイター、デザイナー、企業に加わり、世界トップクラスのAIモデルでMiralで創造性を実現しましょう。",
      "createImage": "画像を作成 →",
      "createVideo": "動画を作成 →",
      "note": "新規ユーザー登録で無料クレジットをプレゼント。クレジットカード不要。"
    },
    "apps": {
      "title": "アプリ",
      "quickTitle": "クイックAIアプリ",
      "more": "もっと見る",
      "keywords": {
        "viralVideo": "バズ動画",
        "tiktokAds": "TikTok広告",
        "productShowcase": "製品ショーケース",
        "aiAvatar": "AIアバター",
        "homeModernKitchen": "モダンキッチン"
      },
      "social": "ソーシャルメディア",
      "posters": "ポスター",
      "interior": "ホーム",
      "entertainment": "エンターテイメント",
      "lifestyle": "ライフスタイル",
      "comic": "コミック",
      "items": {
        "viralVideo": "バイラル動画",
        "celebrityVideo": "セレブ動画",
        "productShowcase": "製品紹介",
        "tiktokAds": "TikTok広告",
        "aiMeme": "AIミーム",
        "aiAvatar": "AIアバター",
        "logoAnimation": "ロゴアニメーション",
        "socialShorts": "SNSショート",
        "brandStory": "ブランドストーリー",
        "tutorialClip": "チュートリアル",
        "musicVideo": "AI ミュージックビデオ",
        "animeScene": "アニメシーン",
        "movieTrailer": "映画予告",
        "gameCinematic": "ゲームシネマティック",
        "visualPoetry": "ビジュアルポエトリー",
        "natureDoc": "自然ドキュメンタリー",
        "cyberpunkCity": "サイバーパンクシティ",
        "underwaterWorld": "水中ワールド",
        "timelapseArt": "タイムラプスアート",
        "dailyVlog": "デイリーVlog",
        "cookingShow": "料理番組",
        "fitnessCoach": "フィットネスコーチ",
        "travelDiary": "旅行ダイアリー",
        "fashionShow": "ファッションショー",
        "petParadise": "ペットパラダイス",
        "weddingMoment": "ウェディングモーメント",
        "yogaFlow": "ヨガフロー",
        "homeDecor": "ホームデコレーション",
        "sunsetRun": "サンセットラン",
        "instagramReels": "Instagramリール",
        "youtubeIntro": "YouTubeイントロ",
        "linkedinPromo": "LinkedInプロモ",
        "aiThumbnail": "AIサムネイル",
        "podcastClip": "ポッドキャストクリップ",
        "horrorShort": "ホラーショート",
        "danceVideo": "ダンス動画",
        "aiComic": "AIコミック",
        "magicShow": "マジックショー",
        "fantasyWorld": "ファンタジーワールド",
        "diyCraft": "DIYクラフト",
        "morningRoutine": "モーニングルーティン",
        "babyGrowth": "ベビーの成長",
        "streetFood": "ストリートフード",
        "bookTrailer": "ブックトレーラー",
        "socialLuxuryBag": "ラグジュアリーバッグ",
        "socialFashionVote": "ファッション投票",
        "socialSneakerDrop": "アーバンラグジュアリースニーカー",
        "socialTropicalCocktail": "週末のカクテル",
        "socialCityBillboard": "シティビルボード広告",
        "socialStreetwearDrop": "ストリートウェアドロップ",
        "socialBoxingGloves": "ボクシンググローブ広告",
        "homeEclecticLiving": "エクレクティック リビング",
        "homeFarmhouseKitchen": "ファームハウス キッチン",
        "homeModernKitchen": "モダン ミニマル キッチン",
        "homeVictorianStairs": "ヴィクトリアン階段",
        "homeScandiLiving": "スカンジナビアン リビング",
        "homeMediterraneanPatio": "地中海風パティオ",
        "homeBohoSunroom": "ボヘミアン サンルーム",
        "homeEclecticBedroom": "エクレクティック ベッドルーム",
        "comicPortrait": "スーパーヒーロー漫画",
        "animeCharacter": "メカアニメ",
        "mangaScene": "雨夜の漫画",
        "comicOilPainting": "日常漫画",
        "comicCover": "エナジーヒーロー漫画",
        "animePortrait": "屋上飛翔漫画",
        "comicCouple": "少年ヒーロー漫画",
        "mangaWarrior": "魔法使い漫画"
      }
    }
  },
  "musicTags": {
    "pop": "ポップ",
    "electronic": "エレクトロニック",
    "classical": "クラシック",
    "jazz": "ジャズ"
  },
  "music": {
    "breadcrumb": {
      "home": "ホーム",
      "aiMusic": "AI音楽"
    },
    "model": {
      "label": "モデル",
      "aiMusicName": "AI音楽",
      "desc": "説明からオリジナル音楽を生成。様々なスタイルと長さをサポート。",
      "tagMusic": "音楽生成",
      "tagLyrics": "歌詞作成"
    },
    "mode": {
      "describe": "説明",
      "lyrics": "歌詞を書く"
    },
    "form": {
      "musicDesc": "音楽の説明",
      "musicDescPlaceholder": "作りたい音楽のスタイル、感情、シーンを説明...\n\n例：未来感のあるシンセサイザーメロディを持つ軽快なエレクトロニック音楽、テック製品のプロモーション動画に適しています",
      "optimize": "最適化",
      "songTitle": "曲名",
      "songTitlePlaceholder": "曲名を入力...",
      "lyricsDescLabel": "歌詞の説明",
      "lyricsDescPlaceholder": "歌詞の説明をここに書いてください...\n\n例：\n[Intro]\n...\n[Verse]\n...\n[Chorus]\n...",
      "styleTags": "スタイルタグ",
      "styleTagsPlaceholder": "下のタグをクリックして追加（複数選択可）"
    },
    "tags": {
      "sections": [
        {
          "label": "Verse",
          "value": "[Verse]\n"
        },
        {
          "label": "Chorus",
          "value": "[Chorus]\n"
        },
        {
          "label": "Bridge",
          "value": "[Bridge]\n"
        },
        {
          "label": "Intro",
          "value": "[Intro]\n"
        },
        {
          "label": "Outro",
          "value": "[Outro]\n"
        }
      ],
      "styles": [
        {
          "label": "Pop",
          "value": "Pop"
        },
        {
          "label": "Rock",
          "value": "Rock"
        },
        {
          "label": "Jazz",
          "value": "Jazz"
        },
        {
          "label": "Classical",
          "value": "Classical"
        },
        {
          "label": "Electronic",
          "value": "Electronic"
        },
        {
          "label": "R&B",
          "value": "R&B"
        },
        {
          "label": "Hip-Hop",
          "value": "Hip-Hop"
        },
        {
          "label": "Country",
          "value": "Country"
        },
        {
          "label": "Folk",
          "value": "Folk"
        },
        {
          "label": "Ambient",
          "value": "Ambient"
        },
        {
          "label": "Cinematic",
          "value": "Cinematic"
        },
        {
          "label": "Lo-fi",
          "value": "Lo-fi"
        },
        {
          "label": "Metal",
          "value": "Metal"
        },
        {
          "label": "Reggae",
          "value": "Reggae"
        },
        {
          "label": "Blues",
          "value": "Blues"
        },
        {
          "label": "Soul",
          "value": "Soul"
        },
        {
          "label": "Funk",
          "value": "Funk"
        },
        {
          "label": "Indie",
          "value": "Indie"
        }
      ]
    },
    "options": {
      "duration": "長さ",
      "instrumental": "インストゥルメンタル",
      "instrumentalDescOn": "伴奏のみ生成、ボーカルなし",
      "instrumentalDescOff": "ボーカルパフォーマンスを含む"
    },
    "errors": {
      "titleRequired": "曲名は必須です",
      "lyricsDescRequired": "歌詞の説明は必須です"
    },
    "footer": {
      "creditsRequired": "必要クレジット：",
      "creditsLeft": "残り：",
      "generate": "音楽を生成"
    },
    "preview": {
      "generating": "音楽を生成中...",
      "generatedTitle": "生成された音楽",
      "emptyTitle": "AI音楽ジェネレーター",
      "emptySubtitle": "AIでオリジナル音楽を作成。スタイルを説明するか歌詞を入力し、数秒で曲を生成できます。",
      "emptyTags": [
        "Pop",
        "Jazz",
        "Cinematic",
        "Lo-fi",
        "Rock"
      ],
      "track": "トラック",
      "play": "再生",
      "pause": "一時停止",
      "mute": "ミュート",
      "unmute": "ミュート解除",
      "download": "ダウンロード",
      "showLyrics": "歌詞を表示",
      "hideLyrics": "歌詞を隠す",
      "generateFailed": "生成に失敗しました",
      "requestFailed": "リクエストに失敗しました。再度お試しください",
      "downloadMp3": "MP3をダウンロード",
      "downloadWav": "WAVをダウンロード",
      "regenerate": "再生成",
      "noHistory": "履歴はまだありません"
    },
    "intro": {
      "title": "AI音楽ジェネレーター",
      "desc": "高度なAI技術を使用して、説明や歌詞を入力するだけで高品質なオリジナル音楽を生成。様々な音楽スタイルをサポートし、動画のサウンドトラック、広告、ポッドキャストなどに適しています。",
      "tagMusic": "音楽生成",
      "tagLyrics": "歌詞作成",
      "tagStyles": "複数スタイル対応",
      "tagCommercial": "商用ライセンス"
    },
    "features": {
      "badge": "コア機能",
      "title": "AI音楽ジェネレーターで何ができますか？",
      "items": {
        "styles": {
          "icon": "🎵",
          "title": "複数スタイル対応",
          "desc": "ポップ、ロック、エレクトロニック、ジャズ、クラシック、ヒップホップなど数十種類の音楽スタイルをサポートし、様々な創作ニーズに対応。"
        },
        "lyrics": {
          "icon": "📝",
          "title": "歌詞作成",
          "desc": "歌詞を入力すると完全な曲を生成。セクションマーカー（Verse、Chorusなど）をサポートし、AIが自動的に編曲・制作。"
        },
        "vocals": {
          "icon": "🎤",
          "title": "ボーカル合成",
          "desc": "男性、女性など様々な音色をサポートし、AIが歌詞を歌い、自然でスムーズな結果を提供。"
        },
        "instrumental": {
          "icon": "🎹",
          "title": "インストゥルメンタルモード",
          "desc": "高品質なインストゥルメンタル伴奏を生成し、動画のサウンドトラックやポッドキャストのBGMなどに適しています。"
        },
        "fast": {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "高度なAIモデルが迅速な音楽制作を保証し、ほとんどの音楽は30秒以内に生成可能。"
        },
        "commercial": {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての音楽は商用目的で使用でき、動画、広告、ポッドキャストなどに対応。"
        }
      }
    },
    "faq": {
      "title": "よくある質問",
      "items": {
        "howItWorks": {
          "q": "AI音楽ジェネレーターはどのように機能しますか？",
          "a": "AI音楽ジェネレーターは高度なディープラーニングモデルを使用して、テキストの説明や歌詞に基づいてオリジナル音楽を作成します。音楽のスタイル、感情、シーンの説明を入力するだけで、AIが完全な音楽作品を自動的に作曲します。"
        },
        "commercial": {
          "q": "生成された音楽は商用目的で使用できますか？",
          "a": "はい、当プラットフォームを使用して生成されたすべての音楽は商用目的で使用でき、YouTube動画、広告、ポッドキャスト、ゲームなどに対応しています。"
        },
        "styles": {
          "q": "どの音楽スタイルがサポートされていますか？",
          "a": "ポップ、ロック、エレクトロニック、ジャズ、クラシック、ヒップホップ、R&B、カントリー、メタル、フォークなど数十種類の音楽スタイルをサポートしています。複数のスタイルを組み合わせてユニークな音楽を作成することもできます。"
        },
        "credits": {
          "q": "各生成に必要なクレジットは？",
          "a": "選択したモデルに応じて、各生成には8〜10クレジットが必要です。サブスクリプションプランでより良いクレジット単価を得ることができます。"
        },
        "download": {
          "q": "生成された音楽はダウンロードできますか？",
          "a": "はい、生成された音楽はMP3とWAVの両方の形式でダウンロード可能です。ニーズに応じて適切な形式を選択できます。"
        }
      }
    },
    "demoTracks": {
      "summerBreeze": {
        "title": "夏のそよ風",
        "style": "ポップ / 軽快",
        "duration": "2:00"
      },
      "spaceJourney": {
        "title": "宇宙の旅",
        "style": "エレクトロニック / 未来感",
        "duration": "1:30"
      },
      "rainWalk": {
        "title": "雨の中の散歩",
        "style": "ジャズ / リラックス",
        "duration": "2:30"
      },
      "mountainDawn": {
        "title": "山の夜明け",
        "style": "クラシック / 静寂",
        "duration": "3:00"
      }
    }
  },
  "pricing": {
    "title": "インスピレーションに限界なく、あなたに最適なプランを選択",
    "subtitle": "すべてのAIモデルをアンロックし、画像、動画、音楽を一括生成。",
    "promo": "期間限定オファー — 年間プランで30%節約",
    "monthly": "月額",
    "yearly": "年額",
    "yearlyNote": "年間プラン — クレジット一括付与、一回払いでお得",
    "popular": "人気No.1",
    "currentPlan": "現在のプラン",
    "currentPlanBtn": "現在のプラン",
    "upgrade": "アップグレード",
    "unavailable": "利用不可",
    "upgradeSuccess": "アップグレード成功！",
    "upgradeFailed": "アップグレード失敗",
    "upgradeModal": {
      "title": "アップグレードの確認",
      "item1": "差額をお客様のカードに請求いたします。",
      "item2": "支払い成功後、追加残高が自動的に追加されます。",
      "item3": "新しいプランは支払い成功後に有効になります。",
      "tip": "ヒント：お支払い方法が有効であることをご確認ください。支払い成功後、残高は数秒以内に増加します。",
      "cancel": "キャンセル",
      "confirm": "アップグレードを確認"
    },
    "subscribe": "今すぐ購読",
    "processing": "処理中...",
    "creditsPer": "クレジット /",
    "extraCredits": "追加クレジット",
    "creditsRate": "100クレジット = $",
    "perMonth": "月",
    "perYear": "年",
    "yearlyBilling": "年額請求",
    "saveVsMonthly": "月額と比較して節約：",
    "planDesc": {
      "basic": "入門に最適",
      "pro": "クリエイターとプロフェッショナルに最適",
      "ultimate": "チームとパワーユーザー向け"
    },
    "creditsPack": {
      "title": "クレジットパックを購入",
      "subtitle": "一回購入、サブスクリプション不要",
      "buy": "クレジットを購入",
      "oneTime": "一回購入",
      "permanent": "クレジットは永久有効",
      "tip": "ヒント：サブスクリプションの方がお得",
      "tipItems": [
        "クレジット単価が低い（40〜60%節約）",
        "すべてのクレジットパックが15%オフ"
      ]
    },
    "security": {
      "noTraining": "AIトレーニングに不使用",
      "encrypted": "暗号化ストレージ",
      "gdpr": "GDPR準拠",
      "delete": "セルフアカウント削除"
    },
    "dataSafety": "データセキュリティの取り組みについて →",
    "allPlansInclude": "すべてのプランに含まれるもの",
    "includes": {
      "models": "プレミアムAIモデル",
      "fast": "高速生成",
      "privacy": "100%プライバシー",
      "commercial": "商用利用"
    },
    "creditsInfo": {
      "title": "クレジットガイド",
      "subtitle": "すべてのモデルのクレジット消費を表示",
      "model": "モデル",
      "type": "タイプ",
      "cost": "クレジット消費",
      "speed": "速度",
      "image": "画像",
      "video": "動画"
    },
    "questions": "ご質問がありますか？",
    "contact": "お困りですか？",
    "contactUs": "お問い合わせ",
    "faq": {
      "items": [
        {
          "q": "クレジットで何を作成できますか？",
          "a": "クレジットはAI画像、動画、音楽の生成に使用できます。画像生成は2クレジットから、動画生成は10クレジットから、音楽は1曲あたり10クレジットです。プレミアムモデルはより多くのクレジットを消費する場合があります。"
        },
        {
          "q": "いつでもキャンセルできますか？",
          "a": "はい、サブスクリプションはいつでもキャンセルできます。現在の請求期間が終了するまでサービスを継続してご利用いただけます。"
        },
        {
          "q": "クレジットがなくなったらどうなりますか？",
          "a": "クレジットパックをいつでも購入できます（サブスクリプション不要）。サブスクライバーはクレジットパックが15%オフになります。また、より良い単価で月間割り当てを増やすためにプランをアップグレードすることもできます。"
        },
        {
          "q": "返金ポリシーはありますか？",
          "a": "はい。一回パッケージの初回購入または初回サブスクリプションの場合、7暦日以内かつクレジット使用量が3%未満であれば返金をリクエストできます。"
        }
      ]
    }
  },
  "modelDetail": {
    "breadcrumb": {
      "home": "ホーム",
      "models": "モデル"
    },
    "model": "モデル",
    "modelVersion": "モデルバージョン",
    "standard": "スタンダード",
    "pro": "プロ",
    "standardDesc": "標準品質、高速生成",
    "proDesc": "高品質、高解像度対応",
    "credits": "クレジット",
    "imagePrompt": "画像プロンプト",
    "imagePromptPlaceholder": "生成したい画像を説明...",
    "videoPrompt": "動画プロンプト",
    "videoPromptPlaceholder": "生成したい動画を説明...",
    "referenceImage": "参照画像",
    "aspectRatio": "アスペクト比",
    "thinkingLevel": "思考レベル",
    "thinkingMinimal": "低遅延",
    "thinkingHigh": "高忠実度",
    "characters": "文字",
    "imageSize": "画像サイズ",
    "auto": "自動",
    "resolution": "解像度",
    "duration": "長さ",
    "seconds": "秒",
    "creditsRequired": "必要クレジット：",
    "remaining": "残り：",
    "getMoreCredits": "クレジットを取得",
    "generate": "生成",
    "generating": "生成中...",
    "demoPrompt": "デモプロンプト",
    "modelLabel": "モデル：",
    "version": "バージョン：",
    "size": "サイズ：",
    "download": "ダウンロード",
    "regenerate": "再生成",
    "noHistory": "生成履歴はありません",
    "features": {
      "badge": "コア機能",
      "title": "このモデルで何ができますか？",
      "items": {
        "realistic": {
          "icon": "📷",
          "title": "リアルスタイル",
          "desc": "自然なライティングとディテールでフォトリアリスティックな画像を生成。"
        },
        "artistic": {
          "icon": "🎨",
          "title": "アートスタイル",
          "desc": "様々な絵画スタイルでアート画像を作成。"
        },
        "portrait": {
          "icon": "👤",
          "title": "ポートレート",
          "desc": "自然な肌色でプロフェッショナルなポートレート写真。"
        },
        "landscape": {
          "icon": "🏔️",
          "title": "風景",
          "desc": "驚くべき風景と自然写真。"
        },
        "product": {
          "icon": "📦",
          "title": "製品",
          "desc": "EC向け高品質製品写真。"
        },
        "fast": {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの画像は10〜30秒以内に生成。"
        },
        "highRes": {
          "icon": "🖼️",
          "title": "高解像度",
          "desc": "最大4K解像度出力をサポート。"
        },
        "cinematic": {
          "icon": "🎬",
          "title": "映画級",
          "desc": "プロのカメラワークで映画級の動画を作成。"
        },
        "audioSync": {
          "icon": "🔊",
          "title": "音声同期",
          "desc": "動画のネイティブ音声・映像同期。"
        },
        "lipSync": {
          "icon": "👄",
          "title": "リップシンク",
          "desc": "キャラクター動画の正確なリップシンク。"
        },
        "animation": {
          "icon": "🎭",
          "title": "アニメーション",
          "desc": "スムーズなキャラクターアニメーションと動き。"
        },
        "longVideo": {
          "icon": "⏱️",
          "title": "長尺動画",
          "desc": "より長い動画時間をサポート。"
        },
        "privacy": {
          "icon": "🔒",
          "title": "Privacy & security",
          "desc": "All data is encrypted in transit and not used for AI training. Your creations belong to you."
        }
      }
    },
    "faq": {
      "title": "よくある質問",
      "items": [
        {
          "q": "このモデルは何に最適ですか？",
          "a": "このモデルはリアルなディテールと自然なライティングで高品質な画像を生成するのに優れています。ポートレート写真、製品画像、アート作品に最適です。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "スタンダード版は1生成あたり5クレジット、プロ版はより高品質と解像度オプションで20クレジットです。"
        },
        {
          "q": "どの解像度がサポートされていますか？",
          "a": "スタンダード版は最大2K解像度をサポート。プロ版は最大4K解像度で、より詳細なディテールを提供します。"
        },
        {
          "q": "生成にはどのくらい時間がかかりますか？",
          "a": "ほとんどの画像は複雑さと解像度設定に応じて10〜30秒以内に生成されます。"
        }
      ],
      "imageType": "images",
      "videoType": "videos",
      "imageFormats": "PNG, JPEG, and WebP output formats are supported; choose what fits your workflow.",
      "videoFormats": "Videos are delivered as MP4 with 480p and 720p options and multiple aspect ratios."
    },
    "qwenImage20Pro": {
      "negativePromptLabel": "ネガティブプロンプト（任意）",
      "negativePromptPlaceholder": "出したくない内容を説明（例：低解像度、変形した手など）",
      "customWidth": "幅",
      "customHeight": "高さ",
      "sizeHint": "範囲：512×512 ～ 2048×2048",
      "sizeErrorRequired": "幅と高さを入力してください",
      "sizeErrorInteger": "幅と高さは整数である必要があります",
      "sizeErrorRange": "解像度は 512×512 ～ 2048×2048 の範囲である必要があります",
      "promptEnhanceTitle": "プロンプト強化",
      "promptEnhanceDesc": "より豊かな出力のために、プロンプトの詳細を強化します",
      "watermarkTitle": "透かし",
      "watermarkDesc": "生成された画像に透かしを追加します",
      "demoPromptText": "雪山の間を、スキーウェアとゴーグルを着けた少年がスキー板で気持ちよく滑走し、滑痕に沿って雪の粒が舞い上がり、背後には連なる雪に覆われた山並みが広がる。",
      "faqSizeSupportQ": "どの解像度がサポートされていますか？",
      "faqSizeSupportA": "入力する幅と高さは 512～2048 の範囲である必要があります（例：2048*2048）。",
      "faqMaxCountQ": "最大で1回に何枚生成できますか？",
      "faqMaxCountA": "最大4枚（n=1..4）。",
      "faqLinkUsageQ": "生成後の画像リンクはどう使いますか？",
      "faqLinkUsageA": "DashScope から返された一時URLを先に取得し、当社サーバーにアップロードして、長期間アクセスできるURLを返します。"
    },
    "zImageTurbo": {
      "promptExtendTitle": "プロンプト強化",
      "promptExtendDesc": "より豊かな出力のために、プロンプトの詳細を強化します",
      "customWidth": "幅",
      "customHeight": "高さ",
      "sizeHint": "範囲：512×512 ～ 2048×2048",
      "sizeErrorRequired": "幅と高さを入力してください",
      "sizeErrorInteger": "幅と高さは整数である必要があります",
      "sizeErrorRange": "解像度は 512×512 ～ 2048×2048 の範囲である必要があります",
      "seedLabel": "シード",
      "seedErrorRequired": "シードを入力してください",
      "seedErrorInteger": "シードは整数である必要があります",
      "seedErrorRange": "シード範囲は 0 から 2147483647 までです",
      "tagQuality": "高品質",
      "tagOfficial": "公式直結",
      "tagHighRes": "高解像度",
      "tagSeed": "シード制御",
      "tagPromptExtend": "プロンプト強化",
      "feature1Title": "高品質出力",
      "feature1Desc": "高解像度の画像を生成し、長期アクセス可能なURLとしてアップロードします。",
      "feature2Title": "カスタム解像度",
      "feature2Desc": "幅と高さを 512～2048 の範囲で入力できます。",
      "feature3Title": "生成の制御",
      "feature3Desc": "シードとプロンプト強化で再現性とチューニングを支援します。",
      "demoPromptText": "きめ細かな黄金色の砂浜に、はっきりした足跡が画面の奥へと続く。縁には湿った砂の粒感があり、砂面は陽光で細かくきらめき、遠くの灯台へと視線を導く。",
      "faqSizeSupportQ": "どの解像度がサポートされていますか？",
      "faqSizeSupportA": "入力する幅と高さは 512～2048 の範囲である必要があります（例：1024*1536）。",
      "faqSeedQ": "シードは何に使いますか？",
      "faqSeedA": "同じプロンプトとパラメータで、シードにより近い結果を再現しやすくなります。",
      "faqPromptExtendQ": "プロンプト強化とは？",
      "faqPromptExtendA": "有効にすると、より豊かな出力のためにプロンプトの詳細を強化します。"
    },
    "creditsRemaining": "Remaining:",
    "whyChoose": {
      "items": [
        "Smart creation powered by {name}",
        "Complete complex creative tasks quickly and efficiently",
        "Generated content can be used commercially",
        "Continuous updates and improving capabilities",
        "Unified credit system, pay as you go"
      ]
    }
  },
  "modelIntro": {
    "common": {
      "videoMode": "動画モード",
      "textToVideo": "テキストから動画",
      "imageToVideo": "画像から動画",
      "referenceImage": "参照画像",
      "referenceAudio": "参照オーディオ",
      "negativePrompt": "ネガティブプロンプト",
      "duration": "再生時間",
      "resolution": "解像度",
      "aspectRatio": "アスペクト比",
      "seed": "シード",
      "generateAudio": "音声生成",
      "watermark": "透かしを追加",
      "endFrame": "エンドフレーム",
      "promptEnhance": "プロンプト強化",
      "promptExtend": "プロンプト拡張",
      "imageSize": "画像サイズ",
      "imageCount": "生成枚数",
      "style": "スタイル",
      "sizeMode": "サイズモード",
      "width": "幅",
      "height": "高さ",
      "optional": "任意",
      "uploading": "アップロード中...",
      "clickToUpload": "クリックしてアップロード",
      "quality": "画質",
      "qualityAuto": "自動",
      "qualityLow": "低画質",
      "qualityMedium": "標準",
      "qualityHigh": "高画質",
      "multipleOf64Hint": "幅と高さは64の倍数である必要があります。"
    },
    "seegen": {
      "aspectAdaptive": "自動",
      "genMode": "生成モード",
      "modeStand": "標準",
      "modeSpeed": "高速"
    },
    "pollodance": {
      "variantLabel": "モデルバリアント",
      "card20": "2.0",
      "card20Fast": "2.0 FAST",
      "card20Ref": "2.0 REF",
      "card20FastRef": "2.0 FAST REF",
      "opt20Desc": "高度なモーション制御、映画級スタイル変換、産業級動画生成。",
      "opt20FastDesc": "高速生成・低遅延処理。",
      "opt20RefDesc": "動画間参照、スタイル転送、被写体トラッキング。",
      "opt20FastRefDesc": "高速生成と精密な参照制御の両立。",
      "refImages": "参照画像（複数可）",
      "refVideo": "参照動画",
      "refAudio": "参照音声",
      "webSearch": "ウェブ検索"
    },
    "nanoBanana": {
      "version": "モデルバージョン",
      "title": "Nano Banana Pro AI画像ジェネレーター",
      "desc": "Nano Bananaは高性能AI画像生成モデルで、リアルスタイルの画像生成をサポートし、ポートレートと自然なシーンに優れています。スタンダードとプロの2つのバージョンで異なるニーズに対応。",
      "v25Type": "低遅延",
      "v25TypeBadge": "高速",
      "v25TypeDesc": "固定1024px解像度、生成スピードが速い",
      "v31Type": "高忠実度",
      "v31TypeBadge": "高品質",
      "v31TypeDesc": "1K/2K/4Kの複数解像度に対応",
      "demoPrompt": "シネマティックなポートレート、ゴールデンアワーの光、自然な肌の質感、柔らかいボケ味の背景",
      "multiSize": "複数サイズ",
      "multiSizeDesc": "自動、1:1、4:3、3:4、16:9、9:16、3:2、2:3など様々な画像サイズをサポート。",
      "featuresDesc": "Nano Bananaは複数のサイズと解像度オプションで高品質な画像生成能力を提供。",
      "flexiblePricing": "柔軟な価格設定",
      "flexiblePricingDesc": "スタンダード5クレジット、プロ20クレジット、必要に応じて選択。",
      "commercial": "商用ライセンス",
      "commercialDesc": "生成されたすべての画像は商用目的で使用可能。",
      "enterPrompt": "プロンプトを入力してください",
      "generateFailed": "生成に失敗しました",
      "requestFailed": "リクエストに失敗しました。再度お試しください",
      "faq": [
        {
          "q": "スタンダードとプロの違いは？",
          "a": "スタンダード版は標準品質の画像を素早く生成するのに適しており、5クレジットを消費します。プロ版はより高い解像度（1K/2K/4K）とより高い画像品質をサポートし、20クレジットを消費します。"
        },
        {
          "q": "Nano Bananaはどのように機能しますか？",
          "a": "テキストの説明を入力するだけで、Nano Bananaモデルがプロンプトに基づいて高品質なリアルスタイルの画像を生成します。"
        },
        {
          "q": "どの画像サイズがサポートされていますか？",
          "a": "自動、1:1（正方形）、4:3、3:4、16:9（横長）、9:16（縦長）、3:2、2:3など様々なサイズをサポートしています。"
        },
        {
          "q": "生成された画像は商用目的で使用できますか？",
          "a": "はい、Nano Bananaを使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "nanoBanana2": {
      "genType": "生成バージョン"
    },
    "seedream": {
      "title": "Seedream 4 AI画像ジェネレーター",
      "desc": "Seedream 4は高度なAI画像生成モデルで、アートとクリエイティブな画像に特化しています。イラスト、コンセプトアート、スタイル化されたビジュアルに最適。",
      "webSearch": "ウェブ検索",
      "webSearchDesc": "より正確な参照情報のためにウェブ検索を有効化",
      "watermark": "透かしを追加",
      "watermarkDesc": "生成画像に透かしを追加",
      "sizeModeResolution": "解像度で指定",
      "sizeModeCustom": "カスタムサイズ",
      "customWidth": "幅",
      "customHeight": "高さ",
      "sizeHint": "面積 1024×1024～4096×4096、アスペクト比 1/16～16",
      "sizeErrorArea": "面積は1024×1024から4096×4096の範囲である必要があります",
      "sizeErrorRatio": "アスペクト比は1/16から16の範囲である必要があります",
      "demoPromptExample": "午後の横光がキャンプテントを照らし、テント生地の粗い質感がはっきり見える。中にはジャーマンシェパードが伏せ、飼い主がしゃがんで握手している。",
      "features": [
        {
          "icon": "🎨",
          "title": "アートスタイル",
          "desc": "様々な絵画やイラストスタイルで驚くべきアート画像を生成。"
        },
        {
          "icon": "🖼️",
          "title": "高解像度",
          "desc": "最大4K解像度をサポートし、詳細なアートワークに。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの画像は15秒以内に生成。"
        },
        {
          "icon": "🎭",
          "title": "スタイル転送",
          "desc": "様々なアートスタイルを創作に適用。"
        },
        {
          "icon": "📐",
          "title": "複数サイズ",
          "desc": "様々なアスペクト比で異なるニーズに対応。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての画像は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Seedream 4は何に最適ですか？",
          "a": "Seedream 4はアートとクリエイティブな画像の生成に優れており、イラスト、コンセプトアート、スタイル化されたビジュアルを含みます。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Seedream 4を使用すると1生成あたり8クレジットを消費します。サブスクリプションプランでより良いクレジット単価を得ることができます。"
        },
        {
          "q": "どのスタイルがサポートされていますか？",
          "a": "Seedream 4は油絵、水彩、デジタルアート、アニメなど様々なアートスタイルをサポートしています。"
        },
        {
          "q": "生成された画像は商用目的で使用できますか？",
          "a": "はい、Seedream 4を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "midjourney": {
      "title": "Midjourney AI画像ジェネレーター",
      "desc": "Midjourneyは卓越したアート品質とクリエイティブ能力で知られる主要なAI画像生成モデルです。プロフェッショナルなアート作品とクリエイティブプロジェクトに最適。",
      "referenceBoxTitle": "参照画像を追加（画像から画像）",
      "referenceBoxSubtitle": "PNG、JPEG、WEBP対応（最大100KB）。最大5枚。枚数が少ないほど精度が高くなります。",
      "demoPrompt": "空に浮かぶ神秘的な浮遊島、光る水晶に覆われた古代の廃墟、雲の下へ流れ落ちる滝、幻想的な光、ファンタジーアートスタイル",
      "referenceImages": "参照画像",
      "referenceImagesCount": "最大5枚",
      "refImageMaxSize": "各画像は100KBを超えてはいけません",
      "style": "スタイル",
      "styleRealistic": "リアル",
      "styleAnime": "アニメ",
      "generationSpeed": "生成速度",
      "fastDesc": "標準速度で生成",
      "turboDesc": "高速生成、優先処理",
      "creative": "クリエイティブ",
      "highQuality": "高品質",
      "fastTurbo": "Fast/Turbo",
      "creativeGeneration": "クリエイティブ生成",
      "speed": "速度",
      "features": [
        {
          "icon": "🎨",
          "title": "アートの卓越性",
          "desc": "業界をリードするアート品質とクリエイティブな出力。"
        },
        {
          "icon": "🖼️",
          "title": "高解像度",
          "desc": "プロフェッショナルな使用に適した高品質画像を生成。"
        },
        {
          "icon": "🎭",
          "title": "ユニークなスタイル",
          "desc": "作品を際立たせる独特なアートスタイル。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの画像は20秒以内に生成。"
        },
        {
          "icon": "📐",
          "title": "複数サイズ",
          "desc": "様々なアスペクト比と解像度をサポート。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての画像は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "FastとTurboの違いは？",
          "a": "Fastモードは10クレジットで標準速度。Turboモードは20クレジットでより高速な生成と優先処理。"
        },
        {
          "q": "Midjourneyはどのように機能しますか？",
          "a": "テキストの説明を入力するだけで、Midjourneyがプロンプトに基づいてアート画像を生成します。"
        },
        {
          "q": "どの画像サイズがサポートされていますか？",
          "a": "1:1（正方形）、4:3、3:4、16:9（横長）、9:16（縦長）、3:2、2:3など様々なサイズをサポートしています。"
        },
        {
          "q": "生成された画像は商用目的で使用できますか？",
          "a": "はい、Midjourneyを使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "gptImage": {
      "title": "GPT-Image-1 AI画像ジェネレーター",
      "desc": "GPT-Image-1はOpenAIの多目的画像生成モデルで、テキストの説明から様々な画像を作成できます。一般的な画像生成に最適。",
      "demoPromptExample": "夕暮れのトスカーナの野原、黄金の麦波がうねる丘陵、遠くに糸杉と古い石造りの農家、夕日が空を暖かな赤に染める、癒し系、風景写真、ゴールデンアワー。",
      "imageCount": "画像枚数",
      "promptEnhance": "プロンプト強化",
      "promptEnhanceDesc": "より良い生成結果のためにプロンプトを自動最適化",
      "count": "枚数",
      "multiPurpose": "マルチパーパス",
      "batchGeneration": "バッチ生成",
      "size1024Square": "1024×1024（正方形）",
      "size1536Landscape": "1536×1024（横長）",
      "size1024Portrait": "1024×1536（縦長）",
      "threeSizes": "3つの固定サイズ",
      "tagQuality": "高品質",
      "tagCommercialShort": "商用利用",
      "features": [
        {
          "icon": "🎨",
          "title": "多目的生成",
          "desc": "あらゆる目的のために様々な画像を作成。"
        },
        {
          "icon": "🖼️",
          "title": "高品質",
          "desc": "正確なディテールで高品質な画像を生成。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの画像は15秒以内に生成。"
        },
        {
          "icon": "📝",
          "title": "テキスト理解",
          "desc": "複雑なテキストの説明を優れた理解。"
        },
        {
          "icon": "📐",
          "title": "3つの固定サイズ",
          "desc": "1024×1024（正方形）、1536×1024（横長）、1024×1536（縦長）。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての画像は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "GPT-Image-1はどのように機能しますか？",
          "a": "テキストの説明を入力するだけで、GPT-Image-1がプロンプトに基づいて高品質な画像を生成します。"
        },
        {
          "q": "どの画像サイズがサポートされていますか？",
          "a": "1024×1024（正方形）、1536×1024（横長）、1024×1536（縦長）の3つの固定サイズをサポートしています。"
        },
        {
          "q": "生成された画像は商用目的で使用できますか？",
          "a": "はい、GPT-Image-1を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "gptImage15": {
      "title": "GPT-Image-1.5 AI画像ジェネレーター",
      "desc": "GPT-Image-1.5はOpenAIの多目的画像生成モデルで、テキストの説明から様々な画像を作成できます。一般的な画像生成に最適。",
      "demoPromptExample": "夕暮れのトスカーナの野原、黄金の麦波がうねる丘陵、遠くに糸杉と古い石造りの農家、夕日が空を暖かな赤に染める、癒し系、風景写真、ゴールデンアワー。",
      "imageCount": "画像枚数",
      "promptEnhance": "プロンプト強化",
      "promptEnhanceDesc": "より良い生成結果のためにプロンプトを自動最適化",
      "count": "枚数",
      "multiPurpose": "マルチパーパス",
      "batchGeneration": "バッチ生成",
      "size1024Square": "1024×1024（正方形）",
      "size1536Landscape": "1536×1024（横長）",
      "size1024Portrait": "1024×1536（縦長）",
      "threeSizes": "3つの固定サイズ",
      "tagQuality": "高品質",
      "tagCommercialShort": "商用利用",
      "features": [
        {
          "icon": "🎨",
          "title": "多目的生成",
          "desc": "あらゆる目的のために様々な画像を作成。"
        },
        {
          "icon": "🖼️",
          "title": "高品質",
          "desc": "正確なディテールで高品質な画像を生成。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの画像は15秒以内に生成。"
        },
        {
          "icon": "📝",
          "title": "テキスト理解",
          "desc": "複雑なテキストの説明を優れた理解。"
        },
        {
          "icon": "📐",
          "title": "3つの固定サイズ",
          "desc": "1024×1024（正方形）、1536×1024（横長）、1024×1536（縦長）。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての画像は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "GPT-Image-1.5はどのように機能しますか？",
          "a": "テキストの説明を入力するだけで、GPT-Image-1.5がプロンプトに基づいて高品質な画像を生成します。"
        },
        {
          "q": "どの画像サイズがサポートされていますか？",
          "a": "1024×1024（正方形）、1536×1024（横長）、1024×1536（縦長）の3つの固定サイズをサポートしています。"
        },
        {
          "q": "生成された画像は商用目的で使用できますか？",
          "a": "はい、GPT-Image-1.5を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "fluxKontext": {
      "title": "Flux Kontext AI画像ジェネレーター",
      "desc": "Flux Kontextのトップクラスの描画力を体感。最大2Kの圧倒的なリアル映像風画像を、プロ品質の審美と質感で。",
      "imageCount": "画像枚数",
      "count": "枚数",
      "demoPrompt1": "ゴールデンアワー、屋上に座る若い女性、オーバーサイズのデニムジャケット、首に白いヘッドフォン、透明なプラスチックカップでアイスコーヒーを飲んでいる。短いカールヘアが風に揺れ、遠くで街の灯りが灯り始める。",
      "demoPrompt2": "20代前半の男性が散らかったアトリエの床に座り、未完成のキャンバスと絵の具のチューブに囲まれている。色のついた白いタンクトップと破れたジーンズを着ている。",
      "demoPrompt3": "ピクニックシートに座り、赤ちゃんのビーニーを直している若い母親。クリーム色のセーターと長いコーデュロイスカート、裸足で草の上。",
      "highQuality": "高品質",
      "fastGen": "高速生成",
      "multiSize": "複数サイズ",
      "outputStyle": "出力スタイル",
      "outputStyleDesc": {
        "auto": "デフォルト — モデルが自動でスタイルを判断し、強制しません",
        "photographic": "写真風リアル — 実写の質感、自然な光と影",
        "digital_art": "デジタルアート/イラスト — CG/イラスト調、鮮やかな色",
        "anime": "アニメ/二次元風 — 日本のアニメ調、線がきれい"
      },
      "outputStyleLabel": {
        "auto": "デフォルト",
        "photographic": "写実",
        "digital_art": "アート",
        "anime": "二次元"
      },
      "features": [
        {
          "icon": "✨",
          "title": "高品質出力",
          "desc": "ディテール豊かで忠実な画像を生成。"
        },
        {
          "icon": "🎨",
          "title": "テキストから画像",
          "desc": "テキスト説明から正確に画像を生成。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの画像が約15秒で完成。"
        },
        {
          "icon": "📐",
          "title": "複数サイズ",
          "desc": "1:1、3:2、2:3のアスペクト比に対応。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成画像は商用利用可能。"
        }
      ],
      "faq": [
        {
          "q": "Flux Kontextはどのように機能しますか？",
          "a": "テキスト説明を入力すると、Flux Kontextが高品質な画像を生成します。1リクエストで1枚または複数枚に対応。"
        },
        {
          "q": "どの画像サイズがサポートされていますか？",
          "a": "1:1（正方形）、3:2（横長）、2:3（縦長）。"
        },
        {
          "q": "一度に複数枚生成できますか？",
          "a": "はい、1〜3枚を選択でき、各枚は個別課金です。"
        },
        {
          "q": "生成された画像は商用利用できますか？",
          "a": "はい、Flux Kontextで生成したコンテンツは商用利用できます。"
        }
      ]
    },
    "fluxPro11Ultra": {
      "title": "Flux Pro 1.1 Ultra AI画像ジェネレーター",
      "desc": "Flux Pro 1.1 Ultra は高品質テキストから画像。複数アスペクト比とバッチ生成に対応。",
      "imageCount": "画像枚数",
      "count": "枚数",
      "demoPrompt1": "ゴールデンアワー、屋上に座る若い女性、オーバーサイズのデニムジャケット、首に白いヘッドフォン、透明なプラスチックカップでアイスコーヒーを飲んでいる。短いカールヘアが風に揺れ、遠くで街の灯りが灯り始める。",
      "demoPrompt2": "20代前半の男性が散らかったアトリエの床に座り、未完成のキャンバスと絵の具のチューブに囲まれている。色のついた白いタンクトップと破れたジーンズを着ている。",
      "demoPrompt3": "ピクニックシートに座り、赤ちゃんのビーニーを直している若い母親。クリーム色のセーターと長いコーデュロイスカート、裸足で草の上。",
      "highQuality": "高品質",
      "fastGen": "高速生成",
      "multiSize": "複数サイズ",
      "outputStyle": "出力スタイル",
      "outputStyleDesc": {
        "auto": "デフォルト — モデルが自動でスタイルを判断し、強制しません",
        "photographic": "写真風リアル — 実写の質感、自然な光と影",
        "digital_art": "デジタルアート/イラスト — CG/イラスト調、鮮やかな色",
        "anime": "アニメ/二次元風 — 日本のアニメ調、線がきれい"
      },
      "outputStyleLabel": {
        "auto": "デフォルト",
        "photographic": "写実",
        "digital_art": "アート",
        "anime": "二次元"
      },
      "features": [
        {
          "icon": "✨",
          "title": "高品質出力",
          "desc": "ディテール豊かで忠実な画像を生成。"
        },
        {
          "icon": "🎨",
          "title": "テキストから画像",
          "desc": "テキスト説明から正確に画像を生成。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの画像が約15秒で完成。"
        },
        {
          "icon": "📐",
          "title": "複数サイズ",
          "desc": "21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成画像は商用利用可能。"
        }
      ],
      "faq": [
        {
          "q": "Flux Pro 1.1 Ultraはどのように機能しますか？",
          "a": "テキスト説明を入力して高品質画像を生成。1リクエストで1〜4枚。"
        },
        {
          "q": "どの画像サイズがサポートされていますか？",
          "a": "21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21。"
        },
        {
          "q": "一度に複数枚生成できますか？",
          "a": "はい、1〜4枚、各枚は個別課金です。"
        },
        {
          "q": "生成された画像は商用利用できますか？",
          "a": "はい、商用利用可能です。"
        }
      ]
    },
    "fluxSchnell": {
      "title": "Flux Schnell AI画像ジェネレーター",
      "desc": "Flux Schnell は高速テキストから画像。複数アスペクト比とバッチ生成に対応。",
      "imageCount": "画像枚数",
      "count": "枚数",
      "demoPrompt1": "ゴールデンアワー、屋上に座る若い女性、オーバーサイズのデニムジャケット、首に白いヘッドフォン、透明なプラスチックカップでアイスコーヒーを飲んでいる。短いカールヘアが風に揺れ、遠くで街の灯りが灯り始める。",
      "demoPrompt2": "20代前半の男性が散らかったアトリエの床に座り、未完成のキャンバスと絵の具のチューブに囲まれている。色のついた白いタンクトップと破れたジーンズを着ている。",
      "demoPrompt3": "ピクニックシートに座り、赤ちゃんのビーニーを直している若い母親。クリーム色のセーターと長いコーデュロイスカート、裸足で草の上。",
      "highQuality": "高品質",
      "fastGen": "高速生成",
      "multiSize": "複数サイズ",
      "outputStyle": "出力スタイル",
      "outputStyleDesc": {
        "auto": "デフォルト — モデルが自動でスタイルを判断し、強制しません",
        "photographic": "写真風リアル — 実写の質感、自然な光と影",
        "digital_art": "デジタルアート/イラスト — CG/イラスト調、鮮やかな色",
        "anime": "アニメ/二次元風 — 日本のアニメ調、線がきれい"
      },
      "outputStyleLabel": {
        "auto": "デフォルト",
        "photographic": "写実",
        "digital_art": "アート",
        "anime": "二次元"
      },
      "features": [
        {
          "icon": "✨",
          "title": "高品質出力",
          "desc": "ディテール豊かで忠実な画像を生成。"
        },
        {
          "icon": "🎨",
          "title": "テキストから画像",
          "desc": "テキスト説明から正確に画像を生成。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの画像が約15秒で完成。"
        },
        {
          "icon": "📐",
          "title": "複数サイズ",
          "desc": "21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成画像は商用利用可能。"
        }
      ],
      "faq": [
        {
          "q": "Flux Schnellはどのように機能しますか？",
          "a": "テキスト説明を入力して素早く高品質画像を生成。1リクエストで1〜4枚。"
        },
        {
          "q": "どの画像サイズがサポートされていますか？",
          "a": "21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21。"
        },
        {
          "q": "一度に複数枚生成できますか？",
          "a": "はい、1〜4枚、各枚は個別課金です。"
        },
        {
          "q": "生成された画像は商用利用できますか？",
          "a": "はい、商用利用可能です。"
        }
      ]
    },
    "flux2": {
      "title": "FLUX.2 AI 画像ジェネレーター",
      "desc": "FLUX.2 はエンタープライズ級の効率とプロ品質の精度を実現し、フォトリアルなディテール、正確な手・顔・テクスチャを生成します。",
      "variantLabel": "モデルバリアント",
      "variantDesc": {
        "klein-04": "リアルタイム",
        "klein-09": "バランス型",
        "max": "最高品質",
        "pro": "プロダクション",
        "flex": "カスタマイズ可能"
      },
      "promptUpsampling": "プロンプトアップサンプリング",
      "promptUpsamplingHint": "プロンプトのディテールを強化し、より豊かな出力を生成します（Kleinモデルでは非対応）。",
      "steps": "ステップ数",
      "stepsHint": "ステップ数が高いほどディテールが増えますが、処理時間が長くなります。Flexバリアントのみ。",
      "guidance": "ガイダンス",
      "guidanceHint": "出力がプロンプトにどれだけ従うかを制御します。Flexバリアントのみ。",
      "tagPhotorealism": "フォトリアリズム",
      "tagMultilingual": "多言語対応",
      "tagVariants": "5バリアント",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "features": [
        { "icon": "✨", "title": "フォトリアルなディテール", "desc": "手、顔、布、ロゴ、小物を最大4MP解像度で正確に再現。" },
        { "icon": "🎨", "title": "タイポグラフィとデザイン", "desc": "明瞭で読みやすいタイポグラフィをレンダリングし、複雑なレイアウト指示に従います。" },
        { "icon": "🌍", "title": "多言語対応", "desc": "母語でのプロンプト入力に対応し、最先端の指示追従を実現。" },
        { "icon": "🎯", "title": "5つのモデルバリアント", "desc": "Klein 4B/9B（速度重視）、Max（最高品質）、Pro（スケール対応）、Flex（カスタム制御）。" },
        { "icon": "⚙️", "title": "柔軟な制御", "desc": "ステップ数、ガイダンス、サイズ、安全性トレランスを調整可能。" }
      ],
      "faq": [
        { "q": "FLUX.2にはどのようなモデルバリアントがありますか？", "a": "FLUX.2には5つのバリアントがあります：Klein 4Bと9B（高速・大量）、Max（最高品質、グラウンディング検索付き）、Pro（プロダクションスケール）、Flex（ステップ・ガイダンス調整可能）。" },
        { "q": "対応画像サイズは？", "a": "FLUX.2はピクセル寸法（幅x高さ）を使用し、16の倍数である必要があります。1:1、4:3、3:4、16:9、9:16、21:9、9:21のプリセットがあります。" },
        { "q": "プロンプトアップサンプリングとは？", "a": "有効にすると、モデルが内部でプロンプトを強化し、より豊かなディテールを生成します。Max、Pro、Flexバリアントで利用可能（Kleinは非対応）。" },
        { "q": "Flexモードのステップ数とガイダンスとは？", "a": "ステップ数（1-50）は推論品質を制御します（高いほど詳細だが遅い）。ガイダンス（1.5-10）はプロンプトへの従順度を制御します（高いほどプロンプトに近い）。" },
        { "q": "生成した画像を商用利用できますか？", "a": "はい、生成されたコンテンツは商用利用可能です。" }
      ]
    },
    "seedance": {
      "title": "Seedance AI動画ジェネレーター",
      "desc": "Seedanceは次世代AI動画モデルで、ネイティブ音声同期、映画級の動き、感情表現をサポートしています。テキストから動画、画像から動画、動画拡張モードをカバー。",
      "textToVideo": "テキストから動画",
      "imageToVideo": "画像から動画",
      "videoExtend": "動画拡張",
      "uploadImage": "クリックして参照画像をアップロード",
      "uploadHint": "PNG, JPG, JPEG（最大20MB）",
      "endFrame": "エンドフレーム画像",
      "endFrameHint": "（オプション）エンドフレームをアップロードして動画の終了を制御",
      "uploadEndFrame": "クリックしてエンドフレーム画像をアップロード",
      "uploadVideo": "クリックして参照動画をアップロード",
      "uploadVideoHint": "MP4, MOV, WebM（最大100MB）",
      "videoPrompt": "動画プロンプト",
      "promptPlaceholder": "生成したい動画を説明...",
      "videoPromptPlaceholder": "生成したい動画を説明...",
      "negativePrompt": "ネガティブプロンプト",
      "negativePromptPlaceholder": "動画に入れたくない内容を説明（オプション）",
      "duration": "長さ",
      "videoDuration": "動画の長さ",
      "resolution": "解像度",
      "aspectRatio": "アスペクト比",
      "promptEnhance": "プロンプト強化",
      "promptEnhanceDesc": "より良い生成結果のためにプロンプトを自動最適化",
      "generateAudio": "音声生成",
      "audioOn": "ネイティブ音声（音声+効果音）",
      "audioOff": "動画のみ、音声なし",
      "seedValue": "シード（ランダムシード）",
      "seedHint": "シード値は作品全体のスタイルを識別する一意のキーです。同じシード値を入力するとスタイルを維持でき、他のパラメータを微調整することで画面の細部を最適化できます。",
      "seedPlaceholder": "-1（ランダム）",
      "characters": "文字",
      "creditsRequired": "必要クレジット：",
      "creditsRemaining": "残り：",
      "remaining": "残り：",
      "getMoreCredits": "クレジットを取得",
      "generate": "生成",
      "generating": "生成中...",
      "demoPrompt": "デモプロンプト",
      "demoPromptExample": "ふわふわの白い子猫が、つま先でうれしそうに踊る。小さなピンクの肉球を持ち上げて、やさしく体を揺らす。あたたかな黄色い照明の下、柔らかなカーペットの上で。癒し系のカートゥーン調、細部まで丁寧に、やさしく落ち着いた色合い。",
      "modelLabel": "モデル：",
      "durationLabel": "長さ：",
      "techSpecsTitle": "技術仕様",
      "techSpecsDesc": "Seedanceはネイティブ音声同期、映画級の動き、感情表現をサポート。テキストから動画、画像から動画、動画拡張モードをカバー。",
      "t2vTitle": "テキストから動画（T2V）",
      "t2vDesc": "プロンプトを映画級の動画シーンに変換",
      "i2vTitle": "画像から動画（I2V）",
      "i2vDesc": "AIで単一の画像をアニメーション化",
      "input": "入力：",
      "textPrompt": "テキストプロンプト",
      "imagePrompt": "画像 + プロンプト",
      "audio": "音声：",
      "nativeAudio": "ネイティブ音声生成",
      "bestFor": "最適：",
      "t2vBestFor": "映画級コンテンツ制作、広告、ソーシャルメディア動画に最適。",
      "i2vBestFor": "ポートレートアニメーション、製品ショーケース、クリエイティブコンテンツに最適。",
      "featuresDesc": "デザイナー、マーケター、コンテンツクリエイター、または一般ユーザーであっても、Seedanceは高品質なAIコンテンツを素早く作成するのに役立ちます。",
      "features": [
        {
          "icon": "🎬",
          "title": "ネイティブ音声・映像生成",
          "desc": "動画と音声を一度に同期生成し、映画級の品質を提供。自然なリップシンクとダイアログ吹き替え。"
        },
        {
          "icon": "😊",
          "title": "感情駆動表現システム",
          "desc": "新たな感情認識パフォーマンスで、よりリアルな表情を実現。微妙な表情には躊躇、悲しみ、緊張、または感情の抑制が含まれます。"
        },
        {
          "icon": "🎥",
          "title": "監督級カメラコントロール",
          "desc": "プッシュ、プル、パン、オービット、トラッキングなどのカメラ動作をサポート。最初と最後のフレームガイダンスでスムーズなトランジションを実現。"
        },
        {
          "icon": "📱",
          "title": "マルチモーダル入力",
          "desc": "テキストから動画、画像から動画など柔軟なクリエイティブワークフローをサポート。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "最適化された推論エンジンで迅速な制作を保証、ほとんどの動画は数分以内に完了。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能、広告やソーシャルメディアに適しています。"
        }
      ],
      "enterPrompt": "プロンプトを入力してください",
      "imageRequired": "画像から動画モードには参照画像が必要です",
      "videoRequired": "動画拡張モードには参照動画が必要です",
      "generateFailed": "生成に失敗しました",
      "requestFailed": "リクエストに失敗しました。再度お試しください",
      "faq": [
        {
          "q": "Seedanceはどのように機能しますか？",
          "a": "参照画像をアップロードするか、テキストの説明を直接入力すると、Seedanceモデルが指示に基づいて高品質な動画コンテンツを生成し、音声も同期されます。プロセスはシンプルで直感的、プロのスキルは不要です。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Seedanceを使用して生成されたすべてのコンテンツは商用目的で使用でき、マーケティング資料、ソーシャルメディア、製品ショーケースなどに適しています。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Seedanceを使用すると1生成あたり18クレジットを消費します。サブスクリプションプランでより良いクレジット単価を得ることができます。"
        },
        {
          "q": "生成速度はどうですか？",
          "a": "Seedanceの平均生成速度は約1.5分です。インフラを継続的に最適化し、高速で安定した生成体験を確保しています。"
        },
        {
          "q": "どの出力形式がサポートされていますか？",
          "a": "動画はMP4形式で出力され、480p、720p、1080pの解像度をサポート、長さは5秒または10秒を選択可能、複数のアスペクト比をサポートしています。"
        }
      ]
    },
    "veo": {
      "title": "Veo 3.1 AI動画ジェネレーター",
      "desc": "Google Veo 3.1は最先端のAI動画モデルで、ネイティブ音声生成、超高解像度、長尺動画制作をサポートしています。プロフェッショナルな動画制作に最適。",
      "fastType": "高速タイプ",
      "fastTypeBadge": "高速、低コスト",
      "fastTypeDesc": "（16:9参照画像をサポート）",
      "qualityType": "品質タイプ",
      "qualityTypeBadge": "より豊富なディテール",
      "qualityTypeDesc": "よりスムーズな動き。画像モードのエンドフレームはオプションで、最後のフレームを制御。",
      "imageMode": "生成モード",
      "startEndFrames": "スタート/エンドフレーム",
      "referenceImage": "参照画像",
      "startFrame": "スタートフレーム",
      "startFrameHint": "最初のフレームを設定。動画はこのフレームからアニメーション化。",
      "uploadStartFrame": "クリックしてスタートフレームをアップロード",
      "endFrame": "エンドフレーム",
      "endFrameHint": "最後のフレームを設定。動画はこのフレームで終了。",
      "uploadEndFrame": "クリックしてエンドフレームをアップロード",
      "negativePrompt": "ネガティブプロンプト",
      "negativePromptPlaceholder": "動画に入れたくない要素を説明...",
      "features": [
        {
          "icon": "🎬",
          "title": "ネイティブ音声生成",
          "desc": "動画と音声を同期生成、ダイアログと効果音を含む。"
        },
        {
          "icon": "📺",
          "title": "超高解像度",
          "desc": "最大4K解像度出力をサポート、プロフェッショナルな動画制作に。"
        },
        {
          "icon": "⏱️",
          "title": "長尺動画対応",
          "desc": "最大2分の動画を生成、様々な創作ニーズに対応。"
        },
        {
          "icon": "🎥",
          "title": "映画級の動き",
          "desc": "プロフェッショナルなカメラ動作とスムーズなトランジション。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "最適化された推論エンジンで迅速な制作。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "高速タイプと品質タイプの違いは？",
          "a": "高速タイプはより迅速で経済的、迅速な反復に適しています。品質タイプはより豊富なディテールとスムーズな動きを生成し、最終出力に適しています。"
        },
        {
          "q": "Veo 3.1はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Veo 3.1が指示に基づいて高品質な動画コンテンツを生成し、オプションで音声も同期生成します。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Veo 3.1を使用すると1生成あたり30クレジットを消費します。サブスクリプションプランでより良いクレジット単価を得ることができます。"
        },
        {
          "q": "どの解像度と長さがサポートされていますか？",
          "a": "720pと1080pの解像度をサポート、長さは5秒、10秒、長尺動画は最大2分まで可能です。"
        }
      ]
    },
    "veo30": {
      "title": "Veo 3.0 AI動画ジェネレーター",
      "desc": "Google Veo 3.0は高度なAI動画モデルで、テキストから動画と画像から動画をサポートし、4秒/6秒/8秒の長さと720p/1080p出力に対応。",
      "fastType": "高速タイプ",
      "fastTypeBadge": "高速、低コスト",
      "fastTypeDesc": "（16:9参照画像をサポート）",
      "qualityType": "品質タイプ",
      "qualityTypeBadge": "より豊富なディテール",
      "qualityTypeDesc": "よりスムーズな動き。画像モードのエンドフレームはオプションで、最後のフレームを制御。",
      "imageMode": "画像モード",
      "startEndFrames": "スタート/エンドフレーム",
      "referenceImage": "参照画像",
      "referenceImageHint": "参照画像をアップロード、動画はこの画像に基づいて生成されます。",
      "uploadReferenceImage": "クリックして参照画像をアップロード",
      "startFrame": "スタートフレーム",
      "startFrameHint": "最初のフレームを設定。動画はこのフレームからアニメーション化。",
      "uploadStartFrame": "クリックしてスタートフレームをアップロード",
      "endFrame": "エンドフレーム",
      "endFrameHint": "最後のフレームを設定。動画はこのフレームで終了。",
      "uploadEndFrame": "クリックしてエンドフレームをアップロード",
      "negativePrompt": "ネガティブプロンプト",
      "negativePromptPlaceholder": "動画に入れたくない要素を説明...",
      "seedRangeError": "シードは0〜2147483647の整数である必要があります",
      "duration": "長さ",
      "resolution": "解像度",
      "demoPrompt": "カフェの窓際でノートにスケッチする10代の少女、ガラスを叩く雨...",
      "features": [
        {
          "icon": "🎬",
          "title": "ネイティブ音声生成",
          "desc": "動画と音声を同期生成、ダイアログと効果音を含む。"
        },
        {
          "icon": "📺",
          "title": "HD解像度",
          "desc": "720p、1080p出力をサポート、プロフェッショナルな動画制作に。"
        },
        {
          "icon": "⏱️",
          "title": "複数の長さ",
          "desc": "4秒、6秒、8秒の動画生成をサポート。"
        },
        {
          "icon": "🎥",
          "title": "映画級の動き",
          "desc": "プロフェッショナルなカメラ動作とスムーズなトランジション。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "最適化された推論エンジンで迅速な制作。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "高速タイプと品質タイプの違いは？",
          "a": "高速タイプはより迅速で経済的、迅速な反復に適しています。品質タイプはより豊富なディテールとスムーズな動きを生成し、最終出力に適しています。"
        },
        {
          "q": "Veo 3.0はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Veo 3.0が指示に基づいて高品質な動画コンテンツを生成し、オプションで音声も同期生成します。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Veo 3.0を使用すると1生成あたり25クレジットを消費します。サブスクリプションプランでより良いクレジット単価を得ることができます。"
        },
        {
          "q": "どの解像度と長さがサポートされていますか？",
          "a": "720pと1080pの解像度をサポート、長さは4秒、6秒、または8秒を選択可能。"
        }
      ]
    },
    "veo31fast": {
      "title": "Veo 3.1 Fast AI動画ジェネレーター",
      "desc": "Google Veo 3.1 Fast高速版、テキストから動画と画像から動画をサポート、オプションのテールフレーム、4秒/6秒/8秒の長さと720p/1080p/4K出力に対応。",
      "referenceImage": "参照画像",
      "referenceImageHint": "参照画像をアップロード、動画はこの画像に基づいて生成されます。",
      "uploadReferenceImage": "クリックして参照画像をアップロード",
      "endFrame": "テールフレーム",
      "endFrameHint": "オプション。動画の最後のフレームに対応する画像を設定し、終了画面を制御。",
      "uploadEndFrame": "クリックしてテールフレームをアップロード",
      "duration": "長さ",
      "resolution": "解像度",
      "seedRangeError": "シードは0〜2147483647の整数である必要があります",
      "demoPrompt": "カフェの窓際でノートにスケッチする10代の少女、ガラスを叩く雨...",
      "features": [
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "最適化された推論で、より迅速な出力。"
        },
        {
          "icon": "📺",
          "title": "4K解像度",
          "desc": "720p、1080p、4K出力をサポート。"
        },
        {
          "icon": "⏱️",
          "title": "複数の長さ",
          "desc": "4秒、6秒、8秒の動画をサポート。"
        },
        {
          "icon": "🖼️",
          "title": "オプションのテールフレーム",
          "desc": "画像から動画でテールフレームをアップロードして終了を制御。"
        },
        {
          "icon": "🎥",
          "title": "映画級の動き",
          "desc": "プロフェッショナルなカメラ動作とスムーズなトランジション。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Veo 3.1 FastとVeo 3.1の違いは？",
          "a": "Veo 3.1 Fastは高速版で、生成速度がより速く、クレジット消費が低く、4Kとオプションのテールフレームをサポートしています。"
        },
        {
          "q": "テールフレームとは何ですか？",
          "a": "画像から動画の場合、テールフレーム画像をアップロードして、動画がそのフレームで終了するようにし、終了を制御できます。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Veo 3.1 Fastを使用すると1生成あたり20クレジットを消費します。"
        },
        {
          "q": "どの解像度と長さがサポートされていますか？",
          "a": "720p、1080p、4Kの解像度をサポート、長さは4秒、6秒、または8秒を選択可能。"
        }
      ]
    },
    "kling": {
      "title": "Kling 2.6 AI動画ジェネレーター",
      "desc": "Kling 2.6は高性能AI動画モデルで、テキストから動画と画像から動画をサポートし、優れた動き品質と高速生成を実現。",
      "features": [
        {
          "icon": "🎬",
          "title": "高品質な動き",
          "desc": "スムーズで自然な動きとプロフェッショナルな品質出力。"
        },
        {
          "icon": "📱",
          "title": "複数のアスペクト比",
          "desc": "1:1、16:9、9:16など複数のアスペクト比をサポート。"
        },
        {
          "icon": "🔊",
          "title": "音声生成",
          "desc": "オプションのネイティブ音声生成で完全な動画体験。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの動画は2分以内に生成。"
        },
        {
          "icon": "🖼️",
          "title": "画像から動画",
          "desc": "AIパワードの動きで静止画をアニメーション化。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Kling 2.6はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Kling 2.6が指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Kling 2.6を使用すると1生成あたり28クレジットを消費します。サブスクリプションプランでより良いクレジット単価を得ることができます。"
        },
        {
          "q": "どの解像度と長さがサポートされていますか？",
          "a": "720pと1080pの解像度をサポート、長さは5秒と10秒を選択可能。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Kling 2.6を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "kling3": {
      "title": "Kling 3.0 AI動画ジェネレーター",
      "desc": "Kling 3.0は高性能AI動画モデルで、テキストから動画と画像から動画をサポートし、優れた動き品質と高速生成を実現。",
      "features": [
        {
          "icon": "🎬",
          "title": "高品質な動き",
          "desc": "スムーズで自然な動きとプロフェッショナルな品質出力。"
        },
        {
          "icon": "📱",
          "title": "複数のアスペクト比",
          "desc": "1:1、16:9、9:16など複数のアスペクト比をサポート。"
        },
        {
          "icon": "🔊",
          "title": "音声生成",
          "desc": "オプションのネイティブ音声生成で完全な動画体験。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "ほとんどの動画は2分以内に生成。"
        },
        {
          "icon": "🖼️",
          "title": "画像から動画",
          "desc": "AIパワードの動きで静止画をアニメーション化。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Kling 3.0はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Kling 3.0が指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Kling 3.0を使用すると1生成あたり28クレジットを消費します。サブスクリプションプランでより良いクレジット単価を得ることができます。"
        },
        {
          "q": "どの解像度と長さがサポートされていますか？",
          "a": "720pと1080pの解像度をサポート、長さは5秒と10秒を選択可能。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Kling 3.0を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "sora": {
      "title": "Sora 2 AI動画ジェネレーター",
      "desc": "Sora 2はOpenAIの先進的なAI動画モデルで、リアルな動きと映画級の品質を持つ高品質な動画を生成できます。",
      "demoPromptExample": "@sama OpenAIのCEOサムがこのキャビネット（収納家具）を紹介し、自宅と同じものでとても便利だと話している。",
      "landscape": "横長",
      "portrait": "縦長",
      "removeWatermark": "透かし除去",
      "enabled": "有効",
      "disabled": "無効",
      "noWatermark": "透かしなし",
      "cinematic": "映画品質",
      "restrictedAccess": "アクセス制限",
      "60secDuration": "4秒 / 8秒 / 12秒",
      "photorealistic": "フォトリアル",
      "physicsSimulation": "物理シミュレーション",
      "features": [
        {
          "icon": "🎬",
          "title": "映画品質",
          "desc": "プロの映画のような外観と感触の動画を生成。"
        },
        {
          "icon": "🎥",
          "title": "リアルな動き",
          "desc": "キャラクターとシーンの自然でリアルな動き。"
        },
        {
          "icon": "⏱️",
          "title": "柔軟な長さ",
          "desc": "様々なニーズに対応する複数の動画長をサポート。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "迅速な動画制作ワークフローに最適化。"
        },
        {
          "icon": "🖼️",
          "title": "マルチモーダル入力",
          "desc": "テキストから動画と画像から動画モードをサポート。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Sora 2はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Sora 2が指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Sora 2を使用すると1生成あたり15クレジットを消費します。サブスクリプションプランでより良いクレジット単価を得ることができます。"
        },
        {
          "q": "Sora 2の特別な点は？",
          "a": "Sora 2はリアルな動きと映画級の品質の動画生成に優れており、プロフェッショナルなコンテンツ制作に最適です。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Sora 2を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "wan": {
      "title": "Wan AI動画ジェネレーター",
      "desc": "Wanは多目的AI動画モデルで、テキストから動画と画像から動画をサポートし、優れた品質と速度を実現。",
      "multiFormat": "複数形式",
      "smoothMotion": "スムーズな動き",
      "referenceAudio": "参照音声",
      "uploadAudio": "クリックして参照音声をアップロード",
      "uploadAudioHint": "MP3, WAV, M4A（オプション、動画のサウンドトラックを駆動）",
      "features": [
        {
          "icon": "🎬",
          "title": "高品質出力",
          "desc": "テキストまたは画像からプロフェッショナル品質の動画を生成。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "効率的な動画制作ワークフロー。"
        },
        {
          "icon": "📱",
          "title": "複数形式",
          "desc": "様々なアスペクト比と解像度をサポート。"
        },
        {
          "icon": "🖼️",
          "title": "画像アニメーション",
          "desc": "AIの動きで静止画に命を吹き込む。"
        },
        {
          "icon": "🎥",
          "title": "スムーズな動き",
          "desc": "生成動画内の自然で滑らかな動き。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Wanはどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Wanが指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "どのWanバージョンを使用すべきですか？",
          "a": "Wan 2.5と2.6は最新機能と最高品質を提供します。Wan 2.2はシンプルなプロジェクトのための経済的な選択肢です。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Wan 2.6は70クレジット、Wan 2.5は60クレジット、Wan 2.2は10クレジットを消費します。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Wanを使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "wan25": {
      "title": "Wan 2.5 AI動画ジェネレーター",
      "desc": "Wan 2.5は多目的AI動画モデルで、テキストから動画と画像から動画をサポートし、優れた品質と速度を実現。",
      "features": [
        {
          "icon": "🎬",
          "title": "高品質出力",
          "desc": "テキストまたは画像からプロフェッショナル品質の動画を生成。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "効率的な動画制作ワークフロー。"
        },
        {
          "icon": "📱",
          "title": "複数形式",
          "desc": "様々なアスペクト比と解像度をサポート。"
        },
        {
          "icon": "🖼️",
          "title": "画像アニメーション",
          "desc": "AIの動きで静止画に命を吹き込む。"
        },
        {
          "icon": "🎥",
          "title": "スムーズな動き",
          "desc": "生成動画内の自然で滑らかな動き。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Wan 2.5はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Wan 2.5が指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "Wan 2.5とWan 2.6の違いは？",
          "a": "Wan 2.6は品質と安定性がさらに向上しています。Wan 2.5はコストパフォーマンスが高く、ほとんどのユースケースに適しています。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Wan 2.5は1生成あたり60クレジットを消費します。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Wan 2.5を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "wan26": {
      "title": "Wan 2.6 AI動画ジェネレーター",
      "desc": "Wan 2.6は強化版AI動画モデルで、品質と安定性が全面的に向上し、テキストから動画と画像から動画をサポート。",
      "features": [
        {
          "icon": "🎬",
          "title": "高品質出力",
          "desc": "テキストまたは画像からプロフェッショナル品質の動画を生成、品質が向上。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "効率的な動画制作ワークフロー。"
        },
        {
          "icon": "📱",
          "title": "複数形式",
          "desc": "様々なアスペクト比と解像度をサポート。"
        },
        {
          "icon": "🖼️",
          "title": "画像アニメーション",
          "desc": "AIの動きで静止画に命を吹き込む。"
        },
        {
          "icon": "🎥",
          "title": "スムーズな動き",
          "desc": "生成動画内の自然で滑らかな動き。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Wan 2.6とWan 2.5の違いは？",
          "a": "Wan 2.6は品質と安定性がさらに向上しており、より高品質な出力が必要なシーンに適しています。"
        },
        {
          "q": "Wan 2.6はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Wan 2.6が指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Wan 2.6は1生成あたり70クレジットを消費します。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Wan 2.6を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "wan22": {
      "title": "Wan 2.2 クラシック AI動画ジェネレーター",
      "desc": "Wan 2.2はクラシック版AI動画モデルで、テキストから動画と画像から動画をサポートし、安定した信頼性の高い動画生成能力を提供し、コストパフォーマンスに優れています。",
      "demoPromptExample": "夕暮れの屋上に座る、そばかすと赤い乱れた髪の少女。少し擦れたデニムジャケット、手にはポラロイドカメラ、背後には柔らかな色に輝く街のスカイライン。",
      "resolutionBadge": "720p",
      "costEffective": "コストパフォーマンス",
      "classicVersion": "クラシック版",
      "stableReliable": "安定・信頼性",
      "features": [
        {
          "icon": "🎬",
          "title": "テキスト/画像から動画",
          "desc": "テキストから動画と画像から動画の両モードをサポート、長さは5秒または8秒を選択可能。"
        },
        {
          "icon": "⚡",
          "title": "安定・信頼性",
          "desc": "十分にテストされたクラシックモデルで、安定した信頼性の高い結果を生成。"
        },
        {
          "icon": "💰",
          "title": "コストパフォーマンス",
          "desc": "クレジット消費が低く、バッチコンテンツ制作とテストに最適。"
        },
        {
          "icon": "📐",
          "title": "アスペクト比オプション",
          "desc": "16:9と9:16のアスペクト比をサポート、様々なシーンに対応。"
        },
        {
          "icon": "🎥",
          "title": "720p解像度",
          "desc": "ほとんどのアプリケーションに適した720p解像度出力を提供。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Wan 2.2とWan 2.5の違いは？",
          "a": "Wan 2.2はクラシックモデルでクレジット消費が低く、大量生成が必要だが最高品質は求められないシーンに適しています。Wan 2.5はより多くの機能を備えたアップデート版です。"
        },
        {
          "q": "Wan 2.2はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Wan 2.2が指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Wan 2.2を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "kling25": {
      "title": "Kling 2.5 AI動画ジェネレーター",
      "desc": "Kling 2.5は標準版AI動画モデルで、テキストから動画と画像から動画をサポートし、安定した信頼性の高い動画生成を提供し、コストパフォーマンスに優れています。",
      "standard": "標準",
      "reliable": "安定・信頼性",
      "costEffective": "コストパフォーマンス",
      "standardQuality": "標準品質",
      "textToVideo": "テキストから動画",
      "imageToVideo": "画像から動画",
      "referenceImage": "参照画像",
      "referenceImageHint": "クリックしてアップロードまたはファイルをドラッグ＆ドロップ",
      "referenceImageFormats": "PNG、JPG、JPEG、WEBP形式対応（≤10MB）、URLアップロードのみ",
      "endFrame": "エンドフレーム",
      "endFrameOptional": "オプション",
      "endFrameFormats": "PNG, JPG, JPEG",
      "endFrameHint": "動画の終了フレームを制約するために使用、参照画像と同じアスペクト比でより良い効果",
      "videoPrompt": "動画プロンプト",
      "promptPlaceholder": "生成したい動画を説明してください...",
      "negativePrompt": "ネガティブプロンプト",
      "negativePromptPlaceholder": "動画に含めたくない内容を説明してください...",
      "duration": "長さ",
      "aspectRatio": "アスペクト比",
      "uploading": "アップロード中...",
      "clickToUpload": "クリックしてアップロード",
      "clickToUploadReference": "クリックして参照画像をアップロード",
      "clickToUploadEndFrame": "クリックしてエンドフレーム画像をアップロード",
      "remove": "削除",
      "creditsRequired": "必要クレジット：",
      "remaining": "残り：",
      "generate": "生成",
      "generating": "生成中...",
      "demoPrompt": "デモプロンプト",
      "demoPromptExample": "アップロードしたSF路地の画像を最初のフレームに。同じ路地、ネオンサイン、反射、フードを被った女性が歩き去る構図を保ち、カメラをゆっくり路地の奥へ進める……",
      "model": "モデル：",
      "durationLabel": "長さ：",
      "introTitle": "Kling 2.5標準版で高品質AI動画を生成",
      "featuresBadge": "コア機能",
      "featuresTitle": "{name}でできること",
      "faqTitle": "よくある質問",
      "errorPromptRequired": "プロンプトを入力してください",
      "errorImageRequired": "画像から動画モードでは参照画像のアップロードが必要です",
      "errorGenerationFailed": "生成に失敗しました",
      "errorRequestFailed": "リクエストに失敗しました",
      "errorUploadFailed": "アップロードに失敗しました、再試行してください",
      "features": [
        {
          "icon": "🎬",
          "title": "テキスト/画像から動画",
          "desc": "テキストから動画と画像から動画の両モードをサポート、長さは5秒または10秒を選択可能。"
        },
        {
          "icon": "⚡",
          "title": "安定・信頼性",
          "desc": "十分にテストされた標準モデルで、安定した信頼性の高い結果を生成。"
        },
        {
          "icon": "💰",
          "title": "コストパフォーマンス",
          "desc": "Kling 2.6に比べてクレジット消費が低く、バッチコンテンツ制作に最適。"
        },
        {
          "icon": "📐",
          "title": "複数のアスペクト比",
          "desc": "1:1、16:9、9:16のアスペクト比をサポート、様々なシーンに対応。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Kling 2.5とKling 2.6の違いは？",
          "a": "Kling 2.5は標準モデルでクレジット消費が低く、大量生成が必要だが最高品質は求められないシーンに適しています。Kling 2.6はネイティブオーディオと完璧なリップシンクをサポートする最新版です。"
        },
        {
          "q": "Kling 2.5はどのように機能しますか？",
          "a": "テキストの説明を入力するか参照画像をアップロードすると、Kling 2.5が指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Kling 2.5を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    },
    "viduq3pro": {
      "title": "Vidu Q3 Pro AI動画",
      "desc": "Vidu Q3 Proは、テキスト/画像から動画を生成。解像度・1〜16秒・アスペクト比・音声オプションに対応。",
      "imageUrlHint": "HTTPSの画像URLのみ（アップロードで公開URLを取得）。画像のアスペクト比は1:4〜4:1の範囲内である必要があります。",
      "lengthLabel": "長さ（秒）",
      "optional": "任意",
      "tagHighQuality": "高品質",
      "tagLength": "1〜16秒",
      "tagResolution": "最大2K",
      "demoPromptExample": "朝日の遊歩道、ジョギングする人々、海面をかすめるカモメ、遠くのヨット。",
      "features": [
        { "icon": "🎬", "title": "テキストと画像", "desc": "プロンプトまたは参照画像から生成。" },
        { "icon": "📐", "title": "アスペクト比", "desc": "テキストモード：16:9、9:16、1:1、4:3、3:4。" },
        { "icon": "⏱️", "title": "柔軟な長さ", "desc": "1〜16秒から選択。" },
        { "icon": "🎵", "title": "音声オプション", "desc": "自然な音声付き出力を有効化可能。" },
        { "icon": "🎲", "title": "シード", "desc": "任意のシードで再現性を高められます。" }
      ],
      "faq": [
        { "q": "画像から動画の要件は？", "a": "公開HTTPSの画像URL（JPG/PNG）。極端な縦横比（1:4または4:1を超える）は不可です。" },
        { "q": "テキストと画像モードの違いは？", "a": "テキストはアスペクト比を指定。画像は参照URLを使用し、テキスト用のアスペクト比は送りません。" },
        { "q": "クレジットは？", "a": "ページに表示されるルールに従い、長さ・解像度・音声設定に応じて計算されます。" }
      ]
    },
    "wanAnimate": {
      "title": "Wan Animate",
      "desc": "参照画像と動画でキャラクターアニメーション。標準/プロ品質、オプションで透かし。",
      "refImageLabel": "参照画像",
      "refImageHint": "アニメーション化するキャラクター（JPG/PNG/JPEG/BMP/WEBP、最大5MB、辺200〜4096px、縦横比1:3〜3:1）。",
      "refVideoLabel": "参照動画",
      "refVideoHint": "モーション参照（MP4/AVI/MOV、2〜30秒、最大200MB、辺200〜2048px、縦横比1:3〜3:1）。",
      "animateModeLabel": "アニメーションモード",
      "modeAnimate": "画像から動作",
      "modeReplace": "動画で人物差し替え",
      "referenceVideo": "参照動画",
      "btnAnimate": "アニメート",
      "animateModeBadgeAnimate": "モーション",
      "animateModeBadgeReplace": "置換",
      "btnAnimateDesc": "画像のキャラクターに動画の動きを合成します。",
      "btnReplace": "置換",
      "btnReplaceDesc": "動画内のキャラクターを画像のキャラクターに差し替えます。",
      "qualityLabel": "画質モード",
      "qualityStd": "標準",
      "qualityPro": "プロ",
      "watermarkLabel": "透かし",
      "uploadVideoRequired": "参照動画をアップロードしてください。",
      "uploadImage": "画像をアップロード",
      "uploadVideo": "動画をアップロード",
      "uploading": "アップロード中…",
      "imageUploadHint": "JPG、PNG、JPEG、BMP、WEBP · 最大5MB",
      "videoUploadHint": "MP4、AVI、MOV · 2〜30秒 · 最大200MB",
      "uploadImageRequired": "参照画像をアップロードしてください。",
      "errImageFileTooLarge": "画像サイズが上限（最大5MB）を超えています。",
      "errImageDimensions": "画像の幅・高さは200〜4096pxである必要があります。",
      "errImageAspect": "画像の縦横比は1:3〜3:1である必要があります。",
      "errImageInvalid": "画像が無効か読み込めません。",
      "errVideoFileTooLarge": "動画サイズが上限（最大200MB）を超えています。",
      "errVideoDuration": "動画の長さは2〜30秒である必要があります。",
      "errVideoDimensions": "動画の幅・高さは200〜2048pxである必要があります。",
      "errVideoAspect": "動画の縦横比は1:3〜3:1である必要があります。",
      "errVideoInvalid": "動画が無効か読み込めません。",
      "defaultModelName": "Wan Animate",
      "demoEmptyHint": "キャラクター画像とモーション動画をアップロードし、Wan Animateで素晴らしいキャラクターアニメーションを作成しましょう。",
      "demoEmptyTitle": "キャラクターアニメーション",
      "demoStepCharacter": "キャラクター",
      "demoStepMotion": "モーション",
      "demoStepAnimate": "アニメーション",
      "faqCredits": "プロモードは標準より消費クレジットが多くなります。ページ上部を参照。",
      "characterAnimation": "キャラクターアニメーション",
      "faceSwap": "フェイススワップ",
      "motionTransfer": "モーション転送",
      "identityReplacement": "アイデンティティ置換",
      "motionAccuracy": "高いモーション再現",
      "features": [
        { "icon": "🎭", "title": "2モード", "desc": "モーション転送またはキャラクター全面置換。" },
        { "icon": "📐", "title": "DashScope公式", "desc": "Alibaba Cloud上のWan 2.2 Animate。" },
        { "icon": "⚡", "title": "標準/プロ", "desc": "タスクごとに品質を選択。" },
        { "icon": "💧", "title": "透かしオプション", "desc": "出力に透かしを付けるか選択。" }
      ],
      "faq": [
        { "q": "必要な入力は？", "a": "アップロード後に公開HTTPSの画像URLと動画URLが必要です。形式・サイズ・縦横比の制限に従ってください。" },
        { "q": "アニメートと置換の違いは？", "a": "アニメートは動画の動きを画像キャラに適用。置換は動画内のキャラを画像のキャラに差し替えます。" },
        { "q": "クレジットは？", "a": "プロは標準より消費が多いです。ページ表示に従います。" }
      ]
    },
    "hailuo": {
      "title": "Hailuo 2.3 AI動画ジェネレーター",
      "desc": "Hailuo 2.3は次世代AI動画モデルで、高品質なテキストから動画生成をサポートし、クリエイティブな動画ソリューションを提供します。",
      "demoPromptExample": "映画のようなワンショット：夕暮れの岩場の海岸に打ち寄せる波、水面に反射する金色の光……",
      "highQuality": "高品質",
      "highQualityOutput": "高品質出力",
      "features": [
        {
          "icon": "🎬",
          "title": "テキストから動画",
          "desc": "テキストの説明を入力するだけで高品質な動画を生成、長さは6秒または10秒を選択可能。"
        },
        {
          "icon": "✨",
          "title": "プロンプト拡張",
          "desc": "プロンプト最適化と安全チェックを有効にし、より良い生成結果のためにプロンプトを自動最適化します。"
        },
        {
          "icon": "🌊",
          "title": "クリエイティブスタイル",
          "desc": "クリエイティブと芸術的な動画コンテンツの生成に優れています。"
        },
        {
          "icon": "⚡",
          "title": "高速生成",
          "desc": "最適化された推論エンジンで迅速な出力を確保。"
        },
        {
          "icon": "🎨",
          "title": "高品質出力",
          "desc": "様々なアプリケーションに適した高品質な動画コンテンツを生成。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Hailuo 2.3はどのように機能しますか？",
          "a": "テキストの説明を入力するだけで、Hailuo 2.3モデルが指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "プロンプト拡張とは何ですか？",
          "a": "プロンプト拡張機能はプロンプトを自動的に最適化し、安全チェックを行い、生成されたコンテンツが規範に準拠していることを確保します。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Hailuo 2.3を使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        },
        {
          "q": "各生成に必要なクレジットは？",
          "a": "Hailuo 2.3を使用すると1生成あたり12クレジットを消費します。"
        }
      ]
    },
    "runway": {
      "title": "Runway AI動画ジェネレーター",
      "desc": "RunwayはプロフェッショナルグレードのAI動画生成ツールで、様々な動画品質、アスペクト比、透かし設定をサポートし、プロのコンテンツクリエイターに最適です。",
      "demoPromptExample": "夕暮れ、シンガポールの建設現場でクレーンのシルエットが鮮やかな夕日を背景に浮かぶ。ヘルメットをかぶった作業員たちが道具を片付け、帰り支度をしている……",
      "professional": "プロ向け",
      "multiOption": "多彩なオプション",
      "highQuality": "高品質",
      "multiFormat": "複数形式",
      "reproducibleSeed": "再現可能なシード",
      "features": [
        {
          "icon": "🎬",
          "title": "テキスト/画像から動画",
          "desc": "テキストから動画と画像から動画の両モードをサポート、長さは5秒または10秒を選択可能。"
        },
        {
          "icon": "📐",
          "title": "複数のアスペクト比",
          "desc": "16:9、9:16、1:1、4:3、3:4、21:9の6つのアスペクト比をサポート、様々なシーンに対応。"
        },
        {
          "icon": "🎲",
          "title": "制御可能なシード",
          "desc": "ランダムシードの設定をサポート、同じ動画効果を再現可能。"
        },
        {
          "icon": "⚡",
          "title": "プロフェッショナル出力",
          "desc": "商用利用に適したプロフェッショナル品質の動画コンテンツを生成。"
        },
        {
          "icon": "🖼️",
          "title": "画像アニメーション",
          "desc": "静止画をダイナミックな映像に。"
        },
        {
          "icon": "💼",
          "title": "商用ライセンス",
          "desc": "生成されたすべての動画は商用目的で使用可能。"
        }
      ],
      "faq": [
        {
          "q": "Runwayはどのように機能しますか？",
          "a": "参照画像をアップロードするか、テキストの説明を入力すると、Runwayが指示に基づいて高品質な動画コンテンツを生成します。"
        },
        {
          "q": "どのアスペクト比がサポートされていますか？",
          "a": "Runwayは16:9（横長）、9:16（縦長）、1:1（正方形）、4:3、3:4、21:9のアスペクト比をサポートしています。"
        },
        {
          "q": "生成された動画は商用目的で使用できますか？",
          "a": "はい、Runwayを使用して生成されたすべてのコンテンツは商用目的で使用できます。"
        }
      ]
    }
  },
  "privacy": {
    "title": "プライバシーポリシー",
    "lastUpdated": "最終更新：2025年1月15日",
    "navTerms": "利用規約 →",
    "navTrust": "信頼と安全 →",
    "sections": [
      {
        "title": "1. 情報の収集",
        "paragraphs": [
          "登録およびサービス利用時に提供された情報（メールアドレス、ユーザー名、支払い情報など）を収集します。",
          "IPアドレス、ブラウザタイプ、アクセス時間、使用機能などの使用データも自動的に収集します。"
        ]
      },
      {
        "title": "2. 情報の使用",
        "paragraphs": [
          "収集した情報を使用して、サービスの提供、維持、改善、取引処理、サービス関連通知の送信、不正および乱用の防止を行います。",
          "お客様の個人情報を第三者に販売することはありません。"
        ]
      },
      {
        "title": "3. AI生成コンテンツ",
        "paragraphs": [
          "アップロードされた画像と入力されたプロンプトは、リクエストされたコンテンツの生成のみに使用され、AIモデルのトレーニングには使用されません。",
          "生成されたコンテンツはダウンロードのためにサーバーに一時保存され、その後データ保持ポリシーに従って削除されます。"
        ]
      },
      {
        "title": "4. データセキュリティ",
        "paragraphs": [
          "SSL暗号化、アクセス制御、定期的なセキュリティ監査など、業界標準のセキュリティ対策を採用してお客様の個人情報を保護します。",
          "データを保護するために最善を尽くしていますが、100%安全なインターネット送信方法はありません。"
        ]
      },
      {
        "title": "5. Cookieの使用",
        "paragraphs": [
          "ユーザー体験の向上、使用状況の分析、パーソナライズされたコンテンツの提供のためにCookieおよび類似技術を使用します。",
          "ブラウザ設定からCookieの設定を管理できます。Cookieを無効にすると、一部の機能に影響する可能性があります。"
        ]
      },
      {
        "title": "6. 第三者サービス",
        "paragraphs": [
          "支払い処理、データ分析、カスタマーサポートなど、サービス提供を支援するために第三者サービスプロバイダーを使用する場合があります。",
          "これらの第三者サービスプロバイダーは、当社のためにサービスを実行するために必要な範囲でのみお客様の個人情報にアクセスします。"
        ]
      },
      {
        "title": "7. お客様の権利",
        "paragraphs": [
          "お客様は個人情報へのアクセス、訂正、削除の権利を有します。また、データの処理の制限または別のサービスへのデータ転送をリクエストする権利もあります。",
          "これらの権利を行使するには、miral_support@miralvis.comまでご連絡ください。30日以内にリクエストにお応えします。"
        ]
      },
      {
        "title": "8. GDPR準拠",
        "paragraphs": [
          "欧州経済領域のユーザーに対して、一般データ保護規則（GDPR）の要件を遵守しています。データ処理の法的根拠には、契約履行、正当な利益、お客様の同意が含まれます。"
        ]
      },
      {
        "title": "9. お問い合わせ",
        "paragraphs": [
          "プライバシーポリシーに関するご質問や懸念がある場合は、miral_support@miralvis.comのデータ保護チームまでご連絡ください。"
        ]
      }
    ]
  },
  "terms": {
    "title": "利用規約",
    "lastUpdated": "最終更新：2025年1月15日",
    "navPrivacy": "プライバシーポリシー →",
    "navTrust": "信頼と安全 →",
    "sections": [
      {
        "title": "1. サービス概要",
        "paragraphs": [
          "Miral（以下「本プラットフォーム」）は、画像、動画、音楽制作を一体化したAIプラットフォームです。本利用規約（以下「本規約」）は、本プラットフォームのサービス利用に関する条件とルールを規定します。",
          "本プラットフォームを利用することにより、お客様は本規約に拘束されることに同意したものとみなされます。本規約に同意されない場合は、本プラットフォームをご利用にならないでください。"
        ]
      },
      {
        "title": "2. アカウント登録",
        "paragraphs": [
          "アカウントを登録するには18歳以上である必要があります。正確かつ完全な登録情報を提供し、アカウントのセキュリティを維持する責任があります。",
          "お客様のアカウントを通じて行われるすべての活動について責任を負います。不正使用を発見した場合は、直ちに当社に通知してください。"
        ]
      },
      {
        "title": "3. サービス利用",
        "paragraphs": [
          "本プラットフォームはクレジットベースのAIコンテンツ生成サービスを提供します。クレジットはサブスクリプションまたは一回購入で取得できます。異なるAIモデルと機能は異なる量のクレジットを消費します。",
          "本プラットフォームを違法、有害、または権利侵害の目的で使用しないことに同意します。違法、ポルノ、暴力的、または他人の権利を侵害するコンテンツの生成は禁止されています。"
        ]
      },
      {
        "title": "4. 知的財産権",
        "paragraphs": [
          "本プラットフォームを通じて生成されたコンテンツの知的財産権はお客様に帰属しますが、各AIモデルプロバイダーの利用規約に従うものとします。",
          "本プラットフォームの商標、ロゴ、インターフェースデザイン、ソフトウェアコードは知的財産法により保護されており、許可なく使用することはできません。"
        ]
      },
      {
        "title": "5. 支払いと返金",
        "paragraphs": [
          "すべての支払いは米ドル建てです。サブスクリプション料金は、選択したプランに応じて月額または年額で請求されます。",
          "一回パッケージの初回購入または初回サブスクリプションの場合、7暦日以内かつクレジット使用量が3%未満であれば返金をリクエストできます。"
        ]
      },
      {
        "title": "6. 免責事項",
        "paragraphs": [
          "本プラットフォームは「現状のまま」サービスを提供し、サービスの可用性、正確性、または適合性について明示または黙示の保証を行いません。",
          "AI生成コンテンツは不正確または不完全な場合があります。ユーザーは生成コンテンツの適用性を自己判断する必要があります。"
        ]
      },
      {
        "title": "7. 責任制限",
        "paragraphs": [
          "法律で許可される最大限の範囲で、本プラットフォームはサービスの使用または使用不能に起因する直接的、間接的、付随的、または結果的な損害について責任を負いません。",
          "本プラットフォームの総責任は、過去12ヶ月間にお客様が支払った総額を超えないものとします。"
        ]
      },
      {
        "title": "8. 規約の変更",
        "paragraphs": [
          "当社はいつでも本規約を変更する権利を留保します。変更された規約は本ページに掲載された時点で効力を生じます。",
          "本プラットフォームの継続使用は、変更された規約への同意を示します。重要な変更は、メールまたはプラットフォーム通知でお知らせします。"
        ]
      },
      {
        "title": "9. お問い合わせ",
        "paragraphs": [
          "本規約に関するご質問がある場合は、miral_support@miralvis.comまでご連絡ください。"
        ]
      }
    ]
  },
  "trustSafety": {
    "tag": "🛡️ 信頼と安全",
    "title": "お客様のデータセキュリティは当社の最優先事項です",
    "subtitle": "当社がお客様のプライバシーとデータセキュリティをどのように保護しているかをご確認ください。",
    "badges": [
      {
        "icon": "🛡️",
        "title": "AIトレーニングに不使用",
        "desc": "アップロードされたコンテンツと生成された作品は、いかなるAIモデルのトレーニングにも使用されません。"
      },
      {
        "icon": "🔒",
        "title": "エンドツーエンド暗号化",
        "desc": "すべてのデータ転送はTLS 1.3暗号化を使用し、保存データはAES-256暗号化を使用しています。"
      },
      {
        "icon": "✓",
        "title": "GDPR準拠",
        "desc": "EU一般データ保護規則の要件に完全準拠しています。"
      },
      {
        "icon": "🗑️",
        "title": "自己データ管理",
        "desc": "アカウント削除を含め、いつでもすべてのデータをエクスポートまたは削除できます。"
      }
    ],
    "sections": [
      {
        "title": "データ処理の透明性",
        "paragraphs": [
          "データの処理方法について完全に透明です。アップロードされた画像と動画は、リクエストされたコンテンツの生成のみに使用され、処理完了後24時間以内にサーバーから削除されます。",
          "生成されたコンテンツはお客様のアカウントに保存され、いつでもダウンロードまたは削除できます。お客様の同意なしにコンテンツを共有することはありません。"
        ]
      },
      {
        "title": "セキュアなインフラ",
        "paragraphs": [
          "当社のサービスは、多層セキュリティ保護を備えた世界をリードするクラウドインフラにデプロイされています。すべてのサーバーはSOC 2およびISO 27001認証データセンターに配置されています。",
          "定期的なセキュリティ監査とペネトレーションテストを実施し、システムのセキュリティを確保しています。すべての従業員は厳格なセキュリティトレーニングを受けています。"
        ]
      },
      {
        "title": "コンテンツセーフティ",
        "paragraphs": [
          "有害なコンテンツの生成を自動的に検出・ブロックする先進的なコンテンツセーフティシステムを展開しています。これには、暴力的、ポルノ、権利侵害コンテンツが含まれますが、これらに限定されません。",
          "違反コンテンツを発見された場合は、abuse@miral.orgまでご報告ください。"
        ]
      },
      {
        "title": "コンプライアンスと認証",
        "paragraphs": [
          "GDPR（EU）、CCPA（カリフォルニア）、LGPD（ブラジル）など、世界の主要なデータ保護規制を遵守しています。",
          "当社の支払い処理はPCI DSS基準に準拠し、お客様の支払い情報のセキュリティを確保しています。"
        ]
      }
    ],
    "ctaTitle": "セキュリティに関する懸念がありますか？",
    "ctaDesc": "セキュリティチームがご質問にお答えします",
    "ctaButton": "セキュリティチームに連絡",
    "navTerms": "利用規約 →",
    "navPrivacy": "プライバシーポリシー →"
  },
  "gallery": {
    "tag": "マイクリエイション",
    "title": "作成履歴",
    "subtitle": "画像と動画の生成記録を含む、すべてのAI作成履歴を表示します。",
    "loadMore": "もっと読み込む",
    "loginRequired": "作成履歴を表示するにはログインしてください",
    "empty": "作成記録がありません。今すぐ作成を始めましょう！",
    "filters": {
      "all": "すべて",
      "pending": "処理中",
      "finish": "完了済み",
      "failed": "失敗"
    },
    "status": {
      "pending": "処理中",
      "finish": "完了済み",
      "failed": "失敗"
    },
    "usePrompt": "このプロンプトで生成",
    "download": "ダウンロード"
  },
  "watermarkRemover": {
    "breadcrumb": {
      "home": "ホーム"
    },
    "tag": "AIツール",
    "title": "画像透かし除去",
    "subtitle": "画像内の透かしをインテリジェントに検出・除去し、元の品質を維持",
    "uploadText": "クリックまたはドラッグで画像をアップロード",
    "uploadHint": "JPG、PNG、BMP、WEBP形式対応、最大50MB",
    "keepAlphaChannel": "アルファチャンネルを保持",
    "keepAlphaChannelDesc": "有効にすると結果画像のアルファチャンネル情報を保持します",
    "removeWatermark": "透かしを除去",
    "processing": "処理中...",
    "result": "処理結果",
    "download": "結果をダウンロード",
    "newImage": "新しい画像を処理",
    "watermarkDetected": "透かしを検出しました",
    "noWatermark": "透かしは検出されませんでした",
    "before": "処理前",
    "after": "処理後",
    "emptyText": "画像をアップロードして透かし除去を開始",
    "invalidFormat": "有効な画像ファイルをアップロードしてください",
    "fileTooLarge": "ファイルサイズは50MBを超えることはできません",
    "processFailed": "処理に失敗しました、もう一度お試しください",
    "features": {
      "title": "機能",
      "ai": {
        "title": "AI検出",
        "desc": "透かしの位置とタイプを自動検出"
      },
      "fast": {
        "title": "高速処理",
        "desc": "効率的なアルゴリズムで迅速な透かし除去"
      },
      "formats": {
        "title": "マルチフォーマット対応",
        "desc": "JPG、PNG、BMP、WEBPなどに対応"
      },
      "quality": {
        "title": "品質維持",
        "desc": "元の画像品質を維持、ロスレス除去"
      }
    }
  },
  "profile": {
    "joinTime": "登録日",
    "tabs": {
      "account": "アカウント",
      "billing": "請求",
      "privacy": "データとプライバシー"
    },
    "balance": {
      "title": "残高概要",
      "available": "利用可能クレジット"
    },
    "subscription": {
      "currentPlan": "現在のプラン",
      "status": "ステータス",
      "activated": "有効",
      "cancelled": "現在の期間終了時にキャンセル",
      "pending": "処理中",
      "failed": "支払い失敗",
      "expiryDate": "有効期限",
      "permanent": "永久有効",
      "upgradePlan": "プランをアップグレードまたは変更",
      "cancelPlan": "サブスクリプションをキャンセル",
      "cancelNote": "サブスクリプションは現在の請求期間が終了するまで有効です",
      "cancelWarning": "サブスクリプションはキャンセルされます。それまでの間、すべての機能を引き続きご利用いただけます：",
      "restorePlan": "サブスクリプションを再開"
    },
    "upgrade": {
      "title": "アップグレード",
      "desc": "無制限アクセスと特典を取得",
      "btn": "プランを見る"
    },
    "billing": {
      "title": "支払い履歴",
      "subtitle": "支払い記録を表示し、請求書をダウンロード",
      "empty": "請求記録はまだありません",
      "creditsPack": "クレジットパック",
      "oneTime": "一回",
      "monthly": "月額",
      "yearly": "年額",
      "refresh": "更新",
      "plan": "プラン",
      "date": "日付",
      "amount": "金額",
      "invoice": "請求書",
      "download": "ダウンロード",
      "invoiceModal": {
        "title": "請求書詳細",
        "orderInfo": "注文情報",
        "invoiceInfo": "請求書情報",
        "plan": "プラン",
        "date": "支払日",
        "amount": "金額",
        "paymentId": "注文ID",
        "close": "閉じる",
        "download": "請求書をダウンロード",
        "fullName": "氏名",
        "fullNamePlaceholder": "氏名を入力",
        "email": "メール",
        "emailPlaceholder": "メールを入力",
        "company": "会社名",
        "companyPlaceholder": "会社の正式名称",
        "taxId": "税番号",
        "taxIdPlaceholder": "税番号を入力",
        "addressLine1": "住所1",
        "addressLine1Placeholder": "番地",
        "addressLine2": "住所2",
        "addressLine2Placeholder": "建物名、部屋番号など（オプション）",
        "city": "市区町村",
        "cityPlaceholder": "市区町村",
        "province": "都道府県",
        "provincePlaceholder": "都道府県",
        "postalCode": "郵便番号",
        "postalCodePlaceholder": "郵便番号",
        "country": "国",
        "countryPlaceholder": "国",
        "invoiceRemarks": "備考",
        "invoiceRemarksPlaceholder": "請求書の備考情報",
        "optional": "オプション",
        "required": "必須項目"
      }
    },
    "privacy": {
      "title": "プライバシー設定",
      "cardTitle": "データは保護されています",
      "cardSubtitle": "データプライバシーとセキュリティに対する当社の取り組み",
      "item1": "データはAIモデルのトレーニングに使用されません",
      "item2": "データ転送と保存は完全に暗号化されています",
      "item3": "生成された作品は保存期間後に自動的に削除されます",
      "item4": "フィードバックループなし、派生データの二次利用なし",
      "item5": "データ保護規制を厳格に遵守"
    },
    "support": {
      "title": "お困りですか？",
      "desc": "サポートチームがお手伝いします",
      "btn": "サポートに連絡",
      "note": "miral_support@miralvis.com · 24時間以内に返信"
    }
  },
  "payment": {
    "success": {
      "title": "支払い成功",
      "message": "ご購入ありがとうございます！注文は正常に処理され、クレジットがアカウントに追加されました。",
      "goHome": "ホームに戻る",
      "viewProfile": "プロフィールを表示"
    },
    "cancel": {
      "title": "支払いがキャンセルされました",
      "message": "支払いがキャンセルされました。ご質問がある場合は、サポートチームまでお気軽にお問い合わせください。",
      "tryAgain": "再試行",
      "goHome": "ホームに戻る"
    }
  },
  "inspiration": {
    "title": "Inspiration",
    "subtitle": "See what creators are building with Miral — from hyper-realistic images to cinematic videos, inspiration at your fingertips.",
    "filters": {
      "all": "All",
      "image": "Image",
      "video": "Video",
      "portrait": "Portrait",
      "landscape": "Landscape",
      "fantasy": "Fantasy",
      "anime": "Anime"
    },
  },
  "seo": {
    "default": {
      "title": "Miral - AI画像・動画・音楽生成プラットフォーム",
      "description": "MiralはSeedream 4、Midjourney、GPT Image、Veo 3、Sora 2などトップAIモデルを搭載したオールインワンAI制作プラットフォームです。",
      "keywords": "AI画像生成, AI動画生成, AI音楽生成, テキストから画像, テキストから動画, Seedream, Midjourney, Veo, Sora, Miral"
    },
    "home": { "title": "Miral｜AI画像・動画・音楽生成プラットフォーム｜主要モデル対応オンライン版", "description": "Miralなら、Seedream 5、Midjourney、Veo 3.1、Sora 2などの先進AIモデルを一つのプラットフォームで利用可能。高品質な画像、動画、音楽をすばやく生成し、デザインやマーケティング、コンテンツ制作に活用できます。ブラウザから今すぐ手軽に始められます。" },
    "pricing": { "title": "料金プラン - Miral AI制作プラットフォーム", "description": "Miralは柔軟な料金プランをご提供。クレジットを購入して使うだけ、サブスクリプション不要。" },
    "profile": { "title": "マイページ - Miral", "description": "Miralアカウントの管理、注文履歴と制作記録の確認。" },
    "models": { "title": "AIモデル - Miral", "description": "MiralプラットフォームのトップAIモデルをご覧ください。画像・動画・音楽生成モデルを含みます。" },
    "music": { "title": "AI音楽生成 - Miral", "description": "MiralのAI音楽生成機能で、テキストからオリジナル音楽を制作。" },
    "tools": { "title": "AI画像ツール - Miral", "description": "Miralは透かし除去、背景除去、画像強調など多彩なAI画像処理ツールを提供。" },
    "inspiration": { "title": "インスピレーション - Miral", "description": "Miralコミュニティの注目作品を閲覧して、AI制作のインスピレーションを。" },
    "gallery": { "title": "マイギャラリー - Miral", "description": "Miralプラットフォームで制作した全作品の確認・管理。" },
    "faq": { "title": "よくある質問 - Miral", "description": "Miralプラットフォームに関するよくある質問。" },
    "about": {
      "title": "会社概要 - Miral",
      "description": "Miral AI創作プラットフォームについて。"
    },
    "contact": {
      "title": "お問い合わせ - Miral",
      "description": "Miralサポートへの連絡方法。"
    },
    "terms": { "title": "利用規約 - Miral", "description": "Miralプラットフォームの利用規約とユーザー同意事項。" },
    "privacy": { "title": "プライバシーポリシー - Miral", "description": "Miralプラットフォームのプライバシーポリシーとデータ保護について。" },
    "trustSafety": { "title": "信頼と安全 - Miral", "description": "Miralプラットフォームの信頼と安全ポリシー。" },
    "models": {
      "wan25": { "title": "Wan 2.5 - 強力なAI動画モデル", "description": "Wan 2.5は次世代AI動画生成を実現。高度なモーションとディテールでリアルでスムーズな動画を作成、クリエイターやビジネスに最適。" },
      "wan26": { "title": "Wan 2.6 - 高性能AI動画ジェネレーター", "description": "Wan 2.6で動画制作をアップグレード。高度なAIモデルが改善されたモーション、ディテール、速度で超高品質動画を生成。" },
      "wan22": { "title": "Wan 2.2 - 高速AI動画ジェネレーター", "description": "Wan 2.2は高速で信頼性の高いAI動画モデル。スピーディに高品質動画を生成、プロのコンテンツ制作に最適。" },
      "veo30": { "title": "Veo 3.0 - 先駆的なAI動画モデル", "description": "Veo 3.0はトップクラスのAI動画ジェネレーター。高度なAIでリアルなシネマティック動画を作成、プロのコンテンツ制作とマーケティングに最適。" },
      "veo31": { "title": "Veo 3.1 - トップクラスAI動画生成", "description": "Veo 3.1は美しくリアルな動画向けの先進AI動画モデル。比類のない品質と速度でシネマティッククリップやアニメーションを作成。" },
      "veo31": { "title": "Veo 3.1 - Google AI動画生成 - Miral", "description": "Google Veo 3.1モデルで高品質なAI動画を生成。" },
      "kling26": { "title": "Kling 2.6 - プレミアムAI動画モデル", "description": "Kling 2.6がプロフェッショナルなAI動画生成を実現。高度なAIで高品質でスムーズな動画を生成、クリエイターやマーケターに最適。" },
      "kling25": { "title": "Kling 2.5 - 信頼のAI動画モデル", "description": "Kling 2.5はクリエイター向けの強力なAI動画生成。スムーズなモーションとディテールで高品質動画を作成、コンテンツやマーケティングに最適。" },
      "seedance": { "title": "Seedance AI - 高度なAI動画ジェネレーター", "description": "Seedance AIで高品質AI動画を生成。最先端のAIモデルで美しいクリップ、アニメーション、シネマティックコンテンツを迅速にプロ品質で作成。" },
      "sora2": { "title": "Sora 2 AI動画ジェネレーター – テキスト・画像から動画 | Miral", "description": "Miralでテキストや画像からSora 2 AI動画を作成。無料クレジットで試し、4〜12秒、720p/1080p、16:9/9:16を選択できます。" },
      "hailuo23": { "title": "Hailuo 2.3 - スマートAI動画ジェネレーター", "description": "Hailuo 2.3がインテリジェントなAI動画生成を実現。高度なAIで高品質でクリエイティブな動画を作成、コンテンツクリエイターやビジネスに最適。" },
      "runway": { "title": "Runway - AI動画制作プラットフォーム", "description": "Runwayはクリエイター向けの先進的AI動画プラットフォーム。強力なAIツールで動画の編集、生成、強化が可能、プロのコンテンツ制作に最適。" },
      "nanobanana": { "title": "Nano Banana - AI画像生成 - Miral", "description": "Nano Bananaモデルでクリエイティブな画像を素早く生成。" },
      "seedream4": { "title": "Seedream 4 - AI画像ジェネレーター", "description": "Seedream 4で美しい高解像度AI画像を作成。高度なAIで写真リアルなアート、イラスト、デザインを生成、プロのクリエイティブワークに最適。" },
      "midjourney": { "title": "Midjourney - AIアートジェネレーター", "description": "Midjourneyは先駆的なAIアートジェネレーター。テキストプロンプトから息を呑む画像やアートを作成、アーティストやデザイナーに最適。" },
      "gptimage1": { "title": "GPT-Image-1 - OpenAI AI画像モデル", "description": "OpenAIのGPT-Image-1がテキストから高品質AI画像を生成。デザイン、マーケティング、コンテンツ制作向けのリアルでクリエイティブなビジュアルを作成。" },
      "gptimage15": { "title": "GPT Image 1.5 - OpenAI AI画像生成 - Miral", "description": "OpenAI GPT Image 1.5モデルで高品質なAI画像を生成。" },
      "fluxpro11ultra": { "title": "Flux Pro 1.1 Ultra - プレミアムAI画像ジェネレーター", "description": "Flux Pro 1.1 Ultraは超高品質AI画像生成を実現。高度なAIで写真リアルで詳細な画像を作成、プロのデザインやアートに最適。" },
      "fluxschnell": { "title": "Flux Schnell - 高速AI画像ジェネレーター", "description": "Flux Schnellは超高速AI画像ジェネレーター。迅速に高品質画像を作成、スピーディなプロのビジュアルコンテンツが必要なクリエイターに最適。" },
      "flux2": {
        "title": "FLUX.2 - AI画像生成 - Miral",
        "description": "FLUX.2モデルでプロ品質のAI画像を生成——速度、品質、制御のための5バリアント。"
      },
      "zimageturbo": {
        "title": "Z Image Turbo - AI画像生成 - Miral",
        "description": "Z Image Turboモデルで高解像度のAI画像を生成。"
      }
    },
    "tools": {
      "watermarkRemover": { "title": "無料AI透かし除去ツール｜写真・画像の透かしをオンラインで簡単削除 | Miral", "description": "AIで写真や画像の透かし、ロゴ、日付、文字、下書きマークをオンライン除去。細部と画質を保ちながら、JPG・PNG・WebPを自然で清潔な画像に仕上げます。商品写真、SNS投稿、資料、作品画像の不要な表示を手軽に整理でき、専門ソフトを入れずブラウザですぐに無料で利用できて便利です。" },
      "backgroundRemover": { "title": "無料AI背景除去｜画像を透明PNGにオンライン変換 | Miral", "description": "AIで画像背景を無料削除。人物や商品を自動切り抜きし、髪の毛や細かな輪郭を保って、JPG・PNG・WebPから透明PNGを作成できます。" },
      "imageEraser": { "title": "AI画像消しゴム - 写真から不要な物体を除去", "description": "AIで写真から不要な物体、人物、透かし、テキストを消去。対象範囲をブラシでなぞるだけでAIがシームレスに除去し自然な内容で塗りつぶします。写真の整理に最適。" },
      "objectRemover": { "title": "AIオブジェクト削除 - 写真から不要な物体を削除", "description": "AIで写真から不要なオブジェクトを削除。対象オブジェクトをブラシでなぞるだけでAIがシームレスに削除し自然な内容で塗りつぶします。写真の整理に最適。" },
      "aiPersonRemover": { "title": "AI人物削除 - 写真から不要な人物を削除", "description": "AIで写真から不要な人物を削除。対象人物をブラシでなぞるだけでAIがシームレスに削除し自然な内容で塗りつぶします。通行人や見知らぬ人の除去に最適。" },
            "whiteBackground": { "title": "AI白背景置換 - 画像背景を白に置換", "description": "AIで自動的に画像背景を白に置換。商品写真や証明写真、カタログ画像に最適。" },
            "blueBackground": { "title": "AI青背景置換 - 画像背景を青に置換", "description": "AIで自動的に画像背景を青に置換。証明写真やパスポート写真、公式書類に最適。" },
      "faceSwap": { "title": "AI顔交換 - 写真の顔を交換", "description": "AIで写真の顔を交換。ターゲット写真とソース顔写真をアップロードするだけで、リアルで自然な結果で顔をシームレスに合成。" },
      "imageEnhancer": { "title": "AI画像強調 - 拡大・高画質化", "description": "AIで画像を強調・拡大。ディテールをシャープにし、ぼやけを修正、解像度を向上、古い写真を復元してプロ品質を実現。" },
      "docCropEnhance": { "title": "AI文書トリミング・傾き補正ツール｜試験用紙と宿題をオンラインで鮮明化 | Miral", "description": "文書、試験用紙、宿題、教科書の写真をAIで自動トリミング・補正。傾き、遠近感、ページの湾曲、影を整え、文字が読みやすい鮮明なスキャン画像を作成します。スマートフォンで斜めから撮影したプリントや見開きページも補正でき、保存、共有、印刷に使いやすい文書画像へ手軽に整えられ、無料で使えます。" },
      "handwrittenErase": { "title": "無料AI手書き文字除去ツール｜テスト用紙・宿題の回答をオンライン消去 | Miral", "description": "試験用紙、宿題、問題集の手書き回答をAIで除去し、印刷された問題とレイアウトを保持。回転、トリミング、湾曲補正にも対応し、空白の教材を復元します。採点済みプリント、書き込みのある練習帳、再利用したい学習資料をブラウザで整理でき、家庭学習や授業準備にもさらに何度でも無料で活用できます。" }
    },
    imageModels: {
            title: "AI 画像モデル - Miral",
            description: "Miral でトップの AI 画像モデルを探索し、テキスト プロンプトから見事な画像を生成します。",
            relatedModelsTitle: "AI 画像モデルをさらに探索する",
            demoPrompt: "テキストプロンプト",
            demoOutput: "生成された画像",
            demoPlaceholder: "サンプル画像 — 近日公開予定",
            promptLabel: "で作成する",
            usePrompt: "このプロンプトを使用します →",
            imagePlaceholder: "AI画像の例",
            replaceImageHint: "この画像の横に表示されるプロンプトから生成されます",
            flux1: {
                title: "FLUX.1 AI 画像ジェネレーター無料オンライン |ミラル",
                description: "Flux Pro 1.1 Ultra または Flux Schnell を使用して、FLUX.1 で高品質の AI 画像をオンラインで作成します。 9 つのアスペクト比、ビジュアル スタイル、無料クレジットをご覧ください。",
                heroHeadline: "FLUX.1 AI画像ジェネレーター",
                heroIntro: "Black Forest Labs の FLUX.1 AI 画像ジェネレーターを Miral AI で無料で使用します。サインアップして無料クレジットを受け取り、Flux Pro 1.1 Ultra の高品質出力か、Flux Schnell の高速でマルチスタイルの作成のいずれかを選択してください。",
                eyebrow: "Black Forest Labs · FLUX.1",
                sectionKicker: "フラックス.1",
                ctaTag: "FLUX.1・ミラル",
                badges: ["テキストから画像へ", "9 縦横比", "プロとシュネル", "写真 / デジタルアート / アニメ"],
                previewLabel: "フラックス プロ 1.1 ウルトラ",
                previewMeta: ["1:1", "16:9", "9:16", "9 比率"],
                previewTitle: "洗練された品質と迅速なクリエイティブの探索のどちらかを選択してください",
                previewDesc: "詳細なビジュアルには Pro 1.1 Ultra を使用し、写真、デジタル アート、アニメの方向性をすばやく探索するには Schnell を使用します。",
                keyFeaturesTitle: "FLUX.1 Text to Image Generator で高品質のビジュアルを作成",
                keyFeaturesIntro: "Flux Pro 1.1 Ultra および Flux Schnell の機能を探索して、迅速な理解、出力速度、ビジュアル スタイル、柔軟なアスペクト比を実現します。",
                exploreTitle: "AI 画像モデルをさらに探索する",
                mainFeaturesTitle: "FLUX.1 の主な機能",
                generatedImageLabel: "生成された画像",
                versionLabel: "バージョン",
                featureLabel: "主な特長",
                useCaseLabel: "最適な用途",
                controlsTitle: "適切なモデル、比率、視覚スタイルを選択する",
                controlsIntro: "洗練された最終イメージには Flux Pro 1.1 Ultra を使用し、より迅速な調査には Flux Schnell を使用して、アスペクト比とスタイルを目的のチャンネルに合わせます。",
                galleryTitle: "その他の FLUX.1 画像の例",
                discussionTitle: "FLUX.1 選択に関する一般的な質問",
                communityTitle: "FLUX.1 を使用した一般的な作成方法",
                tutorialPrompt: "日の出の海のそばの静かなガラス張りの本屋、温かみのある読書灯、淡いオークの棚、床の柔らかな反射、リアルな室内写真。",
                qualityBenefits: [
                    "マテリアル、照明、空間の奥行きをより洗練された仕上がりでレンダリングします。",
                    "主題、構図、カメラ、スタイルを組み合わせた詳細なプロンプトに従います。",
                    "写真、デジタル アート、アニメの指示を明確なテキストの指示から探索します。"
                ],
                features: [
                    { name: "高品質 FLUX.1 テキストから画像へ", short: "書かれたプロンプトを詳細でプロフェッショナルなビジュアルに変換します。", desc: "Flux Pro 1.1 Ultra は、画像の詳細、マテリアル、照明、および全体的な仕上げが重要な作業に適しています。主題、構図、カメラ、スタイルを明確に説明すると、画像をプロジェクトの方向に導くことができます。", demo: { type: 'table', rows: [
                        { prompt: "ブルーアワーのブティック砂漠ホテルの外観、版築壁、暖かい窓の輝き、自生の草、長い影、リアルな建築写真。", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "マットブラックの皿に手作りのラビオリ、バジルオイル、リネンナプキン、指向性窓の光、浅い被写界深度のエディトリアルフード写真。", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "Flux Schnell による高速生成", short: "素早い下書きを作成し、プロンプトをテストし、アイデアを迅速に検討します。", desc: "Flux Schnell は、素早い構成、スタイル、コンセプトのテストが必要なワークフローに最適です。ドラフトを生成し、方向を確認してから、別の反復のためにプロンプ​​トを調整します。", prompt: "エコスタートアップ向けのモジュール式段ボール展示会ブースのコンセプト、シンプルな製品台座、再生紙の質感、明るい展示照明、すっきりとしたレイアウト。", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "9 つの画像アスペクト比", short: "ウルトラワイド、ランドスケープ、スクエア、ポートレート、トールフォーマットをカバーします。", desc: "Flux Pro 1.1 Ultra と Flux Schnell はどちらも、バナー、製品画像、ソーシャル コンテンツ、ポスター、モバイル ビジュアルで 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21 をサポートします。", prompt: "雲海の上に広がる 21:9 のパノラマ高山展望台、ガラス張りの展望台、早朝の光、スケールの小さなハイカー、映画のようなマットペイント。", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "Schnell の複数の視覚スタイル", short: "自動、写真、デジタル アート、またはアニメを選択します。", desc: "Flux Schnell は、自動、写真、デジタル アート、アニメのスタイルの方向性を提供し、モデルを変更せずにフォトリアル、イラスト、アニメのビジュアルを簡単に切り替えることができます。", demo: { type: 'table', rows: [
                        { prompt: "写真スタイル: 太陽に照らされたガレージでビンテージ レーシング バイクを調整する自転車整備士、油汚れた手、リアルなクロムの反射。", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "アニメ スタイル: スカイトレイン内の居心地の良い猫カフェ、窓の外のパステル調の夕焼け雲、表情豊かなキャラクター、きれいな線画。", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "柔軟なクリエイティブな使用例", short: "製品、マーケティング、ポートレート、コンセプト、ソーシャル ビジュアルを作成します。", desc: "FLUX.1 ファミリは、洗練された製品とブランドのイメージに加え、迅速なキャンペーン コンセプト、ポートレート、環境デザイン、プラットフォーム固有のアスペクト比をサポートします。", prompt: "リサイクル生地のテクスチャー、浮遊レースのディテール、モスグリーンのグラデーション背景、ソーシャル広告コピー用の大胆な空きスペースを備えた、持続可能なスニーカーの発売ビジュアル。", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "プロンプトの例",
                showcaseTitle: "より良い AI 画像のための FLUX.1 プロンプトの例",
                showcaseIntro: "これらの FLUX.1 プロンプトを開始点として使用してください。主題、構図、照明、カメラ、マテリアル、カラーパレット、ビジュアルスタイルを明確に説明します。",
                variantsKicker: "モデルガイド",
                variantsTitle: "Flux Pro 1.1 Ultra vs Flux Schnell",
                variantsIntro: "プロジェクトに必要な品質、速度、スタイル制御に基づいて FLUX.1 モデルを選択してください。",
                variants: [
                    { name: "フラックス プロ 1.1 ウルトラ", tag: "高品質", desc: "サポートされている 9 つのアスペクト比を使用して、詳細でリアルで洗練されたテキストから画像への作業向けに設計されています。", bestFor: "製品写真、キャンペーンのヒーロー画像、洗練された最終ビジュアルに最適" },
                    { name: "フラックス・シュネル", tag: "速い", desc: "9 つのアスペクト比と自動、写真、デジタル アート、アニメのスタイルを使用して、迅速に反復できるように設計されています。", bestFor: "下書き、迅速なテスト、ソーシャル コンテンツ、および迅速な探索に最適" }
                ],
                useCasesKicker: "実際の仕事向けに作られています",
                useCasesTitle: "人気のある FLUX.1 の使用例",
                useCases: [
                    { name: "商品撮影用 FLUX.1", desc: "製品のヒーローイメージ、ライフスタイルシーン、eコマースのビジュアルコンセプトを作成します。" },
                    { name: "マーケティングと広告のための FLUX.1", desc: "ソーシャル広告、キャンペーン バナー、ブランドのマーケティング ビジュアルを生成します。" },
                    { name: "FLUX.1 フォトリアルなポートレート", desc: "照明、背景、構成を制御して、写真のようなポートレートを作成します。" },
                    { name: "デジタル アート向け FLUX.1", desc: "Schnell を使用すると、イラスト、ファンタジー、デジタル アートの方向性をすばやく探索できます。" },
                    { name: "アニメ画像用の FLUX.1", desc: "キャラクターやアニメ シーンには Schnell Anime スタイルを使用します。" },
                    { name: "FLUX.1 コンセプト アート用", desc: "映画のような環境、ゲーム シーン、キャラクター、ビジュアルな世界を探索します。" },
                    { name: "ソーシャルメディア画像用の FLUX.1", desc: "横向き、正方形、縦向きのプラットフォーム コンテンツには 9 つのアスペクト比を使用します。" },
                    { name: "ポスターとバナー用の FLUX.1", desc: "イベント、プロモーション、モバイル ページのレイアウトのコンセプトに適した比率を選択してください。" }
                ],
                howToKicker: "3 つの簡単なステップ",
                howToTitle: "FLUX.1 AI 画像ジェネレーターをオンラインで無料で使用する方法",
                howToIntro: "サインアップして無料クレジットを受け取り、Miral でオンラインで Flux Pro 1.1 Ultra または Flux Schnell を使用してください。",
                howToSteps: [
                    { title: "詳細なプロンプトを入力してください", desc: "主題、設定、構図、照明、カメラ、素材、色、ターゲットのスタイルについて説明します。" },
                    { title: "モデルと比率を選択してください", desc: "洗練された品質を求めるには Pro 1.1 Ultra を、高速に探索するには Schnell を選択し、アスペクト比と Schnell スタイルを設定します。" },
                    { title: "生成と洗練", desc: "画像を生成し、確認してダウンロードするか、別のバージョンのプロンプト、比率、またはスタイルを調整します。" }
                ],
                howToCta: "FLUX.1 AI 画像ジェネレーターを無料で使用する",
                faqTitle: "FLUX.1 に関するよくある質問",
                faqs: [
                    { q: "FLUX.1 AI画像ジェネレーターとは何ですか？", a: "FLUX.1 は、Black Forest Labs の画像生成モデル ファミリです。 Miral では、Flux Pro 1.1 Ultra と Flux Schnell を使用して、テキスト プロンプトを製品、マーケティング、ポートレート、アニメ、コンセプト アートの画像に変換します。" },
                    { q: "FLUX.1 AI 画像ジェネレーターは無料で使用できますか?", a: "はい。サインアップして無料クレジットを受け取り、FLUX.1 AI 画像ジェネレーターを使用して高品質の画像の作成をすぐに開始してください。画像の生成には、対応するクレジットが使用されます。" },
                    { q: "Flux Pro 1.1 Ultra と Flux Schnell の違いは何ですか?", a: "Flux Pro 1.1 Ultra は、細部と仕上げが重要な洗練された最終画像に適しています。 Flux Schnell は、高速ドラフト、迅速なテスト、自動、写真、デジタル アート、アニメ スタイルなどのマルチスタイルの探索に適しています。" },
                    { q: "FLUX.1 はどのような画像アスペクト比をサポートしていますか?", a: "Miral の Flux Pro 1.1 Ultra および Flux Schnell は、21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、および 9:21 の合計 9 つのアスペクト比をサポートします。" },
                    { q: "Flux Schnell はどのようなスタイルをサポートしていますか?", a: "Flux Schnell は、自動マッチング、フォトリアル画像、デジタル イラスト、アニメ ビジュアルのために、オート、写真、デジタル アート、アニメをサポートしています。" },
                    { q: "FLUX.1 AI 画像ジェネレーターをオンラインで使用するにはどうすればよいですか?", a: "テキスト プロンプトを入力し、Flux Pro 1.1 Ultra または Flux Schnell を選択し、アスペクト比を設定します。 Schnell を使用すると、「生成」をクリックする前に視覚スタイルを選択することもできます。" },
                    { q: "最良の FLUX.1 プロンプトの例は何ですか?", a: "効果的な FLUX.1 プロンプトは、主題、設定、構成、照明、カメラ、マテリアル、カラー パレット、ターゲット スタイルを明確に説明します。このページの例を出発点として使用し、プロジェクトに適応させてください。" },
                    { q: "FLUX.1 と FLUX.2: どちらを使用すべきですか?", a: "Flux Pro 1.1 Ultra で洗練された出力を得るには FLUX.1 を、Flux Schnell を使ってマルチスタイルを高速に作成するには FLUX.1 を選択してください。 Klein、Max、Pro、Flex の各バージョンが必要な場合は、Miral の FLUX.2 ページを選択してください。" },
                    { q: "FLUX.1 と Midjourney: どちらを使用すべきですか?", a: "FLUX.1 は、明示的なアスペクト比、高速 Schnell ワークフロー、または洗練された Pro 1.1 Ultra 出力に最適です。 Midjourney は、芸術的なスタイル、参照画像のワークフロー、クリエイティブなプロセスを好むユーザーに適しているかもしれません。" }
                ],
                ctaTitle: "Miral で FLUX.1 を無料で使用してください!",
                ctaDesc: "無料のクレジットを受け取るにはサインアップしてください。 Flux Pro 1.1 Ultra または Flux Schnell を選択し、プロジェクトに必要な比率とスタイルで画像を作成します。"
            },
            flux2: {
                title: "FLUX.2 AI 画像ジェネレーター無料オンライン |ミラル",
                description: "FLUX.2 を使用してフォトリアルな AI 画像をオンラインで作成します。製品写真、ポスター、アートワーク、洗練されたマーケティング ビジュアル用に 5 つのモデル バリエーションを選択します。",
                heroHeadline: "FLUX.2 AI画像ジェネレーター",
                heroIntro: "Black Forest Labs の FLUX.2 AI 画像ジェネレーターを Miral AI で無料で使用します。サインアップすると、無料のクレジットを受け取り、高品質で写実的な画像、製品写真、ポスター、マーケティング ビジュアルを即座に作成できます。",
                eyebrow: "Black Forest Labs · FLUX.2",
                sectionKicker: "フラックス.2",
                ctaTag: "FLUX.2・ミラル",
                badges: ["テキストから画像へ", "写実的な", "正確なタイポグラフィー", "複数のアスペクト比"],
                previewLabel: "フラックス.2",
                previewMeta: ["1:1", "1024×1024", "PNG"],
                previewTitle: "正確なプロンプトから制作可能なビジュアルまで",
                previewDesc: "1 つの合理化されたワークフローで、詳細な製品ショット、キャンペーン コンセプト、ポートレート、テキストが豊富なデザインを作成します。",
                keyFeaturesTitle: "FLUX.2 Text to Image Generator でプロフェッショナルなビジュアルを作成",
                keyFeaturesIntro: "正確なプロンプト、洗練されたディテール、現実的な出力、信頼性の高い視覚制御を実現する、主要な FLUX.2 AI 画像生成機能を調べてください。",
                exploreTitle: "AI 画像モデルをさらに探索する",
                mainFeaturesTitle: "FLUX.2 の主な機能",
                generatedImageLabel: "生成された画像",
                versionLabel: "バージョン",
                featureLabel: "主な特長",
                useCaseLabel: "最適な用途",
                controlsTitle: "適切な FLUX.2 バージョンと出力設定を選択する",
                controlsIntro: "迅速なイテレーションには Klein を、最高の最終品質には Max、制作ワークフローには Pro、タイポグラフィーや細部の制御には Flex を使用してください。",
                galleryTitle: "その他の FLUX.2 画像の例",
                discussionTitle: "FLUX.2 モデルに関するよくある質問",
                communityTitle: "FLUX.2 を使用した一般的な作成方法",
                tutorialPrompt: "淡い石灰岩の上に半透明のエメラルドの香水瓶を描いたプレミアム キャンペーン写真、柔らかな朝の光、リアルなガラスの屈折、洗練されたタイポグラフィー、たっぷりとしたネガティブ スペース。",
                qualityBenefits: [
                    "主題、構成、照明、スタイルをより強力に制御しながら、詳細なプロンプトに従います。",
                    "リアルなテクスチャ、奥行き、洗練されたディテールを作成して、プロフェッショナルなビジュアル作品を実現します。",
                    "テキストの多いポスター、製品ラベル、キャンペーン グラフィックをより鮮明なタイポグラフィーで処理します。"
                ],
                features: [
                    { name: "ハイエンドの画像合成", short: "遅延を追加することなく、強化された即時遵守と画質を実現します。", desc: "FLUX.2 はプロンプトの調整を大幅に強化し、詳細なスクリプトやシーンの説明などの長い形式の入力もサポートします。これにより、速度を犠牲にすることなく、生成された画像の忠実度が向上するため、反復的な調整の必要性が減り、クリエイターはより早く完成結果に到達できるようになります。", demo: { type: 'table', rows: [
                        { prompt: "山脈に沈む夕日を映し出す、鮮やかな色と複雑なディテールを備えた見事な風景。",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "関数型言語と低レベル言語の間で翻訳を行うための抽象芸術。" ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "アニメ/漫画のキャラクターの顔写真。詳細でよく作られていますが、人間が作ったように見えます。" ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "優れたディテールとリアリズム", short: "本物のようなテクスチャ、照明、奥行きを生み出し、スタジオ グレードのビジュアルを実現します。", desc: "FLUX.2 は、生成された画像を本物の写真のように見せる、細かいテクスチャ、リアルな照明、自然な奥行きをキャプチャします。そのため、信憑性が最も重要となる製品ショット、ポートレート、映画のようなビジュアルに最適です。", prompt: "ダークスレート上の銀色の機械式時計のスタジオ製品写真、柔らかい側面照明、現実的なつや消し金属の質感、浅い被写界深度、微妙な反射、プレミアム編集構成。" ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "強力な即時遵守", short: "特定の主題、スタイル、構成など、複雑なプロンプトに厳密に従います。", desc: "FLUX.2 は、階層化されたマルチパート プロンプトを驚くほど正確に解釈し、特定の主題、アート スタイル、カラー パレット、構成指示を 1 つの世代で処理します。これにより、クリエイターはより詳細な制御が可能になり、必要なものを正確に説明する際に再ロールが少なくなります。", prompt: "夕暮れ時に雨のヨーロッパの広場を横切る赤い路面電車、前景に 3 人の自転車に乗る人、左側の暖かいカフェの窓、青い時間の空、対称的な構図、映画のような写真。",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "高度なタイポグラフィ処理", short: "画像内のテキストをよりクリーンなスペルとスタイルの一貫性でレンダリングします。", desc: "FLUX.2 では、フォント スタイルの一貫性がより正確になり、画像全体にわたるテキストの生成と制御が向上しました。これにより、ポスター、広告、コミック、ブランド グラフィックなどのテキストベースの素材や看板を、より少ないアーティファクトで作成できるようになります。", demo: { type: 'table', rows: [
                        { prompt: "「FLUX 2」の文字が入った美しい神秘的な風景写真、繊細な美しさ、ブルーベリーが組み込まれています。" ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "「FLUX 2 Pro」の文字が綴られた黒い森のガトーケーキ、美味しそうな食べ物の写真。" ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "高速かつスケーラブルな生成", short: "1 秒未満の反復から最高品質の出力まで選択できます。", desc: "FLUX.2 は、高速の Klein モデルと、プロダクションに焦点を当てた Pro、Max、および Flex のバリアントに及びます。この範囲により、迅速な下書き、バッチコンテンツ制作、最終品質のマーケティングまたはクリエイティブアセットに実用的になります。", prompt: "石灰岩の上にある半透明の緑色の香水瓶、柔らかい朝の光、微妙な影、プレミアム キャンペーンの美しさのきれいなエディトリアル製品写真。" ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "プロンプトの例",
                showcaseTitle: "より良い AI 画像のための FLUX.2 プロンプトの例",
                showcaseIntro: "これらの FLUX.2 プロンプトの例を開始点として使用し、主題、構成、照明、スタイルをカスタマイズして、プロンプトをジェネレーターに直接送信します。",
                variantsKicker: "モデルガイド",
                variantsTitle: "FLUX.2 モデルの比較: Klein vs Max vs Pro vs Flex",
                variantsIntro: "FLUX.2 Klein、Max、Pro、Flex を比較して、迅速なイテレーション、最終品質のアセット、生産規模、または細かいタイポグラフィ制御に適した AI 画像モデルを選択してください。",
                variants: [
                    { name: "FLUX.2 クライン 4B / 9B", tag: "最速", desc: "高速で大量の画像生成、ドラフト、ラピッド プロトタイピングには FLUX.2 Klein をお選びください。", bestFor: "下書き、バッチ、素早い反復に最適" },
                    { name: "FLUX.2 マックス", tag: "最高品質", desc: "最終的なアセット、最も強力なプロンプト追従、および根拠のある生成には、FLUX.2 Max を選択してください。", bestFor: "プレミアム キャンペーンやヒーロー画像に最適" },
                    { name: "FLUX.2 プロ", tag: "生産", desc: "プロダクショングレードの画質、所要時間、スケーラブルな出力のバランスを実現するには、FLUX.2 Pro をお選びください。", bestFor: "マーケティングやコンテンツ制作に最適" },
                    { name: "FLUX.2 フレックス", tag: "制御", desc: "調整可能なガイダンス、タイポグラフィー、テキスト レンダリング、細部の保存には、FLUX.2 Flex を選択してください。", bestFor: "ポスター、ラベル、デザイン資産に最適" }
                ],
                useCasesKicker: "実際の仕事向けに作られています",
                useCasesTitle: "人気のある FLUX.2 の使用例",
                useCases: [
                    { name: "商品撮影用 FLUX.2", desc: "洗練された商品ショット、ライフスタイルシーン、eコマースイメージのバリエーションを作成します。" },
                    { name: "マーケティングと広告向けの FLUX.2", desc: "キャンペーンのコンセプトをソーシャル広告、バナー、一貫したブランド ビジュアルに変えます。" },
                    { name: "ポスターとタイポグラフィー用の FLUX.2", desc: "FLUX.2 テキスト レンダリングを使用して、より鮮明な見出し、ラベル、ポスター、テキストベースのグラフィックを作成します。" },
                    { name: "FLUX.2 フォトリアルなポートレート", desc: "照明、スタイリング、構成を制御して、詳細な AI ポートレートを生成します。" },
                    { name: "FLUX.2 コンセプト アート用", desc: "映画のような環境、キャラクター、視覚的な方向性をすばやく探索します。" },
                    { name: "エディトリアルデザイン用のFLUX.2", desc: "記事やプレゼンテーション用の個性的なイラストや表紙を作成します。" }
                ],
                howToKicker: "3 つの簡単なステップ",
                howToTitle: "FLUX.2 AI 画像ジェネレーターをオンラインで使用する方法",
                howToIntro: "Miral でオンラインの FLUX.2 AI 画像ジェネレーターを使用して、詳細なテキスト プロンプトから生成された画像に移行します。",
                howToSteps: [
                    { title: "プロンプトを入力してください", desc: "主題、構図、照明、色、スタイル、画像に表示したいテキストを説明します。" },
                    { title: "FLUX.2 設定を選択します", desc: "ジェネレーターを開き、Klein、Max、Pro、または Flex を選択し、プロジェクトに適した出力サイズを選択します。" },
                    { title: "イメージを生成する", desc: "生成を開始し、結果を確認して、イメージをダウンロードするか、別のバージョンのプロンプトを調整します。" }
                ],
                howToCta: "FLUX.2 AI 画像ジェネレーターを試す",
                faqTitle: "FLUX.2 に関するよくある質問",
                faqs: [
                    { q: "FLUX.2とは何ですか？", a: "FLUX.2 は、Black Forest Labs の次世代のテキストから画像への AI モデルです。書かれたプロンプトを高品質で詳細な画像に変換し、Miral でアート、デザイン、マーケティング、製品のビジュアル作成にブラウザーで直接利用できます。" },
                    { q: "製品の写真やテキストが豊富なマーケティング ビジュアルを作成するにはどのツールを使用できますか?", a: "FLUX.2 は、忠実性と正確性が要求されるプロの製品写真やテキストが豊富なマーケティング ビジュアル向けに、迅速な一貫性、詳細、フォトリアリズム、タイポグラフィ処理を組み合わせています。" },
                    { q: "FLUX.2 AI 画像ジェネレーターは無料で使用できますか?", a: "はい。サインアップして無料クレジットを受け取り、FLUX.2 AI 画像ジェネレーターを使用して高品質の画像の作成をすぐに開始してください。画像の生成には、対応するクレジットが使用されます。" },
                    { q: "FLUX.2 AI 画像ジェネレーターをオンラインで使用するにはどうすればよいですか?", a: "詳細なテキスト プロンプトを入力し、FLUX.2 Klein、Max、Pro、または Flex を選択し、画像サイズを選択して、[生成] をクリックします。 FLUX.2 は、マーケティング資料、製品写真、映画のコンセプト、ソーシャル クリエイティブ、ポスター デザインに適しています。" },
                    { q: "FLUX.2 の生成にはどのくらい時間がかかりますか?", a: "生成時間は、選択した FLUX.2 バリアント、画像サイズ、現在のサービス負荷によって異なります。 Klein は非常に高速な反復を行うように設計されていますが、Max、Pro、Flex は品質と制御の異なるバランスを優先します。" },
                    { q: "プロンプトに従わない FLUX.2 イメージを修正するにはどうすればよいですか?", a: "主題、設定、構成、照明、カメラまたはアート スタイル、色、および必要なテキストをより明確に説明します。このページの FLUX.2 プロンプトの例を開始点として使用し、プロジェクトに合わせてカスタマイズします。" },
                    { q: "FLUX.2 のどのモデルを選択すればよいですか?", a: "迅速なドラフトとバッチには FLUX.2 Klein を、最高品質の最終アセットには Max、プロダクション規模の画像生成には Pro、またはタイポグラフィと細かい制御が最も重要な場合には Flex を選択してください。" },
                    { q: "FLUX.2 Max と Pro: 違いは何ですか?", a: "FLUX.2 Max は、最高の品質、強力なプロンプト追従、そして地に足の着いた生成を優先します。 FLUX.2 Pro は、日常のクリエイティブなワークフロー向けに、プロダクション グレードの品質、迅速な納期、スケーラブルな出力のバランスを実現します。" },
                    { q: "FLUX.2 と Midjourney: どちらを使用すべきですか?", a: "普遍的な勝者ではなく、ワークフローに基づいて選択してください。 FLUX.2 は、正確なプロンプトフォロー、タイポグラフィー、製品ビジュアル、API ベースの制作に非常に適しています。 Midjourney は、その独特の芸術的なワークフローとコミュニティ ツールを好むクリエイターに適しているかもしれません。" }
                ],
                ctaTitle: "Miral で FLUX.2 を無料でお試しください!",
                ctaDesc: "上記のアイデアを入力し、FLUX.2 AI 画像ジェネレーターを使用して、ワークフローに合ったモデル バリアントで詳細な画像を作成します。"
            },
            seedream: {
                title: "Seedream AI 画像ジェネレーター無料オンライン |ミラル",
                description: "Seedream を使用して高品質の AI 画像をオンラインで生成します。クリエイティブなプロジェクト向けに、正確で迅速な理解、クリアなテキストのレンダリング、詳細な 2K ～ 4K 出力を実現します。",
                heroHeadline: "Seedream AI 画像ジェネレーター",
                heroIntro: "Seedream AI 画像ジェネレーターを無料で使用します。サインアップすると、無料のクレジットを受け取り、高品質の製品ビジュアル、ポスター、ポートレート、マーケティング画像を即座に作成できます。",
                eyebrow: "ByteDance Seed・Seedream AI",
                sectionKicker: "シードドリームAI",
                ctaTag: "シードドリーム・ミラル",
                badges: ["テキストから画像へ", "意図の理解", "2K/3K/4K出力", "クリアテキストのレンダリング"],
                previewLabel: "シードドリームAI",
                previewMeta: ["1:1", "2K / 3K / 4K", "カスタムサイズ"],
                previewTitle: "創造的な意図から正確な高解像度のビジュアルまで",
                previewDesc: "洗練された詳細と信頼性の高いプロンプト制御を使用して、複雑な構成、製品ショット、ポートレート、テキストが豊富なデザインを作成します。",
                keyFeaturesTitle: "Seedream AI Text to Image Generator で正確なビジュアルを作成",
                keyFeaturesIntro: "Seedream AI の機能を探索して、より深い意図の理解、複雑な構成、高解像度の出力、リアルな詳細、テキストから画像への生成による正確なテキスト レンダリングを実現します。",
                exploreTitle: "Seedream AI モデルを探索する",
                mainFeaturesTitle: "Seedream AI Text-to-Image の主な機能",
                seedream5Desc: "最新の Seedream モデルを使用して、正確なプロンプト、洗練されたリアリズム、テキスト レンダリング、高解像度の出力を実現します。",
                seedream4Desc: "確立された Seedream 4 ワークフローを開き、信頼性の高いテキストから画像への作成と柔軟な出力設定を実現します。",
                features: [
                    { name: "より深く迅速な理解", short: "創造的な意図、空間的な関係、詳細な指示を解釈します。", desc: "Seedream AI は、個別のプロンプト用語の照合を超えています。主題、レイアウト、属性、視覚的コンテキスト間の関係を推論して、複雑なテキスト命令からより一貫した結果を生成します。", demo: { type: 'table', rows: [
                        { prompt: "3x3 のディスプレイ棚、正面図。素材と色ごとに配置された 9 つの異なるオブジェクト、一貫したスタジオ照明、正確な空間配置。", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "折り畳まれたリネンとセラミックのカップの横にある時計、バランスの取れた三角形の構図、柔らかな朝の光のエディトリアル製品写真。", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "前景の買い物客、明確な中心主題、層状の奥行き、濡れた舗道に反射する暖かい光を備えた映画のような市場のシーン。", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "複雑な組成制御", short: "複数の主題、属性、構造化されたレイアウトを一貫性を持って処理します。", desc: "Seedream AI 画像ジェネレーターは、複雑なシーン全体でマルチパートの指示に従い、要求されたオブジェクトの属性、位置、色、および関係を 1 つの構成で保持するのに役立ちます。", prompt: "千鳥状の石の台の上にさまざまな形の 3 つの陶器の花瓶が置かれた正面の編集シーン、最も高い花瓶の背後にある赤い球体、柔らかな側面照明、バランスの取れた間隔、ニュートラルなスタジオの背景。", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "2K、3K、4K出力", short: "プロジェクトに必要な詳細と寸法に基づいて出力解像度を選択します。", desc: "Seedream AI は、Miral で選択可能な 2K、3K、4K 出力に加えて、カスタム画像サイズをサポートします。最終的な用途に必要な寸法と詳細レベルに基づいて選択してください。", prompt: "日の出時の未来的な沿岸都市の広大な映画のような風景、層状の建築、反射する水、大気の深さ、複雑な建物の詳細、パノラマ構成。", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "テキストレンダリングの改善", short: "ポスター、レイアウト、ラベル、プレゼンテーション グラフィック用のより鮮明なテキストを作成します。", desc: "Seedream AI は、視覚的な推論と改善されたテキスト作成を組み合わせて、ポスター、プレゼンテーション グラフィック、広告、パッケージのコンセプト、および読み取り可能なテキストが画像の一部であるその他のレイアウトに役立ちます。", demo: { type: 'table', rows: [
                        { prompt: "「DESIGN FOR TOMORROW」という見出しが付いたミニマルなイベント ポスター、大胆な幾何学的なタイプ、白の背景、緑のアクセント グリッド。", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "「MIRAL ROAST」とラベルされたプレミアムコーヒーパッケージ、簡潔なテイスティングノート、温かみのある紙の質感、スタジオでの商品写真。", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "洗練されたディテールとリアルさ", short: "説得力のある照明、素材、奥行き、製品のプレゼンテーションを作成します。", desc: "Seedream AI は、明瞭さと信頼できる構造が重要な製品写真、ポートレート、エディトリアル ビジュアル、映画のコンセプトに洗練されたテクスチャと一貫した照明をレンダリングします。", prompt: "石灰岩の上にある半透明の緑色の香水瓶、柔らかい朝の光、微妙な影、プレミアム キャンペーンの美しさのきれいなエディトリアル製品写真。", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "プロンプトの例",
                showcaseTitle: "より良い AI 画像を実現する Seedream AI プロンプトの例",
                showcaseIntro: "これらの Seedream AI プロンプトの例を出発点として使用してください。主題、空間関係、テキスト、照明、レイアウトを明確に説明し、プロンプトをジェネレーターに直接送信します。",
                variantsKicker: "解決ガイド",
                variantsTitle: "Seedream AI 解像度ガイド: 2K vs 3K vs 4K",
                variantsIntro: "反復処理の速度と、最終的なアセットに必要な詳細度に基づいて、Seedream AI の出力解像度を選択します。",
                variants: [
                    { name: "2K", tag: "標準出力", desc: "ソーシャル コンテンツ、日常のクリエイティブな作業、標準的なデジタル レイアウトのための実用的な解決策。", bestFor: "通常のデジタルコンテンツに最適" },
                    { name: "3K", tag: "さらに詳しく", desc: "画像の詳細をさらに追加し、マーケティングやプレゼンテーション作業のためのより大きなレイアウトをサポートします。", bestFor: "マーケティングおよびプレゼンテーションのアセットに最適" },
                    { name: "4K", tag: "最大限の詳細", desc: "細かいテクスチャ、テキストの多いレイアウト、または最高の配信品質が重要な場合は、最高のプリセットを使用してください。", bestFor: "最終的なキャンペーンや高解像度の出力に最適" }
                ],
                useCasesKicker: "実際の仕事向けに作られています",
                useCasesTitle: "Seedream AI の人気の使用例",
                useCases: [
                    { name: "Seedream AIによる商品写真撮影", desc: "洗練された製品ショット、ライフスタイル シーン、電子商取引のイメージ コンセプトを作成します。" },
                    { name: "Seedream AI によるマーケティング", desc: "構造化されたキャンペーンのアイデアをソーシャル広告、バナー、ブランド ビジュアルに変換します。" },
                    { name: "ポスターとテキスト用の Seedream AI", desc: "ポスターのコンセプト、プレゼンテーション グラフィック、ラベル、テキストベースのレイアウトを作成します。" },
                    { name: "複雑な構成のための Seedream AI", desc: "複数の主題と要求された属性を一貫した視覚的構造に配置します。" },
                    { name: "Seedream AI のコンセプト アート", desc: "映画のような環境、キャラクター、詳細な視覚的指示を探索します。" },
                    { name: "Seedream AI によるエディトリアルビジュアル", desc: "カバー、イラスト、インフォグラフィック、プレゼンテーション用の画像を作成します。" }
                ],
                howToKicker: "3 つの簡単なステップ",
                howToTitle: "Seedream AI 画像ジェネレーターをオンラインで無料で使用する方法",
                howToIntro: "サインアップして無料のクレジットを受け取り、明確なプロンプトとプロジェクトに必要な解像度を備えた Seedream AI 画像ジェネレーターをオンラインで使用します。",
                howToSteps: [
                    { title: "創造的な意図を入力してください", desc: "主題、空間関係、構図、照明、スタイル、必要なテキストをできるだけ明確に説明します。" },
                    { title: "解像度とサイズを選択してください", desc: "ジェネレーターを開き、最終的な用途に基づいて 2K、3K、4K、またはサポートされているカスタム サイズを選択します。" },
                    { title: "生成とレビュー", desc: "生成を開始し、構成と詳細を確認してから、結果をダウンロードするか、プロンプトを調整します。" }
                ],
                howToCta: "Seedream AI 画像ジェネレーターを無料で使用する",
                faqTitle: "Seedream AI に関するよくある質問",
                faqs: [
                    { q: "Seedream AI画像ジェネレータとは何ですか?", a: "Seedream AI は、ByteDance の Seed チームによるインテリジェントな画像作成モデルです。 Miral では、詳細なテキスト プロンプトを、デザイン、マーケティング、製品コンセプト、ポスター、エディトリアル ビジュアル用の高解像度画像に変換します。" },
                    { q: "クリアテキストの高解像度ポスターを作成するにはどのツールを使用できますか?", a: "Seedream AI は、より深い意図の理解、正確な構成、改善されたテキスト作成、ポスターやその他のテキストの多いレイアウト向けの選択可能な高解像度出力を組み合わせています。" },
                    { q: "Seedream AI 画像ジェネレーターは無料で使用できますか?", a: "はい。サインアップして無料クレジットを受け取り、Seedream AI 画像ジェネレーターを使用して高品質の画像の作成をすぐに開始してください。画像の生成には、対応するクレジットが使用されます。" },
                    { q: "Seedream AI 画像ジェネレーターをオンラインで使用するにはどうすればよいですか?", a: "詳細なテキスト プロンプトを入力し、2K、3K、または 4K 出力を選択し、必要に応じてカスタム サイズを選択して、[生成] をクリックします。より良い結果を得るには、主題、空間関係、属性、照明、テキスト、レイアウトを明確に説明します。" },
                    { q: "Seedream AI は 2K、3K、4K 画像をサポートしていますか?", a: "はい。 Miral は、Seedream AI の 2K、3K、および 4K 解像度のプリセットと、さまざまなアスペクト比や配信ニーズに対応するサポートされるカスタム ディメンションを公開します。" },
                    { q: "Seedream 画像のテキストや構成が正しくない場合はどうすればよいですか?", a: "主題、オブジェクト間の関係、構成、照明、色、スタイル、必要なテキストをより明確に説明します。このページの Seedream の例を出発点として使用し、各視覚的な要件を明確に述べてください。" },
                    { q: "どの Seedream AI 解像度を選択すればよいですか?", a: "標準的なデジタル コンテンツには 2K、マーケティングやプレゼンテーションのレイアウトで詳細が必要な場合は 3K、大規模な最終キャンペーン、ポスター、またはプレミアム デザイン アセットで最大限の詳細が重要な場合は 4K を選択します。" },
                    { q: "Seedream AI と Midjourney: どちらを使用すべきですか?", a: "Seedream AI は、Miral の構造化されたプロンプト、複雑な構成、テキストの多いレイアウト、および選択可能な高解像度出力に非常に適しています。 Midjourney は、その独特の芸術的なワークフローとコミュニティ ツールを好むクリエイターに適しているかもしれません。" }
                ],
                ctaTitle: "Miral で Seedream AI を無料で使用してください!",
                ctaDesc: "無料のクレジットを受け取るにはサインアップしてください。アイデアを説明し、適切な解像度を選択し、Seedream AI 画像ジェネレーターを使用して正確な高解像度のビジュアルを作成します。"
            },
            gptImage: {
                title: "GPT 画像 AI 画像ジェネレーター無料オンライン |ミラル",
                description: "Miral AI の GPT Image および GPT-Image-1.5 を使用して、高品質の AI 画像をオンラインで生成します。ポスター、製品、ポートレートなどに実用的なサイズと品質レベルを選択してください。",
                heroHeadline: "GPT画像AI画像生成器",
                heroIntro: "Miral AI では GPT Image AI 画像ジェネレーターを無料で使用できます。サインアップして無料のクレジットを受け取り、GPT-Image-1.5 を使用して高品質の製品画像、ポスター、ポートレート、マーケティング ビジュアルを即座に作成します。",
                eyebrow: "OpenAI・GPT-Image-1.5",
                sectionKicker: "GPT画像",
                ctaTag: "GPT画像・ミラル",
                badges: ["テキストから画像へ", "選べる品質", "風景 / ポートレート / 正方形", "正確かつ迅速な理解"],
                previewLabel: "GPT 画像-1.5",
                previewMeta: ["1024×1024", "1536×1024", "1024×1536"],
                previewTitle: "書かれたアイデアから洗練された実用的な AI イメージまで",
                previewDesc: "明確なプロンプトと選択可能な品質を使用して、製品のビジュアル、ポスター、ポートレート、ブランド コンテンツを作成します。",
                keyFeaturesTitle: "GPT Image AI 画像ジェネレーターで高品質のビジュアルを作成",
                keyFeaturesIntro: "GPT-Image-1.5 の機能を探索して、迅速な理解、品質管理、実用的な画像サイズ、プロフェッショナルなビジュアル作成を実現します。",
                features: [
                    { name: "自然言語と複数の主題に関するプロンプト", short: "主題、構図、照明、スタイル、視覚的な関係を自然言語で説明します。", desc: "GPT Image AI 画像ジェネレーターは、複数の件名、属性、構成要件を含む自然言語プロンプトをサポートします。単純なプロンプトから始めるか、各被写体の位置、色、関係を指定して、より一貫性のある複数の被写体の画像を作成します。", demo: { type: 'table', rows: [
                        { prompt: "淡い石の台座に置かれた透明な香水瓶のエディトリアル製品写真、左からの柔らかな朝の光、きれいな背景、浅い被写界深度、プレミアム ブランドの美学。", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "雨が降る夜の街路、さまざまな色の傘を差した前景の3人の歩行者、遠くを通過する路面電車、濡れた歩道に反射するネオン、映画のような幅広い構成。", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "GPT-Image-1.5 品質管理", short: "速度と詳細のニーズに基づいて、自動、低、中、または高を選択します。", desc: "GPT-Image-1.5 には、自動、低、中、高品質の設定が用意されています。迅速な調査には低品質を使用し、最終製品の画像、ポスター、またはマーケティング資産には高品質を使用します。", prompt: "黒い背景にイチゴケーキの高品質の食品広告、サクサクしたクリームの質感、柔らかなリムライト、詳細な食品の写真、商業的な構成。", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "実用的な 3 つの画像サイズ", short: "正方形、横長、縦長の出力を作成します。", desc: "ソーシャル投稿、バナーおよびプレゼンテーションビジュアル、またはポートレートポスターおよびモバイルコンテンツには、1024×1024、1536×1024、または 1024×1536 を選択します。", prompt: "朝霧の中に海辺の崖と灯台が描かれた1024×1536の縦長の旅行ポスター、上部に見出し用のスペース、モダンな編集レイアウト。", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "クリアテキストとレイアウトの作成", short: "テキストを含むポスター、ラベル、ブランドコンセプトを作成します。", desc: "GPT Image は、必要なコピー、配置、タイポグラフィの雰囲気、レイアウトの関係を明確に記述することで、ポスター、パッケージ、イベント グラフィック、および見出し付きのマーケティング イメージを探索するのに役立ちます。", demo: { type: 'table', rows: [
                        { prompt: "「CREATE THE FUTURE」という見出しが付いたミニマリストのテクノロジー イベント ポスター、大胆なサンセリフ体、深い青色の背景、緑色の幾何学的なグリッド、明確な中央の見出し。", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "前面に「MIRAL ROAST」の文字が入ったプレミアムコーヒーパッケージのコンセプト、温かみのある茶色の紙の質感、きれいなラベル、スタジオでの商品写真。", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "ディテールとリアリズム", short: "信頼できる素材、照明、人物、製品の詳細をレンダリングします。", desc: "GPT Image は、プロンプトに素材、カメラの選択、照明、被写界深度が明確に説明されている場合、製品写真、ポートレート、インテリア、エディトリアル ビジュアルに適しています。", prompt: "自然な窓の光、リアルな肌の質感、手についた粘土の粉、ワークショップの背景、浅い被写界深度、温かみのあるエディトリアル写真で陶芸家をクローズアップしたエディトリアルポートレート。", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "プロンプトの例",
                showcaseTitle: "より良い AI 画像のための GPT 画像プロンプトの例",
                showcaseIntro: "これらの GPT イメージ プロンプトを開始点として使用してください。主題、構図、照明、スタイル、素材、必要なテキストを明確に説明します。",
                variantsKicker: "バージョンガイド",
                variantsTitle: "GPT イメージ 1.5 と GPT イメージ 1",
                variantsIntro: "品質管理が必要かどうかに基づいて GPT イメージのバージョンを選択します。どちらも実用的な正方形、横長、縦長のサイズをサポートしています。",
                variants: [
                    { name: "GPT 画像-1.5", tag: "おすすめ", desc: "自動、低、中、高品質オプションで 1024×1024、1536×1024、および 1024×1536 をサポートします。", bestFor: "品質管理が必要な日常業務および専門業務に最適" },
                    { name: "GPT 画像-1", tag: "クラシック", desc: "よりシンプルなコントロール セットを使用して、同じ 3 つの実用的な画像サイズをサポートします。", bestFor: "簡単な汎用のテキストから画像への作成に最適" }
                ],
                useCasesKicker: "実際の仕事向けに作られています",
                useCasesTitle: "一般的な GPT イメージの使用例",
                useCases: [
                    { name: "製品写真およびモックアップ用の GPT イメージ", desc: "製品のヒーロー イメージ、ライフスタイル シーン、製品モックアップ、電子商取引のビジュアル コンセプトを作成します。" },
                    { name: "電子商取引リスト画像用の GPT イメージ", desc: "製品リストの画像、フィーチャー グラフィック、パッケージの表示、広告のコンセプトを調べます。" },
                    { name: "マーケティングおよびソーシャルメディア広告用の GPT 画像", desc: "ソーシャル メディア広告、キャンペーン バナー、電子メール バナー、ブランドのマーケティング ビジュアルを作成します。" },
                    { name: "UI/UX および Web サイトのレイアウト用の GPT イメージ", desc: "アプリのインターフェイス、Web サイトのレイアウト、ランディング ページ、製品ショーケース ページのビジュアル コンセプトを生成します。" },
                    { name: "インフォグラフィックスおよびビジュアルレポート用の GPT 画像", desc: "インフォグラフィックス、ビジュアルレポート、プレゼンテーショングラフィックスのレイアウトコンセプトを探ります。最終的に使用する前に、すべてのテキストとデータを確認してください。" },
                    { name: "ポスターおよび製品パッケージ用の GPT 画像", desc: "見出しとレイアウトの要件を考慮して、ポスター、製品ラベル、パッケージのデザインを検討します。" },
                    { name: "本の表紙とブログ画像用の GPT 画像", desc: "本の表紙、エディトリアルイラスト、ブログのヘッダー、出版のビジュアルコンセプトを作成します。" },
                    { name: "ポートレート用の GPT 画像", desc: "照明、背景、スタイリングを制御してエディトリアルポートレートを作成します。" },
                    { name: "ゲーム キャラクター コンセプトの GPT イメージ", desc: "ゲームのキャラクター、衣装、小道具、さまざまな芸術的方向性をすばやく探索できます。" },
                    { name: "ゲーム環境用の GPT イメージ", desc: "ゲーム環境、映画のようなシーン、世界構築のコンセプトを生成して、初期の創造的な探求を実現します。" },
                    { name: "ソーシャル コンテンツの GPT イメージ", desc: "さまざまなプラットフォーム向けに正方形、横長、縦長の画像を生成します。" }
                ],
                howToKicker: "3 つの簡単なステップ",
                howToTitle: "GPT Image AI 画像ジェネレーターをオンラインで無料で使用する方法",
                howToIntro: "サインアップして無料クレジットを受け取り、Miral で GPT Image AI 画像ジェネレーターをオンラインで使用してください。",
                howToSteps: [
                    { title: "詳細なプロンプトを入力してください", desc: "主題、設定、構成、照明、スタイル、素材、および必要なテキストについて説明します。" },
                    { title: "サイズと品質を選択してください", desc: "正方形、横長、または縦長のサイズを選択し、ニーズに基づいて GPT-Image-1.5 の品質を設定します。" },
                    { title: "生成とレビュー", desc: "生成を開始し、イメージを確認してダウンロードするか、プロンプトを調整して別のバージョンを作成します。" }
                ],
                howToCta: "GPT Image AI 画像ジェネレーターを無料で使用する",
                faqTitle: "GPT イメージに関するよくある質問",
                faqs: [
                    { q: "GPT Image AI画像生成ツールとは何ですか?", a: "GPT Image は、OpenAI の汎用テキストから画像へのモデル ファミリです。 Miral では、GPT Image AI 画像ジェネレーターが、書かれたプロンプトをデザイン、マーケティング、製品コンセプト、ポスター、ソーシャル コンテンツ用の高品質画像に変換します。" },
                    { q: "GPT Image AI 画像ジェネレーターを無料で使用できますか?", a: "はい。サインアップして無料クレジットを受け取り、GPT Image AI 画像ジェネレーターを使用して高品質の画像の作成をすぐに開始してください。画像の生成には、対応するクレジットが使用されます。" },
                    { q: "GPT Image AI 画像ジェネレーターをオンラインで使用するにはどうすればよいですか?", a: "詳細なプロンプトを入力し、1024×1024、1536×1024、または 1024×1536 を選択します。 GPT-Image-1.5 では、「生成」をクリックする前に、自動、低、中、または高品質を選択することもできます。" },
                    { q: "GPT-Image-1.5 と GPT-Image-1 の違いは何ですか?", a: "どちらのバージョンも、同じ 3 つの実用的な画像サイズをサポートしています。 Miral の GPT-Image-1.5 は、自動、低、中、高品質の制御も提供しますが、GPT-Image-1 にはより単純なパラメーター セットがあります。" },
                    { q: "GPT Image はどのような画像サイズをサポートしていますか?", a: "Miral では、GPT-Image-1 および GPT-Image-1.5 は、1024×1024 の正方形、1536×1024 の横長の画像、および 1024×1536 の縦長の画像をサポートしています。" },
                    { q: "どの GPT 画質を選択すればよいですか?", a: "プロンプトを迅速にテストする場合は低または中を選択し、最終製品の画像、ポスター、またはマーケティング資産の場合は高を選択し、不明な場合は自動を選択します。品質オプションは GPT-Image-1.5 に適用されます。" },
                    { q: "プロンプトと一致しない GPT イメージの結果を修正するにはどうすればよいですか?", a: "主題、設定、構図、照明、カメラ、素材、スタイル、その他必要なテキストをより明確に説明します。このページの GPT イメージの例を出発点として使用し、プロジェクトに適応させてください。" },
                    { q: "GPT イメージを使用するには、迅速なエンジニアリング経験が必要ですか?", a: "いいえ。単純な自然言語プロンプトから始めて、必要に応じて被写体の位置、構図、照明、色、素材、テキストの要件を追加します。一般に、説明が明確になると、結果がクリエイティブな意図とより一致するようになります。" },
                    { q: "電子商取引の製品画像、ポスター、UI コンセプトを作成するにはどのツールを使用できますか?", a: "GPT Image は、電子商取引のリスト画像、製品モックアップ、ポスター、UI/UX コンセプト、Web サイトのレイアウト、インフォグラフィックのレイアウト、本の表紙、ブログの画像、電子メールのバナー、ゲームのコンセプトを作成できます。最終的に使用する前に、テキスト、データ、ブランド要素、構造の詳細を確認してください。" },
                    { q: "GPT イメージと Midjourney: どちらを使用すべきですか?", a: "GPT Image は、明確なプロンプト制御、実用的な画像サイズ、およびブラウザーによる直接生成に非常に適しています。 Midjourney は、芸術的なスタイル、参照画像のワークフロー、クリエイティブなプロセスを好むユーザーに適しているかもしれません。" }
                ],
                ctaTitle: "Miral で GPT 画像を無料で使用してください!",
                ctaDesc: "無料のクレジットを受け取るにはサインアップしてください。アイデアを説明し、サイズと品質を選択し、GPT Image AI 画像ジェネレーターを使用して高品質のビジュアルを作成します。"
            },
            qwenImage2Pro: {
                title: "Qwen Image 2.0 Pro AI 画像ジェネレーター無料オンライン |ミラル",
                description: "Qwen Image 2.0 Pro を使用して AI イメージをオンラインで作成します。ネガティブ プロンプト、プロンプト拡張、柔軟なアスペクト比を使用し、実行ごとに最大 4 つの画像を生成します。",
                heroHeadline: "Qwen Image 2.0 Pro AI 画像ジェネレーター",
                heroIntro: "Miral AI では、Qwen Image 2.0 Pro AI 画像ジェネレーターを無料で使用できます。サインアップして無料クレジットを受け取り、ネガティブ プロンプト、即時補正、柔軟なアスペクト比を備えた高品質の画像をすばやく作成します。",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "クウェン イメージ 2.0 プロ",
                ctaTag: "Qwen Image 2.0 Pro・ミラル",
                badges: ["テキストから画像へ", "否定的なプロンプト", "即時強化", "1 ～ 4 枚の画像 / 実行", "柔軟なアスペクト比"],
                previewLabel: "クウェン イメージ 2.0 プロ",
                previewMeta: ["1:1", "2048×2048", "最大 1 ～ 4 枚の画像"],
                previewTitle: "除外を含む正確なプロンプトから洗練されたビジュアルまで",
                previewDesc: "ポジティブ プロンプトとネガティブ プロンプトおよびプロンプト拡張を組み合わせて、1 回の実行で複数のオンターゲット イメージを生成します。",
                keyFeaturesTitle: "Qwen Image 2.0 Pro Text to Image Generator で正確なビジュアルを作成",
                keyFeaturesIntro: "微調整、ネガティブ プロンプト、プロンプト強化、バッチ出力、柔軟なアスペクト比など、Qwen Image 2.0 Pro AI 画像ジェネレーターの主要な機能を調べてください。",
                mainFeaturesTitle: "Qwen Image 2.0 Pro の主要な機能",
                promptLabel: "ポジティブプロンプト",
                negativePromptLabel: "否定的なプロンプト",
                shortPromptLabel: "ショートプロンプト",
                negativePromptFallback: "鮮明度が低い、細部が歪んでいる、乱雑な構成",
                features: [
                    { name: "ネガティブプロンプトコントロール", short: "よりクリーンで目標どおりの結果を得るために何を除外すべきかを説明します。", desc: "Qwen Image 2.0 Pro AI 画像ジェネレーターは専用のネガティブ プロンプトをサポートしているため、低明瞭さ、変形した手、乱雑な構図など、避けるべきものをモデルに指示できます。これにより、最終イメージをより細かく制御できるようになり、繰り返し再ロールする必要が減ります。", demo: { type: 'table', rows: [
                        { prompt: "濡れた石、柔らかい朝の光、きれいな背景の上にガラスのスキンケア ボトルのプレミアム製品写真。 (マイナス: 乱雑な背景、低解像度、変形した反射。)", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "秋の光、自然な肌の質感、浅い被写界深度の若い女性のポートレート。 (マイナス: 滑らかすぎる肌、ワックス状の外観、彩度の高すぎる色。)", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "即時強化", short: "必要に応じて、短いプロンプトをより詳細な内容に拡張します。", desc: "プロンプト拡張をオンにすると、Qwen Image 2.0 Pro は、生成前に短いプロンプトに追加の詳細を自動的に追加します。これにより、専門家以外のプロンプトが手動で書き直すことなく、より完全で鮮明な画像を生成できるようになります。", demo: { type: 'table', rows: [
                        { prompt: "雨が降る窓際の居心地の良い読書コーナー。", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "夜の雨に覆われた窓の横にある木製の読書机、開いた本と湯気の立つお茶を照らす暖かいタスクランプ、静かで居心地の良いインテリア。", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "一度に 1 ～ 4 枚の画像を生成", short: "1 回の実行で複数のバリエーションを生成します。", desc: "Qwen Image 2.0 Pro はリクエストごとに最大 4 つの画像を生成できるため、コンセプト、角度、スタイルのバリエーションを並べて比較し、最適な画像を選択できます。これにより、マーケティングや製品ビジュアルのクリエイティブな探索がスピードアップされます。", prompt: "クルミ材のサイドテーブルに置かれたミニマリストのセラミックテーブルランプ、暖かい夜のインテリア、クリーム色の壁、柔らかい影、スカンジナビアの製品写真。", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "柔軟なアスペクト比", short: "横長、縦長、正方形、またはカスタム サイズを選択します。", desc: "2688×1536 横長、1536×2688 縦長、2048×2048 正方形、2368×1728 / 1728×2368 などの既製のアスペクト比から選択するか、512×512 ～ 2048×2048 のカスタム サイズを入力します。これにより、Qwen Image 2.0 Pro のテキストから画像へのジェネレーターは、バナー、ポスター、ソーシャル投稿、正方形のサムネイルなどに適したものになります。", prompt: "ゴールデンアワーの海岸の崖、ドラマチックな雲、細かい岩のディテールを撮影した映画のような広い風景ショット、2688×1536。", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "洗練されたディテールとリアリズム", short: "本物のようなテクスチャ、照明、奥行きをレンダリングします。", desc: "Qwen Image 2.0 Pro は、細かいテクスチャ、リアルな照明、自然な奥行きを生成し、信憑性が重要な製品写真、ポートレート、エディトリアル ビジュアルにしっかりと適合します。", prompt: "太陽に照らされた工房にいる年配の陶芸家のクローズアップの編集ポートレート、自然な肌の質感、手についた粘土の粉、暖かい窓の光、浅い被写界深度。", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "プロンプトの例",
                showcaseTitle: "より良い AI 画像のための Qwen Image 2.0 Pro プロンプトの例",
                showcaseIntro: "これらの Qwen Image 2.0 Pro プロンプトの例を出発点として使用してください。各肯定的なプロンプトを否定的なプロンプトと組み合わせて不要な要素を削除し、ジェネレーターに直接送信します。",
                useCasesKicker: "実際の仕事向けに作られています",
                useCasesTitle: "Qwen Image 2.0 Pro の人気の使用例",
                useCases: [
                    { name: "製品写真用 Qwen Image 2.0 Pro", desc: "乱雑さを取り除くためにネガティブプロンプトを使用して、背景を制御したクリーンな製品ショットを作成します。" },
                    { name: "マーケティング向け Qwen Image 2.0 Pro", desc: "キャンペーンのコンセプト、ソーシャル広告、バナーを複数のアスペクト比で生成します。" },
                    { name: "ポスターとタイポグラフィー用の Qwen Image 2.0 Pro", desc: "明確な見出しとラベルを使用して、ポスターのレイアウトとテキストが豊富なデザインを作成します。" },
                    { name: "Qwen Image 2.0 Pro ポートレート用", desc: "アーティファクトを避けるために否定的なプロンプトを使用して、自然な肌の質感を持つ詳細なポートレートを生成します。" },
                    { name: "コンセプト アート用の Qwen Image 2.0 Pro", desc: "実行ごとに 1 ～ 4 つのバリエーションを使用して、キャラクター、環境、視覚的な方向性を探索します。" },
                    { name: "電子商取引用 Qwen Image 2.0 Pro", desc: "1 世代でリスティングや広告用に複数のイメージ バリエーションを作成します。" }
                ],
                howToKicker: "3 つの簡単なステップ",
                howToTitle: "Qwen Image 2.0 Pro AI 画像ジェネレーターをオンラインで使用する方法",
                howToIntro: "Miral で Qwen Image 2.0 Pro AI 画像ジェネレーターをオンラインで使用し、肯定的なプロンプト、否定的なプロンプト、および柔軟な出力制御を使用します。",
                howToSteps: [
                    { title: "メインプロンプトを入力してください", desc: "希望する主題、シーン、構成、照明、スタイル、および視覚的な詳細について説明します。" },
                    { title: "生成制御の構成", desc: "必要に応じて否定的なプロンプトを追加し、プロンプトの拡張を有効にして、サイズを選択し、1 ～ 4 つの画像を選択します。" },
                    { title: "生成して比較する", desc: "生成を開始し、返されたバリエーションを比較して、意図に最も一致するイメージをダウンロードします。" }
                ],
                howToCta: "Qwen Image 2.0 Pro AI 画像ジェネレーターをお試しください",
                faqTitle: "Qwen Image 2.0 Pro に関するよくある質問",
                faqs: [
                    { q: "Qwen Image 2.0 Pro AI 画像ジェネレーターとは何ですか?", a: "Qwen Image 2.0 Pro は、Alibaba の Tongyi Qwen テキストから画像へのモデルです。 Qwen Image 2.0 Pro AI 画像ジェネレーターは、書かれたプロンプトを高品質で詳細な画像に変換し、Miral でアート、デザイン、マーケティング、製品のビジュアル作成にブラウザーで直接利用できます。" },
                    { q: "否定的なプロンプトを含む複数の製品画像のバリエーションを作成するには、どのツールを使用できますか?", a: "Qwen Image 2.0 Pro は、専用のネガティブ プロンプト、オプションのプロンプト強化、実行ごとに 1 ～ 4 枚の画像、および製品写真、マーケティング、電子商取引のビジュアル バリエーション用の柔軟なアスペクト比を提供します。" },
                    { q: "Qwen Image 2.0 Pro AI 画像ジェネレーターを無料で使用できますか?", a: "はい。サインアップして無料のクレジットを受け取り、Qwen Image 2.0 Pro AI 画像ジェネレーターを使用して高品質の画像の作成をすぐに開始してください。画像の生成には、対応するクレジットが使用されます。" },
                    { q: "Qwen Image 2.0 Pro AI 画像ジェネレーターをオンラインで使用するにはどうすればよいですか?", a: "詳細なテキスト プロンプトを入力し、必要に応じて回避すべき内容を説明する否定的なプロンプトを追加し、必要に応じてプロンプト拡張をオンにし、アスペクト比またはカスタム サイズを選択し、生成する画像の数 (1 ～ 4) を設定して、[生成] をクリックします。 Qwen Image 2.0 Pro は、マーケティング資料、製品写真、ポートレート、ポスター デザインに適しています。" },
                    { q: "Qwen Image 2.0 Pro の結果の不要な要素を修正するにはどうすればよいですか?", a: "低い透明度、変形した手、乱雑な背景など、望ましくない要素を説明する否定的なプロンプトを追加します。 Qwen Image 2.0 Pro は、これらの結果から生成を遠ざけるためにこれを使用します。" },
                    { q: "Qwen Image 2.0 Pro は一度に何枚の画像を生成できますか?", a: "Qwen Image 2.0 Pro は、1 回のリクエストで最大 4 枚の画像を生成できるため (n = 1 ～ 4)、コンセプト、角度、スタイルのバリエーションを比較し、最適な画像を選択できます。" },
                    { q: "Qwen Image 2.0 Pro はどのサイズとアスペクト比をサポートしていますか?", a: "Miral では、Qwen Image 2.0 Pro は、2688×1536、1536×2688、2048×2048、2368×1728、1728×2368 などの既製の比率に加えて、512×512 から 2048×2048 までのカスタム サイズを提供します。これは、バナー、ポスター、ソーシャル投稿、サムネイルの横長、縦長、正方形の出力をカバーします。" },
                    { q: "Qwen Image 2.0 Pro プロンプトの最良の例は何ですか?", a: "Qwen Image 2.0 Pro の効果的なプロンプトは、主題、設定、構成、照明、スタイルを明確に説明し、ポジティブなプロンプトとネガティブなプロンプトを組み合わせて、不要な詳細を削除します。このページにある Qwen Image 2.0 Pro プロンプトの例を開始点として使用し、プロジェクトに合わせてカスタマイズします。" },
                    { q: "Qwen Image 2.0 Pro と Midjourney: どちらを使用すべきですか?", a: "普遍的な勝者ではなく、ワークフローに基づいて選択してください。 Qwen Image 2.0 Pro は、Miral 上のブラウザベースのジェネレーターで、明示的な否定的なプロンプト、プロンプトの強化、実行ごとに 1 ～ 4 枚の画像、および柔軟なアスペクト比が必要な場合に最適です。 Midjourney は、その独特の芸術的なワークフローとコミュニティ ツールを好むクリエイターに適しているかもしれません。" }
                ],
                ctaTitle: "Miral で Qwen Image 2.0 Pro を無料でお試しください!",
                ctaDesc: "上記のアイデアを入力し、オプションのコントロールを備えた Qwen Image 2.0 Pro AI 画像ジェネレーターを使用して、正確な画像バリエーションを作成します。"
            },
            stableDiffusion: {
                title: "Stable Diffusion 3.5 AI 画像ジェネレーター無料オンライン |ミラル",
                description: "Stable Diffusion 3.5 を使用してオンラインで AI 画像を生成します。 Miral では、ネガティブ プロンプト、プリセットのアスペクト比、および 512 ～ 2048 ピクセルのカスタム サイズを使用します。",
                heroHeadline: "Stable Diffusion 3.5 AI 画像生成ツール",
                heroIntro: "Miral AI では、Stable Diffusion 3.5 AI 画像ジェネレーターを無料で使用できます。サインアップして無料のクレジットを受け取り、詳細なプロンプト、否定的なプロンプト、および柔軟なサイズを備えた高品質の画像をすばやく作成します。",
                eyebrow: "安定AI・安定拡散3.5",
                sectionKicker: "安定拡散 3.5",
                ctaTag: "安定拡散3.5・ミラル",
                badges: ["テキストから画像へ", "否定的なプロンプト", "柔軟なアスペクト比", "カスタムサイズ"],
                previewLabel: "安定拡散 3.5",
                previewMeta: ["1:1", "512 – 2048", "64の倍数"],
                previewTitle: "詳細なプロンプトから、制御された洗練されたイメージまで",
                previewDesc: "ポジティブなプロンプトとネガティブなプロンプトを組み合わせて、適切なアスペクト比を選択して、Stable Diffusion 3.5 をクリーンで的を射たビジュアルに導きます。",
                keyFeaturesTitle: "Stable Diffusion 3.5 Text to Image Generator を使用して制御されたビジュアルを作成する",
                keyFeaturesIntro: "否定的なプロンプト、柔軟なアスペクト比、カスタム サイズ、プロンプトの詳細な理解のために、Stable Diffusion 3.5 AI 画像ジェネレーターの主要な機能を調べてください。",
                exploreTitle: "AI 画像モデルをさらに探索する",
                mainFeaturesTitle: "Stable Diffusion 3.5 の主な機能",
                generatedImageLabel: "生成された画像",
                versionLabel: "制御",
                featureLabel: "何が変わるのか",
                useCaseLabel: "最適な用途",
                variantsTitle: "Stable Diffusion 3.5 出力制御",
                variantsIntro: "Stable Diffusion 3.5 モデルを、必要な最終レイアウトに基づいてプリセットされたアスペクト比または正確なカスタム寸法と組み合わせます。",
                variants: [
                    { name: "安定拡散 3.5", desc: "ポジティブおよびネガティブプロンプト制御による詳細なテキストから画像への生成。", bestFor: "製品ビジュアル、ポートレート、コンセプトアート、マーケティング画像。" },
                    { name: "プリセットのアスペクト比", desc: "既製の横長、縦長、正方形の出力サイズ。", bestFor: "ソーシャル投稿、バナー、ポスター、サムネイル。" },
                    { name: "カスタム画像サイズ", desc: "正確な幅と高さは 512 ～ 2048 の 64 の倍数です。", bestFor: "正確なピクセル寸法を必要とするレイアウト スロットとプロジェクト。" }
                ],
                controlsTitle: "適切なプロンプト コントロールと画像サイズを選択する",
                controlsIntro: "否定的なプロンプトを使用して不要な詳細を減らし、プリセット比率を選択するか、目的のチャンネルのカスタム寸法を入力します。",
                galleryTitle: "より安定した Diffusion 3.5 画像の例",
                discussionTitle: "Stable Diffusion 3.5 に関する一般的な質問",
                communityTitle: "Stable Diffusion 3.5 を使用した一般的な作成方法",
                tutorialPrompt: "淡い石の上に彫刻的なセラミック スピーカーのエディトリアル製品写真、柔らかな朝の窓の光、リアルな質感、バランスのとれた構成、微妙な影、きれいな背景。",
                qualityBenefits: [
                    "否定的なプロンプトを使用して、乱雑さ、不正な詳細、および不要な表示スタイルを削減します。",
                    "主題、構図、照明、素材、雰囲気の階層的な説明に従います。",
                    "プリセットまたは正確なカスタム寸法を使用して、横長、縦長、正方形の画像を作成します。"
                ],
                features: [
                    { name: "ネガティブプロンプトコントロール", short: "よりクリーンで目標どおりの結果を得るために何を除外すべきかを説明します。", desc: "Stable Diffusion 3.5 AI 画像ジェネレーターは専用のネガティブ プロンプトをサポートしているため、低明瞭さ、変形した手、乱雑な背景など、避けるべきものをモデルに指示できます。これにより、最終イメージをより細かく制御できるようになり、繰り返し再ロールする必要が減ります。", demo: { type: 'table', rows: [
                        { prompt: "大理石の台座にマットブラックのセラミック花瓶、柔らかいスタジオライト、きれいな背景のプレミアム製品写真。 (マイナス: 乱雑な背景、低解像度、変形した反射。)", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "柔らかい窓の光、自然な肌の質感、浅い被写界深度の中の若い男性のポートレート。 (マイナス: 滑らかすぎる肌、ワックス状の外観、彩度の高すぎる色。)", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "柔軟なアスペクト比", short: "横向き、縦向き、正方形、またはカスタム サイズを選択します。", desc: "1024×1024、1280×1280、896×1536、1536×896、768×1344、1344×768、1024×1536、1536×1536などの既製のアスペクト比から選択するか、512×512から512×512までのカスタム サイズを入力します。 2048×2048。これにより、Stable Diffusion 3.5 のテキストから画像へのジェネレーターは、バナー、ポスター、ソーシャル投稿、正方形のサムネイルなどに適したものになります。", prompt: "ゴールデンアワーの海岸の崖、ドラマチックな雲、細かい岩のディテールを撮影した映画のような広い風景ショット、1536×896。", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "カスタム画像サイズ", short: "正確な出力のために正確なピクセル寸法を設定します。", desc: "プリセットが適合しない場合は、カスタム サイズに切り替えて、512 ～ 2048 の幅と高さを 64 の倍数で入力します。これにより、手動でトリミングせずに、特定のレイアウト、バナー スロット、または印刷面に一致させることができます。", prompt: "中央に幾何学的な構成を備えたミニマリストのポスター背景、深い青のグラデーション、微妙な粒子、1280×1280。", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "詳細かつ迅速な理解", short: "主題、光、スタイルの階層的な説明に従います。", desc: "Stable Diffusion 3.5 は、レイヤー化されたテキストの指示を読み取り、説明した主題、設定、照明、雰囲気をレンダリングします。明確な肯定的なプロンプトと否定的なプロンプトを組み合わせて、より少ない試行で結果を意図に近づけます。", demo: { type: 'table', rows: [
                        { prompt: "折り畳まれたリネンとセラミックのカップの横にある腕時計のエディトリアル製品写真、バランスのとれた三角形の構図、柔らかな朝の光。", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "雨が降る窓辺の居心地の良い読書コーナー、暖かいランプの光、積み上げられた本、織り目加工の毛布、映画のような雰囲気。", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "洗練されたディテールとリアルさ", short: "信頼できる照明、マテリアル、奥行きをレンダリングします。", desc: "Stable Diffusion 3.5 は、細かいテクスチャ、リアルな照明、自然な奥行きを生成し、Stable Diffusion 3.5 AI 画像ジェネレーターを、信憑性が重要な製品写真、ポートレート、コンセプト アート、エディトリアル ビジュアルに確実に適合させます。", prompt: "太陽に照らされた工房にいる年配の陶芸家のクローズアップの編集ポートレート、自然な肌の質感、手についた粘土の粉、暖かい窓の光、浅い被写界深度。", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "プロンプトの例",
                showcaseTitle: "より良い AI 画像のための Stable Diffusion 3.5 プロンプトの例",
                showcaseIntro: "これらの Stable Diffusion 3.5 プロンプトの例を出発点として使用してください。主題、構成、照明、スタイルを明確に説明し、各プロンプトを否定的なプロンプトと組み合わせて、ジェネレーターに直接送信します。",
                useCasesKicker: "実際の仕事向けに作られています",
                useCasesTitle: "人気のある Stable Diffusion 3.5 の使用例",
                useCases: [
                    { name: "商品写真用のStable Diffusion 3.5", desc: "乱雑さを取り除くためにネガティブプロンプトを使用して、背景を制御したクリーンな製品ショットを作成します。" },
                    { name: "マーケティング向けの安定した拡散 3.5", desc: "キャンペーンのコンセプト、ソーシャル広告、バナーを複数のアスペクト比で生成します。" },
                    { name: "ポスターとレイアウト用の Stable Diffusion 3.5", desc: "ポスターの背景とレイアウトに対応したビジュアルをカスタム ピクセル サイズで作成します。" },
                    { name: "ポートレート用の安定した拡散 3.5", desc: "アーチファクトを避けるために否定的なプロンプトを使用して、自然な肌の質感を備えた詳細なポートレートを生成します。" },
                    { name: "コンセプトアート用の安定した拡散 3.5", desc: "階層化されたプロンプトを使用して、キャラクター、環境、視覚的な指示を探索します。" },
                    { name: "ソーシャル コンテンツの安定した拡散 3.5", desc: "さまざまなソーシャル プラットフォームに合わせてサイズを調整した正方形、縦長、横長の画像を作成します。" }
                ],
                howToKicker: "3 つの簡単なステップ",
                howToTitle: "Stable Diffusion 3.5 AI 画像ジェネレーターをオンラインで使用する方法",
                howToIntro: "明確なプロンプト、否定的なプロンプト、プロジェクトに必要なアスペクト比を指定して、Miral でオンラインの Stable Diffusion 3.5 AI 画像ジェネレーターを使用します。",
                howToSteps: [
                    { title: "メインプロンプトを入力してください", desc: "希望する主題、シーン、構成、照明、スタイル、および視覚的な詳細について説明します。" },
                    { title: "生成制御の構成", desc: "必要に応じて否定プロンプトを追加し、既製のアスペクト比を選択するか、カスタム サイズを入力します。" },
                    { title: "生成とレビュー", desc: "生成を開始し、結果を確認し、イメージをダウンロードするか、別のパスのプロンプトを調整します。" }
                ],
                howToCta: "Stable Diffusion 3.5 AI 画像ジェネレーターを試す",
                faqTitle: "Stable Diffusion 3.5 に関するよくある質問",
                faqs: [
                    { q: "Stable Diffusion 3.5 AI 画像ジェネレーターとは何ですか?", a: "Stable Diffusion 3.5 は、Stability AI のテキストから画像へのモデルです。 Stable Diffusion 3.5 AI 画像ジェネレーターは、書かれたプロンプトを詳細な画像に変換し、Miral でアート、デザイン、マーケティング、製品のビジュアル作成にブラウザーで直接利用できます。" },
                    { q: "ネガティブプロンプトを含むカスタムサイズの画像を作成するにはどのツールを使用できますか?", a: "Stable Diffusion 3.5 は、製品写真、マーケティング ビジュアル、ポートレート、コンセプト アート向けに、専用のネガティブ プロンプト、既製のアスペクト比、および 512 ～ 2048 のカスタム サイズを提供します。" },
                    { q: "Stable Diffusion 3.5 AI 画像ジェネレーターを無料で使用できますか?", a: "はい。サインアップして無料のクレジットを受け取り、Stable Diffusion 3.5 AI 画像ジェネレーターを使用して高品質の画像の作成をすぐに開始してください。画像の生成には、対応するクレジットが使用されます。" },
                    { q: "Stable Diffusion 3.5 AI 画像ジェネレーターをオンラインで使用するにはどうすればよいですか?", a: "詳細なテキスト プロンプトを入力し、オプションで回避すべき内容を説明する否定的なプロンプトを追加し、既製のアスペクト比を選択するかカスタム サイズを入力して、「生成」をクリックします。 Stable Diffusion 3.5 は、マーケティング資料、製品写真、ポートレート、ポスター レイアウトに適しています。" },
                    { q: "Stable Diffusion 3.5 画像の不要なディテールや変形したディテールを修正するにはどうすればよいですか?", a: "低い透明度、変形した手、乱雑な背景など、望ましくない要素を説明する否定的なプロンプトを追加します。 Stable Diffusion 3.5 は、生成をこれらの結果から遠ざけるためにこれを使用します。" },
                    { q: "Stable Diffusion 3.5 はどのサイズとアスペクト比をサポートしますか?", a: "Miral では、Stable Diffusion 3.5 は、1024×1024、1280×1280、896×1536、1536×896、768×1344、1344×768、1024×1536、1536×1536 などの既製の比率に加えて、カスタム サイズを提供します。 512×512 から 64 の倍数で最大 2048×2048。これは、バナー、ポスター、ソーシャル投稿、サムネイルの横長、縦長、および正方形の出力をカバーします。" },
                    { q: "Stable Diffusion 3.5 プロンプトの最良の例は何ですか?", a: "効果的な安定拡散 3.5 のプロンプトは、主題、設定、構成、照明、スタイルを明確に説明し、ポジティブなプロンプトとネガティブなプロンプトを組み合わせて、不要な詳細を削除します。このページの Stable Diffusion 3.5 プロンプトの例を開始点として使用し、プロジェクトに合わせてカスタマイズします。" },
                    { q: "Stable Diffusion 3.5 と Midjourney: どちらを使用すべきですか?", a: "普遍的な勝者ではなく、ワークフローに基づいて選択してください。 Stable Diffusion 3.5 は、Miral のブラウザベースのジェネレーターで明示的な否定プロンプト、既成のアスペクト比、カスタム ピクセル サイズが必要な場合に最適です。 Midjourney は、その独特の芸術的なワークフローとコミュニティ ツールを好むクリエイターに適しているかもしれません。" }
                ],
                ctaTitle: "Miral で Stable Diffusion 3.5 を無料でお試しください!",
                ctaDesc: "上記のアイデアを入力し、ネガティブ プロンプトと柔軟なサイズを備えた Stable Diffusion 3.5 AI 画像ジェネレーターを使用して、制御されたビジュアルを作成します。"
            },
            zImageTurbo: {
                title: "Z Image Turbo AI 画像ジェネレーター無料オンライン |ミラル",
                description: "Z Image Turbo を使用して、高品質の AI 画像をオンラインで作成します。 Miral でプロンプトを拡張し、柔軟なアスペクト比を選択し、カスタム寸法を設定し、シードを制御します。",
                heroHeadline: "Z Image Turbo AI 画像生成装置",
                heroIntro: "Z Image Turbo AI 画像ジェネレーターを Miral AI で無料で使用します。サインアップして無料のクレジットを受け取り、即時拡張、柔軟なアスペクト比、シード コントロールを備えた高品質の画像をすばやく作成します。",
                eyebrow: "Zイメージターボ",
                sectionKicker: "Zイメージターボ",
                ctaTag: "ゼットイメージターボ・ミラル",
                badges: ["テキストから画像へ", "即時延長", "柔軟なアスペクト比", "カスタムサイズ", "種子管理"],
                previewLabel: "Zイメージターボ",
                previewMeta: ["1:1", "512 – 2048", "種子管理"],
                previewTitle: "短いプロンプトから洗練された高解像度のビジュアルまで",
                previewDesc: "プロンプト拡張によって簡単なアイデアを充実させ、適切なアスペクト比を選択し、シードを再利用して画像間で一貫したスタイルを維持します。",
                keyFeaturesTitle: "Z Image Turbo Text to Image Generator で洗練されたビジュアルを作成",
                keyFeaturesIntro: "即時拡張、柔軟なアスペクト比、カスタム サイズ、シードベースの一貫性を実現する、Z Image Turbo AI 画像ジェネレーターの主要な機能を調べてください。",
                exploreTitle: "AI 画像モデルをさらに探索する",
                mainFeaturesTitle: "Z Image Turbo の主な機能",
                generatedImageLabel: "生成された画像",
                versionLabel: "制御",
                featureLabel: "何が変わるのか",
                useCaseLabel: "最適な用途",
                variantsTitle: "Z イメージ ターボ作成コントロール",
                variantsIntro: "プロジェクトに必要な詳細と視覚的な一貫性の程度に応じて、プロンプト拡張、柔軟なディメンション、シード コントロールを組み合わせます。",
                variants: [
                    { name: "Zイメージターボ", desc: "詳細な高解像度出力によるテキストから画像への高速生成。", bestFor: "製品ビジュアル、ポートレート、コンセプトアート、マーケティング画像。" },
                    { name: "即時延長", desc: "視覚的な詳細を追加して短いプロンプトを自動的に充実させます。", bestFor: "素早いアイデアをより完全な生成手順に変換します。" },
                    { name: "種子管理", desc: "他の設定を調整するときに、同じ開始シードを再利用します。", bestFor: "画像のバリエーションやキャンペーン全体で統一されたスタイルを維持します。" }
                ],
                controlsTitle: "適切なプロンプト、サイズ、シード設定を選択する",
                controlsIntro: "アイデアに詳細が必要な場合はプロンプト拡張を有効にし、意図した出力ディメンションを選択し、視覚的な一貫性が重要な場合はシードを再利用します。",
                galleryTitle: "Z イメージ ターボ イメージのその他の例",
                discussionTitle: "Z Image Turbo に関するよくある質問",
                communityTitle: "Z Image Turbo を使用した一般的な作成方法",
                tutorialPrompt: "明るい建築スタジオに展示されたコンパクトな電動スクーター、淡いコンクリートの床、柔らかな天窓、洗練された製品写真、バランスの取れた構図、リアルな素材。",
                qualityBenefits: [
                    "視覚的な詳細をすべて手動で書き直すことなく、短いアイデアをより充実したプロンプトに拡張できます。",
                    "最終チャンネルの横長、縦長、正方形、または正確なカスタム寸法を選択します。",
                    "シードを再利用して、反復間で照明、パレット、構成の一貫性を保ちます。"
                ],
                features: [
                    { name: "即時延長", short: "必要に応じて、短いプロンプトをより詳細な内容に拡張します。", desc: "プロンプト拡張機能をオンにすると、Z Image Turbo は、生成前に短いプロンプトに追加の詳細情報を自動的に追加します。これにより、短いプロンプトまたは単純なプロンプトで、手動で書き直すことなく、より完全で鮮明な画像を生成することができます。", demo: { type: 'table', rows: [
                        { prompt: "火星の表面にある熱帯植物で満たされたガラスの温室。", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "ヴィンテージの車両内に建てられた小さな職人のパン屋。", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "柔軟なアスペクト比", short: "横向き、縦向き、正方形、またはカスタム サイズを選択します。", desc: "1024×1024、1280×1280、864×1536、1536×864、720×1280、1280×720、1024×1536、1536×1536などの既製のアスペクト比から選択するか、512×512から512×512までのカスタム サイズを入力します。 2048×2048。これにより、Z Image Turbo テキスト画像ジェネレーターは、バナー、ポスター、ソーシャル投稿、正方形のサムネイルなどに適したものになります。", prompt: "雨の中の東京の夜市、光る提灯、混雑した屋台、反射する街路、映画のような雰囲気の超広角上空からの眺め、1536×864。", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "カスタム画像サイズ", short: "正確な出力のために正確なピクセル寸法を設定します。", desc: "プリセットが適合しない場合は、カスタム サイズに切り替えて、512 から 2048 までの任意の幅と高さを入力します。これにより、手動でトリミングせずに、特定のレイアウト、バナー スロット、または印刷アスペクトに一致させることができます。", prompt: "縦型の植物展示ポスター、特大のオレンジ色のタイポグラフィ、珍しい熱帯の葉、温かみのあるオフホワイトの紙のテクスチャ、正確な編集グリッド、1152×1728。", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "一貫性のためのシード制御", short: "シードを再利用して、画像全体で安定したスタイルを維持します。", desc: "固定シード (0 ～ 2147483647) を設定すると、Z Image Turbo AI イメージ ジェネレーターは実行全体で同じ開始点に依存するため、プロンプトを調整する際に一貫した外観を維持することが容易になります。毎回新鮮なランダムな結果を得るには、シードを 0 のままにしておきます。", prompt: "淡い緑色の石の上に 3 つの曇りガラスのボトル、柔らかな拡散光、ユーカリのアクセントをフィーチャーした、コーディネートされたスキンケア キャンペーンです。製品シリーズ全体で照明、パレット、構成を維持するために同じシードを再利用しています。", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "洗練されたディテールとリアルさ", short: "信頼できる照明、マテリアル、奥行きをレンダリングします。", desc: "Z Image Turbo は、細かいテクスチャ、リアルな照明、自然な奥行きを生成し、信憑性が重要な製品写真、ポートレート、コンセプト アート、エディトリアル ビジュアルにしっかりと適合します。", prompt: "静かな工房でカエデの橋を彫るバイオリン職人のクローズアップのドキュメンタリー、細かい木の削りくず、使い古された手工具、自然な肌の質感、柔らかな北窓の光、浅い被写界深度。", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "プロンプトの例",
                showcaseTitle: "より良い AI 画像のための Z Image Turbo プロンプトの例",
                showcaseIntro: "これらの Z Image Turbo プロンプトの例を出発点として使用してください。主題、構成、照明、スタイルを明確に説明し、オプションでプロンプト拡張を有効にして、ジェネレーターに直接送信します。",
                useCasesKicker: "実際の仕事向けに作られています",
                useCasesTitle: "Z Image Turbo の一般的な使用例",
                useCases: [
                    { name: "商品撮影用 Z Image Turbo", desc: "制御された背景と固定シードを使用して、一貫した外観を実現するきれいな製品ショットを作成します。" },
                    { name: "マーケティング向け Z Image Turbo", desc: "キャンペーンのコンセプト、ソーシャル広告、バナーを複数のアスペクト比で生成します。" },
                    { name: "ポスターとレイアウト用の Z Image Turbo", desc: "ポスターの背景とレイアウトに対応したビジュアルをカスタム ピクセル サイズで作成します。" },
                    { name: "Z Image Turbo for ポートレート", desc: "自然な肌の質感と信頼できる照明を使用して、詳細なポートレートを生成します。" },
                    { name: "コンセプトアート用のZ Image Turbo", desc: "階層化されたプロンプトを使用して、キャラクター、環境、視覚的な指示を探索します。" },
                    { name: "ソーシャル コンテンツ向け Z Image Turbo", desc: "さまざまなソーシャル プラットフォームに合わせてサイズを調整した正方形、縦長、横長の画像を作成します。" }
                ],
                howToKicker: "3 つの簡単なステップ",
                howToTitle: "Z Image Turbo AI 画像ジェネレーターをオンラインで使用する方法",
                howToIntro: "明確なプロンプト、オプションのプロンプト拡張子、プロジェクトに必要なアスペクト比を備えた Z Image Turbo AI 画像ジェネレーターを Miral でオンラインで使用します。",
                howToSteps: [
                    { title: "メインプロンプトを入力してください", desc: "希望する主題、シーン、構成、照明、スタイル、および視覚的な詳細について説明します。" },
                    { title: "生成制御の構成", desc: "オプションでプロンプト拡張を有効にし、既製のアスペクト比を選択するかカスタム サイズを入力し、一貫性が必要な場合はシードを設定します。" },
                    { title: "生成とレビュー", desc: "生成を開始し、結果を確認し、イメージをダウンロードするか、別のパスのプロンプトを調整します。" }
                ],
                howToCta: "Z Image Turbo AI 画像ジェネレーターを試す",
                faqTitle: "Z Image Turbo に関するよくある質問",
                faqs: [
                    { q: "AI画像生成装置Z Image Turboとは何ですか？", a: "Z Image Turbo は、高解像度画像生成のためのテキストから画像へのモデルです。 Z Image Turbo AI 画像ジェネレーターは、書かれたプロンプトを詳細な画像に変換し、Miral でアート、デザイン、マーケティング、製品のビジュアル作成にブラウザーで直接利用できます。" },
                    { q: "一貫した一連の製品画像を作成するにはどのツールを使用できますか?", a: "Z Image Turbo は、即時拡張、柔軟な画像サイズ、シード コントロールを組み合わせて、一貫した一連の製品写真やマーケティング ビジュアルの作成を支援します。" },
                    { q: "Z Image Turbo AI画像生成ソフトは無料で利用できますか？", a: "はい。サインアップして無料クレジットを受け取り、Z Image Turbo AI 画像ジェネレーターを使用して高品質の画像の作成をすぐに開始してください。画像の生成には、対応するクレジットが使用されます。" },
                    { q: "Z Image Turbo AI 画像ジェネレーターをオンラインで使用するにはどうすればよいですか?", a: "詳細なテキスト プロンプトを入力し、必要に応じてプロンプト拡張機能をオンにし、既製のアスペクト比を選択するかカスタム サイズを入力し、一貫した外観が必要な場合はシードを設定して、[生成] をクリックします。 Z Image Turbo は、マーケティング資料、製品写真、ポートレート、ポスターのレイアウトに適しています。" },
                    { q: "Z Image Turbo のプロンプト拡張機能とは何ですか?", a: "プロンプト拡張機能は、Z Image Turbo が生成前に短いプロンプトまたは単純なプロンプトを追加の詳細で自動的に強化できるようにするオプションのスイッチです。これにより、専門家以外のプロンプトが手動で書き直すことなく、より完全で鮮明な画像を生成できるようになります。" },
                    { q: "Z Image Turbo で一貫性のない結果を修正するにはどうすればよいですか?", a: "他のパラメータを調整しながら同じシードを再利用して、画像間で一貫したスタイルを維持できるようにします。毎回新鮮でランダムな結果が必要な場合にのみ、シードを 0 のままにしておきます。" },
                    { q: "Z Image Turbo はどのサイズとアスペクト比をサポートしますか?", a: "Miral では、Z Image Turbo は 1024×1024、1280×1280、864×1536、1536×864、720×1280、1280×720、1024×1536、1536×1536 などの既製の比率に加えて、512×512 から最大 512×512 までのカスタム サイズを提供します。 2048×2048。これは、バナー、ポスター、ソーシャル投稿、サムネイルの横長、縦長、正方形の出力をカバーします。" },
                    { q: "Z Image Turbo プロンプトの最良の例は何ですか?", a: "効果的な Z Image Turbo プロンプトは、主題、設定、構成、照明、スタイルを明確に説明します。短いアイデアの場合は、プロンプト拡張を有効にして、モデルがプロンプトを自動的に強化できるようにします。このページの Z Image Turbo プロンプトの例を開始点として使用し、プロジェクトに合わせてカスタマイズします。" }
                ],
                ctaTitle: "Miral で Z Image Turbo を無料でお試しください!",
                ctaDesc: "上記のアイデアを入力し、プロンプト拡張、柔軟なサイズ、シード コントロールを備えた Z Image Turbo AI 画像ジェネレーターを使用して、洗練されたビジュアルを作成します。"
            },
            midjourney: {
                title: "Midjourney AI 画像ジェネレーター無料オンライン |ミラル",
                description: "Miral AI の Midjourney を使用して、オンラインで AI アートを作成します。リアルなスタイルまたはアニメ スタイルを選択し、参照画像を使用して結果をガイドし、テキスト プロンプトを鮮やかなビジュアルに変えます。",
                heroHeadline: "ミッドジャーニー AI 画像ジェネレーター",
                heroIntro: "Miral AI では、Midjourney AI 画像ジェネレーターを無料で使用できます。サインアップして無料クレジットを受け取り、リアルまたはアニメ スタイルとオプションの参照画像ガイダンスを使用して高品質の画像を即座に作成します。",
                eyebrow: "旅の途中",
                sectionKicker: "旅の途中",
                ctaTag: "ミッドジャーニー・ミラル",
                badges: ["テキストから画像へ", "リアル＆アニメスタイル", "参考画像のご案内", "芸術的方向性"],
                previewLabel: "旅の途中",
                previewMeta: ["現実的な", "アニメ", "参考文献は 5 件まで"],
                previewTitle: "鮮やかなプロンプトから映画のようなアートなイメージまで",
                previewDesc: "スタイルを選択し、雰囲気や照明を説明し、Midjourney にコンセプト、ポスター、キャラクターの芸術的な外観を形作ってもらいましょう。",
                keyFeaturesTitle: "Midjourney Text to Image Generator を使用してアート志向のビジュアルを作成する",
                keyFeaturesIntro: "スタイルの切り替え、参照画像のガイダンス、豊かな芸術的方向性など、Midjourney AI 画像生成の主要機能を探索してください。",
                features: [
                    { name: "リアルなスタイルとアニメのスタイル", short: "ワンタップでビジュアルスタイルを切り替えます。", desc: "Miral の Midjourney AI 画像ジェネレーターは、リアリスティックとアニメという 2 つの既製のスタイルを公開します。写真の詳細、自然光、本物のようなテクスチャを求める場合はリアリスティックを選択し、様式化された線、大胆な色、手描きの雰囲気を求める場合はアニメを選択します。スタイルはパネルで選択されるため、プロンプトはシーン自体に焦点を当てることができます。", demo: { type: 'table', rows: [
                        { prompt: "日の出時に霧のかかった山の尾根の端に立つ孤独な旅行者、立体的な光、映画のようなワイドショット、上質な生地と岩のディテール。", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "夕暮れの屋上に立つ決意の強い若い剣士、なびく髪、光るランタン、表情豊かなアニメの線画、鮮やかなセルシェーディング。", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "参考画像のご案内", short: "最大 5 枚の画像をアップロードして見た目を調整します。", desc: "最大 5 つの参照画像 (PNG、JPG、JPEG、または WebP) を使用して Midjourney AI 画像ジェネレーターをガイドします。これらを使用して、カラー パレット、キャラクターの外観、製品の形状、または全体的な美学を引き継ぎ、結果がテキストだけではなく参照方向に近くなるようにします。", prompt: "大理石の台座にマットブラックのセラミック花瓶、柔らかいスタジオライト、きれいな背景を載せたプレミアムな商品写真で、アップロードされた参考資料の雰囲気とパレットにマッチしています。", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "映画のような照明と雰囲気", short: "ドラマチックな光、雰囲気、奥行きを表現します。", desc: "ミッドジャーニーは、アートを取り入れた照明と雰囲気で知られています。ゴールデンアワー、ネオンの輝き、霧、リムライト、またはキャンドルライトを描写すると、モデルはポスター、キーアート、コンセプトビジュアルに適した映画のような外観に傾きます。", demo: { type: 'table', rows: [
                        { prompt: "雨に濡れた夜のネオン路地、反射する水たまり、遠くの標識からの柔らかなボケ、ムーディーな映画のような雰囲気、傘を差した一人の人物。", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "屋上にいるミュージシャンのゴールデンアワーのポートレート、暖かい逆光、レンズフレア、浅い被写界深度、フィルムグレイン。", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "キャラクターアートとコンセプトアート", short: "表現力豊かなキャラクターと世界を構築します。", desc: "Midjourney テキストから画像へのジェネレーターは、キャラクター デザイン、ファンタジー シーン、コンセプト アートに非常に適しています。キャラクターのポーズ、服装、表情、設定を説明し、スタイルを選択し、見た目が決まるまで繰り返します。", prompt: "重ね着の旅用マントを着た放浪の錬金術師、真鍮のランタンと輝く小瓶を持ち、古代の森の小道、まだらの光、複雑な衣装のディテール。", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "ポスターとエディトリアルアート", short: "印象的なレイアウトやキービジュアルを制作します。", desc: "キャンペーンのキーアートからエディトリアルイラストに至るまで、Midjourney は大胆な構図と洗練された美学を形作っています。焦点が明確な主題と説明された雰囲気を組み合わせて、モデルにマーケティングやエディトリアル用途にアート志向のビジュアルを提供させます。", prompt: "輝く南国の花の上を飛び回るハチドリの大胆なキャンペーン キー ビジュアル、彩度の高いジュエル トーン、クリーンなネガティブ スペース、ハイコントラストのスタジオ照明。", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "プロンプトの例",
                showcaseTitle: "より良い AI 画像のためのミッドジャーニー プロンプトの例",
                showcaseIntro: "これらの Midjourney プロンプトの例を出発点として使用してください。シーンの主題、雰囲気、照明、スタイルを説明し、パネルで「リアル」または「アニメ」を選択してジェネレーターに送信します。",
                useCasesKicker: "実際の仕事向けに作られています",
                useCasesTitle: "旅の途中で人気のあるユースケース",
                useCases: [
                    { name: "コンセプトアートの旅の途中", desc: "アートに基づいた照明と雰囲気を使用して、キャラクター、ファンタジーの世界、視覚的な方向性を構築します。" },
                    { name: "キーアートとポスターのミッドジャーニー", desc: "大胆なキャンペーンのキービジュアル、ポスター、エディトリアルイラストを洗練された外観で作成します。" },
                    { name: "製品およびブランドビジュアルのミッドジャーニー", desc: "一貫性を保つための参照画像に基づいて、プレミアム製品のコンセプトとブランド イメージを形成します。" },
                    { name: "ポートレートのミッドジャーニー", desc: "自然光、フィルムグレイン、または様式化されたアニメシェーディングを使用して、映画のようなポートレートを生成します。" },
                    { name: "アニメとイラストのミッドジャーニー", desc: "アニメ スタイルに切り替えると、表現力豊かな線画、大胆な色、手描きの文字が表示されます。" },
                    { name: "ソーシャル コンテンツの旅の途中", desc: "フィード、サムネイル、クリエイティブなソーシャル投稿用に、印象的で共有可能なビジュアルを作成します。" }
                ],
                howToKicker: "3 つの簡単なステップ",
                howToTitle: "Midjourney AI 画像ジェネレーターをオンラインで使用する方法",
                howToIntro: "Miral でオンラインで Midjourney AI 画像ジェネレーターを使用し、鮮やかなプロンプト、選択したスタイル、オプションの参照画像を使用します。",
                howToSteps: [
                    { title: "あなたのシーンを説明してください", desc: "主題、設定、雰囲気、照明、希望する芸術的な外観をカバーする鮮やかなプロンプトを作成します。" },
                    { title: "スタイルと参照の選択", desc: "パネルで [リアル] または [アニメ] を選択し、必要に応じて、外観のガイドとして最大 5 つの参照画像をアップロードします。" },
                    { title: "生成と洗練", desc: "生成を開始し、結果を確認し、イメージをダウンロードするか、別のパスのプロンプトと参照を調整します。" }
                ],
                howToCta: "Midjourney AI 画像ジェネレーターを試す",
                faqTitle: "ミッドジャーニーに関するよくある質問",
                faqs: [
                    { q: "Midjourney AI画像ジェネレーターとは何ですか?", a: "Midjourney は、アート志向の映画のようなビジュアルで知られる、広く使用されているテキストから画像へのモデルです。 Miral では、Midjourney AI 画像ジェネレーターが、書かれたプロンプトを、コンセプト アート、キー ビジュアル、ポスター、編集作業用の印象的な画像にブラウザーで直接変換します。" },
                    { q: "参照画像を使用して映画のようなコンセプト アートを作成するにはどのツールを使用できますか?", a: "Midjourney は、豊かな芸術的方向性、劇的な照明、リアリスティックおよびアニメ スタイル、映画のコンセプト アート、キー ビジュアル、ブランド イメージの参照画像ガイダンスを組み合わせています。" },
                    { q: "Midjourney AI 画像ジェネレーターは無料で使用できますか?", a: "はい。サインアップして無料クレジットを受け取り、Midjourney AI 画像ジェネレーターを使用して高品質の画像の作成をすぐに開始してください。画像の生成には、対応するクレジットが使用されます。" },
                    { q: "Midjourney AI 画像ジェネレーターをオンラインで使用するにはどうすればよいですか?", a: "主題、雰囲気、照明、スタイルを説明する鮮やかなテキスト プロンプトを入力し、パネルで [リアル] または [アニメ] を選択し、オプションで最大 5 つの参照画像をアップロードし、[生成] をクリックします。 Midjourney は、コンセプト アート、キー ビジュアル、ポスター、ポートレート、エディトリアル イラストなどに適しています。" },
                    { q: "リアルスタイルとアニメスタイルの違いは何ですか?", a: "リアルは写真のディテール、自然光、本物のようなテクスチャに傾向があり、アニメは様式化された線、大胆な色、手描きの外観が好まれます。パネルでスタイルを選択すると、プロンプトがシーン自体に焦点を当てることができます。" },
                    { q: "参照と一致しない Midjourney 画像を修正するにはどうすればよいですか?", a: "最大 5 つの明確な参照画像 (PNG、JPG、JPEG、または WebP) をアップロードし、結果が従うべきカラー パレット、キャラクターの外観、製品の形状、または全体的な美しさを説明します。" },
                    { q: "Midjourney プロンプトの最良の例は何ですか?", a: "効果的なミッドジャーニー プロンプトでは、主題、設定、雰囲気、照明、芸術的な外観を詳細に説明し、そのプロンプトをパネル上の適切なスタイルと組み合わせます。このページの Midjourney プロンプトの例を出発点として使用し、プロジェクトに合わせて調整してください。" },
                    { q: "Midjourney vs Stable Diffusion 3.5: どちらを使用すべきですか?", a: "普遍的な勝者ではなく、ワークフローに基づいて選択してください。 Midjourney は、Miral の既成のリアリスティック スタイルとアニメ スタイルを備えた、アート主導のコンセプト、映画のような照明、リファレンスガイド付きビジュアルに非常に適しています。 Stable Diffusion 3.5 は、明示的なネガティブ プロンプトとカスタム サイズの柔軟なアスペクト比を必要とするクリエイターに適しています。" }
                ],
                ctaTitle: "Miral で Midjourney を無料でお試しください!",
                ctaDesc: "上記のアイデアを入力し、リアルまたはアニメ スタイルと参照画像ガイダンスを備えた Midjourney AI 画像ジェネレーターを使用して、アート指向のビジュアルを作成します。"
            }
        }
  }
}
